/* tslint:disable */
/* eslint-disable */
/**
 * ECSF Platform API
 * ## Date and time conventions  - Timestamps are UTC in ISO-8601 format (e.g. `2026-08-23T22:00:00Z`). - Fields that represent a calendar day (e.g. `activationDate`, `consentEndDate`, `billingPeriodFrom`) are date-only values in `yyyy-MM-dd` format. They are **always** days in the **Europe/Vienna** timezone, never UTC days. Where such a day is stored as a timestamp, it is anchored at the Vienna start of day, e.g. `2026-08-24` becomes `2026-08-23T22:00:00Z` during CEST. - Time ranges are half-open `[from, to)` — `from` inclusive, `to` exclusive.  ## Table filters  Endpoints that return table rows take a `RowsRequestDto` whose `filters` are `{ \"id\": \"<property>\", \"value\": <value> }` objects. The shape of `value` depends on the property:  - Text: a string, matched case-insensitively as a substring. - Number / id: a number, or an array of numbers to match any of them. - Boolean: `true` or `false`. - Enum: an array of enum values to match any of them. - Number range: `[min, max]`, both inclusive; either may be `null`. - Date / time range: `[from, to]` as ISO-8601 timestamps, applied as the half-open range `[from, to)`; either may be `null` (open-ended). To filter whole Vienna days, send the Vienna start of the first day as `from` and the Vienna start of the day **after** the last day as `to`, e.g. `[\"2026-10-04T22:00:00Z\", \"2026-10-05T22:00:00Z\"]` for 2026-10-05. For calendar-day columns both bounds are converted to Vienna days before comparing.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AdditionalInvoiceProperty {
    'key': string | null;
    'value': string | null;
}
export interface AddressCreateRequestDto {
    'street': string | null;
    'zipCode': string | null;
    'city': string | null;
    'country': Country;
}


export interface AddressDto {
    'id': number;
    'street': string | null;
    'zipCode': string | null;
    'city': string | null;
    'country': Country;
}



export const AggregationResolution = {
    QuarterHour: 'QUARTER_HOUR',
    Day: 'DAY',
    Month: 'MONTH',
} as const;

export type AggregationResolution = typeof AggregationResolution[keyof typeof AggregationResolution];


export interface AmountBreakdownDto {
    'netAmountEUR'?: number;
    'vatRate'?: number;
    'grossAmountEUR'?: number;
    'vatAmountEUR'?: number;
}

export const BankStatementMatchStatus = {
    Unmatched: 'UNMATCHED',
    Matched: 'MATCHED',
    AmountMismatch: 'AMOUNT_MISMATCH',
    MultipleCandidates: 'MULTIPLE_CANDIDATES',
    RTransaction: 'R_TRANSACTION',
} as const;

export type BankStatementMatchStatus = typeof BankStatementMatchStatus[keyof typeof BankStatementMatchStatus];


export interface BankTxDetailDto {
    'id': number;
    'endToEndId': string | null;
    'mandateId': string | null;
    'amountEUR': number;
    'chargesEUR': number | null;
    'debtorName': string | null;
    'debtorIBAN': string | null;
    'debtorBIC': string | null;
    'creditorName': string | null;
    'creditorIBAN': string | null;
    'creditorBIC': string | null;
    'remittanceUnstructured': string | null;
    'remittanceStructured': string | null;
    'returnReasonCode': string | null;
    'returnReasonText': string | null;
    'invoiceId': number | null;
    'matchStatus': BankStatementMatchStatus;
    'bookingDate': string;
}


export interface BankTxDetailDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<BankTxDetailDtoTableFilterDto> | null;
}
export interface BankTxDetailDtoRowsResponseDto {
    'rows': Array<BankTxDetailDto> | null;
    'rowCount': number;
}
export interface BankTxDetailDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}

export const BannerSeverity = {
    Info: 'INFO',
    Warning: 'WARNING',
    Critical: 'CRITICAL',
} as const;

export type BannerSeverity = typeof BannerSeverity[keyof typeof BannerSeverity];


export interface BillingBatchDto {
    'id': number;
    'name': string | null;
    'energyCommunityId': number;
    'energyCommunityName': string | null;
    'billingPeriodFrom': string;
    'billingPeriodTo': string;
    'createdByUserId': number;
    'createdByUserName': string | null;
    'createdAt': string;
    'ecTotalConsumptionKwh': number;
    'ecTotalProductionKwh': number;
    'totalsByInvoiceType': BillingBatchDtoTotalsByInvoiceType | null;
    'sepaDebitTotalEUR': number;
    'sepaCreditTotalEUR': number;
    'sepaDebitUploadedAt'?: string | null;
    'sepaCreditUploadedAt'?: string | null;
}
export interface BillingBatchDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<BillingBatchDtoTableFilterDto> | null;
}
export interface BillingBatchDtoRowsResponseDto {
    'rows': Array<BillingBatchDto> | null;
    'rowCount': number;
}
export interface BillingBatchDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface BillingBatchDtoTotalsByInvoiceType {
    'STANDARD'?: InvoiceTypeTotalsDto;
    'INVOICE'?: InvoiceTypeTotalsDto;
    'CLEARING_PAYMENT'?: InvoiceTypeTotalsDto;
}
export interface ConversationDto {
    'id': number;
    'conversationType': ConversationType;
    'startTime': string;
    'endTime': string | null;
    'conversationId': string | null;
}


export interface ConversationDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<ConversationDtoTableFilterDto> | null;
}
export interface ConversationDtoRowsResponseDto {
    'rows': Array<ConversationDto> | null;
    'rowCount': number;
}
export interface ConversationDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface ConversationMessagesResponseDto {
    'messages': Array<MessageDto> | null;
    'totalCount': number;
    'hasMore': boolean;
    'conversationId': string | null;
}

export const ConversationType = {
    CmRevSp0102: 'CM_REV_SP__01_02',
    EcReqOnl0200: 'EC_REQ_ONL__02_00',
    EcReqOff0200: 'EC_REQ_OFF__02_00',
    CrReqPt0300: 'CR_REQ_PT__03_00',
    EcPrtfactChange0101: 'EC_PRTFACT_CHANGE__01_01',
    CmRevSp0110: 'CM_REV_SP__01_10',
    EcReqOnl0210: 'EC_REQ_ONL__02_10',
    EcReqOff0210: 'EC_REQ_OFF__02_10',
    EcPodlist0200: 'EC_PODLIST__02_00',
    EcReqOnl0220: 'EC_REQ_ONL__02_20',
    EcReqOff0211: 'EC_REQ_OFF__02_11',
    CmRevSp0130: 'CM_REV_SP__01_30',
    EcReqOnl0230: 'EC_REQ_ONL__02_30',
    EcReqOff0220: 'EC_REQ_OFF__02_20',
    EcReqOnl0300: 'EC_REQ_ONL__03_00',
    EcReqOff0300: 'EC_REQ_OFF__03_00',
    EcPrtfactChange0110: 'EC_PRTFACT_CHANGE__01_10',
    EcPodlist0210: 'EC_PODLIST__02_10',
    CrReqPt0430: 'CR_REQ_PT__04_30',
    CmRevSp0140: 'CM_REV_SP__01_40',
    Incoming: 'INCOMING',
} as const;

export type ConversationType = typeof ConversationType[keyof typeof ConversationType];



export const Country = {
    Austria: 'AUSTRIA',
    Germany: 'GERMANY',
    Unknown: 'UNKNOWN',
} as const;

export type Country = typeof Country[keyof typeof Country];


export interface CreateInvoiceRequestDto {
    'ecId': number;
    'mcId': number;
    'invoiceName': string | null;
}
export interface CreateInvoicesRequestDto {
    'energyCommunityId': number;
    /**
     * First day of the billing period. Must be the first day of a month.
     */
    'billingPeriodFrom': string;
    /**
     * Exclusive end of the billing period. Must be the first day of a month, after  `billingPeriodFrom`, and no later than the first day of the current month — periods  that are still running cannot be invoiced. The period must also not overlap an existing  invoice of any listed membership.
     */
    'billingPeriodTo': string;
    'batchName': string | null;
    'invoices': Set<CreateInvoiceRequestDto> | null;
}
export interface CreateOnboardingNoteDto {
    'meteringPointContractId': number;
    'noteText': string | null;
}
export interface CurrentUserMCDto {
    'id': number;
    'customerId': string | null;
    'memberType': MemberType;
    'activationDate': string;
    'deactivationDate': string | null;
    'ownerName': string | null;
    'ownerAddress': AddressDto;
    'energyCommunityEntityId': number;
    'energyCommunityCode': string | null;
    'energyCommunityContactName': string | null;
    'energyCommunityAddress': AddressDto;
    'paymentInfoAccountHolder': string | null;
    'paymentInfoIBAN': string | null;
    'documentName': string | null;
    'documentFileId': string | null;
    'documentUploadDate': string | null;
    'meteringPointContractCount': number;
}


export interface CurrentUserMeteringPointContractDto {
    'id': number;
    'energyCommunityId': number;
    'energyCommunityName': string | null;
    'energyCommunityCode': string | null;
    'mpInfoId': number;
    'meteringPointIdentifier': string | null;
    'meteringPointName': string | null;
    'meteringPointEnergyDirection': EnergyDirection;
    'ownerName': string | null;
    'participationFactor': number;
    'activationDate': string | null;
    'deactivationDate': string | null;
    'activeOverrule'?: boolean;
}


export interface DeleteDocumentsDto {
    'documentIds': Array<number> | null;
}
export interface DeregisterRequestDto {
    'meteringPointContractId': number;
    /**
     * Consent end date, inclusive — the contract is deactivated at the end of this day.  Must not be in the past and at most 42 calendar days (6 weeks) ahead; that is the  platform\'s approximation of the EBUtilities rule \"at most 30 working days\".
     */
    'consentEndDate': string;
    'consentId': string | null;
}
export interface DocumentDto {
    'id': number;
    'name': string | null;
    'documentId': string;
    'sizeInBytes': number;
    'ownerId': number | null;
    'ownerUserId': number | null;
    'ownerEmail': string | null;
    'ownerName': string | null;
    'isDeletable': boolean;
    'type': DocumentType;
    'fileType': FileType;
    'createdAt': string;
}


export interface DocumentDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<DocumentDtoTableFilterDto> | null;
}
export interface DocumentDtoRowsResponseDto {
    'rows': Array<DocumentDto> | null;
    'rowCount': number;
}
export interface DocumentDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}

export const DocumentType = {
    EnergyDataExportContract: 'ENERGY_DATA_EXPORT_CONTRACT',
    EnergyDataExportEnergyCommunity: 'ENERGY_DATA_EXPORT_ENERGY_COMMUNITY',
    EnergyDataExportEnergyCommunityDetailed: 'ENERGY_DATA_EXPORT_ENERGY_COMMUNITY_DETAILED',
    Invoice: 'INVOICE',
    MemberContract: 'MEMBER_CONTRACT',
    SepaMandate: 'SEPA_MANDATE',
} as const;

export type DocumentType = typeof DocumentType[keyof typeof DocumentType];


export interface ECBillingDto {
    'energyCommunityName': string | null;
    'energyCommunityCode': string | null;
    'invoiceTextType': InvoiceType;
    'from': string;
    'to': string;
    'lastBillingDate'?: string | null;
    'grandConsumption': AmountBreakdownDto;
    'grandConsumptionKwh': number;
    'grandProductionNet': number;
    'grandProductionGross': number;
    'grandProductionKwh': number;
    'grandBilling': AmountBreakdownDto;
    'totalCorrection': number;
    'invoiceNumberPrefix'?: string | null;
    'invoiceNumberMinDigits': number;
    'invoiceNumberLastSequence': number;
    'currentYearMaxInvoiceSequence'?: number | null;
}


export interface ECCreateRequestDto {
    'energyCommunityId': string | null;
    /**
     * Market participation ID: two letters followed by six digits, e.g. \"AT123456\".
     */
    'marketParticipationId': string | null;
    'state': EnergyCommunityState;
    'activationDate': string;
    'contactName': string | null;
    'contactEmail': string | null;
    'ecType': ECType;
    'participationModel': Participation;
    'zvrNumber': number;
    'vatId': string | null;
    'address': AddressCreateRequestDto;
    'showAggregatedData'?: boolean;
    'invoiceTextType': InvoiceType;
    'paymentInfoId': number | null;
    /**
     * Optional prefix for generated invoice numbers, at most 40 characters.
     */
    'invoiceNumberPrefix'?: string | null;
    /**
     * Zero-padding width of the invoice number sequence. Must be between 1 and 10.
     */
    'invoiceNumberMinDigits'?: number;
    'invoiceNumberLastSequence'?: number;
}


export interface ECDto {
    'id': number;
    'energyCommunityId': string | null;
    'marketParticipationId': string | null;
    'showAggregatedData': boolean;
    'contactName': string | null;
    'contactEmail': string | null;
}
export interface ECMPInfoRequestDto {
    'energyCommunityId': number;
    'from': string;
    'to': string;
}

export const ECType = {
    Gea: 'GEA',
    EegLokal: 'EEG_LOKAL',
    EegRegional: 'EEG_REGIONAL',
    Beg: 'BEG',
    P2P: 'P2P',
    Eva: 'EVA',
} as const;

export type ECType = typeof ECType[keyof typeof ECType];


export interface EnergyCommunityAggregatedDataAdminDto {
    'bucket': string;
    'energyCommunityId': number;
    'energyCommunityName': string | null;
    'totalConsumption': number;
    'totalProduction': number;
    'ecConsumption': number;
    'gridConsumption': number;
    'ecProduction': number;
    'gridProduction': number;
    'hasL3EcConsumption': boolean;
    'hasL3GridConsumption': boolean;
    'hasL3EcProduction': boolean;
    'hasL3GridProduction': boolean;
}
export interface EnergyCommunityAggregatedDataDto {
    'bucket': string;
    'energyCommunityId': number;
    'totalConsumption': number;
    'totalProduction': number;
    'ecConsumption': number;
    'gridConsumption': number;
    'ecProduction': number;
    'gridProduction': number;
    'hasL3EcConsumption': boolean;
    'hasL3GridConsumption': boolean;
    'hasL3EcProduction': boolean;
    'hasL3GridProduction': boolean;
}
export interface EnergyCommunityDto {
    'id': number;
    'energyCommunityId': string | null;
    'marketParticipationId': string | null;
    'state': EnergyCommunityState;
    'activationDate': string;
    'deactivationDate': string | null;
    'contactName': string | null;
    'contactEmail': string | null;
    'ecType': ECType;
    'participationModel': Participation;
    'zvrNumber': number;
    'vatId': string | null;
    'paymentInfo': PaymentInfoDto;
    'address': AddressDto;
    'showAggregatedData': boolean;
    'invoiceTextType': InvoiceType;
    'invoiceNumberPrefix': string | null;
    'invoiceNumberMinDigits': number;
    'invoiceNumberLastSequence': number;
}


export interface EnergyCommunityDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<EnergyCommunityDtoTableFilterDto> | null;
}
export interface EnergyCommunityDtoRowsResponseDto {
    'rows': Array<EnergyCommunityDto> | null;
    'rowCount': number;
}
export interface EnergyCommunityDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}

export const EnergyCommunityState = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
} as const;

export type EnergyCommunityState = typeof EnergyCommunityState[keyof typeof EnergyCommunityState];


export interface EnergyDataAggregateDto {
    'meteringPointContractId': number;
    'from': string;
    'to': string;
    'isProduced': boolean;
    'consumptionTotalQuality': EnergyDataQualityLevel;
    'consumptionTotalQuantity': number;
    'consumptionEgAllocationQuality': EnergyDataQualityLevel;
    'consumptionEgAllocationQuantity': number;
    'consumptionEgMaxAllocationQuality': EnergyDataQualityLevel;
    'consumptionEgMaxAllocationQuantity': number;
    'consumptionEgEffectiveQuality': EnergyDataQualityLevel;
    'consumptionEgEffectiveQuantity': number;
    'consumptionEgEffRenewableQuality': EnergyDataQualityLevel;
    'consumptionEgEffRenewableQuantity': number;
    'productionTotalQuality': EnergyDataQualityLevel;
    'productionTotalQuantity': number;
    'productionEgAllocationQuality': EnergyDataQualityLevel;
    'productionEgAllocationQuantity': number;
    'productionEgConsumedQuality': EnergyDataQualityLevel;
    'productionEgConsumedQuantity': number;
    'productionUsedElsewhereQuality': EnergyDataQualityLevel;
    'productionUsedElsewhereQuantity': number;
}


export interface EnergyDataCostDto {
    'date': string;
    'kWhAmount': number;
    'priceEUR': number;
    'leastQualityLevel': EnergyDataQualityLevel;
    'invoiceID': number | null;
}


export interface EnergyDataCostInfo {
    'original'?: EnergyDataCostDto;
    'corrected'?: EnergyDataCostDto;
    'isCorrection'?: boolean;
    'date'?: string;
    'kWhAmount'?: number;
    /**
     * Cost invariant of energy direction. The costs which are not yet invoiced.      If the value is negative, the original price was too high      If the value is positive, the original price was too low
     */
    'costToBePaidEUR'?: number;
    /**
     * Cost invariant of energy direction. The absolute cost amount including all corrections.  The amount which should have been invoiced initially.      If the value is negative, the energy direction is production.      If the value is positive, the energy direction is consumption.
     */
    'correctedCostEUR'?: number;
    'lowestDataQuality'?: EnergyDataQualityLevel;
    'correctionQualityMarker'?: boolean;
}


export interface EnergyDataExportStatusDto {
    'id': number;
    'exportType': EnergyDataExportType;
    'meteringPointContractId'?: number | null;
    'energyCommunityId'?: number | null;
    'fromDate': string;
    'toDate': string;
    'createdAt': string;
}



export const EnergyDataExportType = {
    Contract: 'CONTRACT',
    EnergyCommunity: 'ENERGY_COMMUNITY',
    EnergyCommunityDetailed: 'ENERGY_COMMUNITY_DETAILED',
} as const;

export type EnergyDataExportType = typeof EnergyDataExportType[keyof typeof EnergyDataExportType];



export const EnergyDataQualityLevel = {
    L1: 'L1',
    L2: 'L2',
    L3: 'L3',
    Empty: 'EMPTY',
} as const;

export type EnergyDataQualityLevel = typeof EnergyDataQualityLevel[keyof typeof EnergyDataQualityLevel];


export interface EnergyDataRequestStepDto {
    'status': EnergyDataRequestStepStatus;
    'created': string;
    'errorCode'?: string | null;
}



export const EnergyDataRequestStepStatus = {
    Created: 'CREATED',
    FailedInAppLogic: 'FAILED_IN_APP_LOGIC',
    DataRequested: 'DATA_REQUESTED',
    FailedInMessenger: 'FAILED_IN_MESSENGER',
    RequestDeclined: 'REQUEST_DECLINED',
    RequestTimeout: 'REQUEST_TIMEOUT',
    RequestResponded: 'REQUEST_RESPONDED',
    ResponseFullfilledRequest: 'RESPONSE_FULLFILLED_REQUEST',
    ResponsePartiallyFullfilledRequest: 'RESPONSE_PARTIALLY_FULLFILLED_REQUEST',
    ResponseLacking: 'RESPONSE_LACKING',
    ReRequestSend: 'RE_REQUEST_SEND',
    EmailPartner: 'EMAIL_PARTNER',
    Done: 'DONE',
    FullfilledDuringTimeout: 'FULLFILLED_DURING_TIMEOUT',
} as const;

export type EnergyDataRequestStepStatus = typeof EnergyDataRequestStepStatus[keyof typeof EnergyDataRequestStepStatus];


export interface EnergyDataRequestTargetEnergyCommunitiesDto {
    'from': string;
    'to': string;
    'requestQuality': EnergyDataQualityLevel;
    'energyCommunityIds': Array<number> | null;
}


export interface EnergyDataRequestTargetMeteringPointContractsDto {
    'from': string;
    'to': string;
    'requestQuality': EnergyDataQualityLevel;
    'meteringPointContractIds': Array<number> | null;
}


export interface EnergyDataSingleRequestDto {
    'id': number;
    'from': string;
    'to': string;
    'existingQuality': EnergyDataQualityLevel;
    'requestedQuality': EnergyDataQualityLevel;
    'requestCount': number;
    'requestSteps': Array<EnergyDataRequestStepDto> | null;
}


export interface EnergyDataStateDto {
    'from': string;
    'to': string;
    'quality': EnergyDataQualityLevel;
    'quantity': number;
    'dataRequestInProgress': boolean;
}



export const EnergyDirection = {
    Incoming: 'INCOMING',
    Outgoing: 'OUTGOING',
} as const;

export type EnergyDirection = typeof EnergyDirection[keyof typeof EnergyDirection];



export const FileType = {
    Excel: 'EXCEL',
    Pdf: 'PDF',
    Xml: 'XML',
    Zip: 'ZIP',
    Csv: 'CSV',
} as const;

export type FileType = typeof FileType[keyof typeof FileType];


export interface FlatTariffComponentDto {
    'componentId': number;
    'componentValueId': number;
    'componentName': string | null;
    'timedValues': Array<TariffComponentTimedValueDto> | null;
    'componentValueFrom': string;
    'componentValueTo': string;
    'assignmentFrom': string;
    'assignmentTo': string;
    'applicability': TariffApplicability;
    'unitType': TariffUnitType;
    'from'?: string;
    'to'?: string;
}


export interface ForgotPasswordRequest {
    'email': string;
}

export const GridConnectionLevel = {
    Ne7: 'NE7',
    Ne6: 'NE6',
    Ne5: 'NE5',
    Ne4: 'NE4',
} as const;

export type GridConnectionLevel = typeof GridConnectionLevel[keyof typeof GridConnectionLevel];


export interface GridOperatorCreateRequestDto {
    'opId': string | null;
    'name': string | null;
    'contactEmail': string | null;
    'contactPageURL': string | null;
    'datasharingInstructionsURL': string | null;
    'forceEmailToAdmin': boolean;
}
export interface GridOperatorDto {
    'id': number;
    'opId': string | null;
    'name': string | null;
    'contactEmail': string | null;
    'contactPageURL': string | null;
    'datasharingInstructionsURL': string | null;
    'forceEmailToAdmin': boolean;
}
export interface GridOperatorDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<GridOperatorDtoTableFilterDto> | null;
}
export interface GridOperatorDtoRowsResponseDto {
    'rows': Array<GridOperatorDto> | null;
    'rowCount': number;
}
export interface GridOperatorDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface GridSubstationDto {
    'id': number;
    'ssId': string | null;
}
export interface GridTransformerDto {
    'id': number;
    'tfId': string | null;
}
export interface Int32TableChangesDto {
    'id': number;
    'propertyName': string | null;
    'value': Int32TableChangesDtoValue | null;
}
/**
 * @type Int32TableChangesDtoValue
 */
export type Int32TableChangesDtoValue = Array<any> | boolean | number | object | string;

export interface IntraDayPriceDto {
    'validFrom': string;
    'validTo': string;
    'pricePerkWh': number;
}
export interface InvoiceControllingEntryDto {
    'year'?: number;
    'month'?: number;
    'invoiceId'?: number | null;
    'invoiceNumber'?: string | null;
    'totalAmountEUR'?: number | null;
    'paidAmountEUR'?: number | null;
    'containsL3Data'?: boolean;
    'invoiceIsPaid'?: boolean | null;
}
export interface InvoiceControllingRowDto {
    'id'?: number;
    'customerId'?: string | null;
    'displayName'?: string | null;
    'ecId'?: number;
    'ecCode'?: string | null;
    'ecName'?: string | null;
    'entries'?: Array<InvoiceControllingEntryDto> | null;
}
export interface InvoiceDto {
    'id': number;
    'invoiceNumber': string | null;
    'invoiceName': string | null;
    'year'?: number;
    'billingPeriodFrom': string;
    'billingPeriodTo': string;
    'createdAt': string;
    'memberContractId': number;
    'membershipDisplayName': string | null;
    'billingBatchName': string | null;
    'documentId': number | null;
    'containsL3Data': boolean;
    'totalAmountEUR': number;
    'paidAmountEUR': number;
    'isPaid': boolean;
    'isOverpaid': boolean;
    'isPartiallyPaid': boolean;
    'invoiceTextType': InvoiceType;
}


export interface InvoiceDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<InvoiceDtoTableFilterDto> | null;
}
export interface InvoiceDtoRowsResponseDto {
    'rows': Array<InvoiceDto> | null;
    'rowCount': number;
}
export interface InvoiceDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface InvoiceNumberConfigDto {
    'invoiceNumberPrefix': string | null;
    'invoiceNumberMinDigits': number;
    'invoiceNumberLastSequence': number;
    'currentYearMaxInvoiceSequence': number | null;
}

export const InvoiceType = {
    Standard: 'STANDARD',
    Invoice: 'INVOICE',
    ClearingPayment: 'CLEARING_PAYMENT',
} as const;

export type InvoiceType = typeof InvoiceType[keyof typeof InvoiceType];


export interface InvoiceTypeTotalsDto {
    'consumption': AmountBreakdownDto;
    'production': AmountBreakdownDto;
    'productionLandwirt': AmountBreakdownDto;
    'monthlyCost': AmountBreakdownDto;
}
export interface LegalPersonCreateRequestDto {
    'type': LegalPersonType;
    'email': string | null;
    'title'?: Title;
    'firstName': string | null;
    'lastName': string | null;
    'companyName': string | null;
    'vatId'?: string | null;
    'taxType': TaxType;
    'address': AddressCreateRequestDto;
    'userIds'?: Array<number> | null;
    'additionalInvoiceProperties': Array<AdditionalInvoiceProperty> | null;
}


export interface LegalPersonDto {
    'id': number;
    'type': LegalPersonType;
    'name': string | null;
    'email': string | null;
    'title': Title;
    'firstName': string | null;
    'lastName': string | null;
    'companyName': string | null;
    'vatId': string | null;
    'taxType': TaxType;
    'address': AddressDto;
    'paymentInfo': PaymentInfoDto;
    'additionalInvoiceProperties': Array<AdditionalInvoiceProperty> | null;
}


export interface LegalPersonDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<LegalPersonDtoTableFilterDto> | null;
}
export interface LegalPersonDtoRowsResponseDto {
    'rows': Array<LegalPersonDto> | null;
    'rowCount': number;
}
export interface LegalPersonDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface LegalPersonMinimalDto {
    'id': number;
    'type': LegalPersonType;
    'name': string | null;
    'email': string | null;
}



export const LegalPersonType = {
    NaturalPerson: 'NATURAL_PERSON',
    LegalEntity: 'LEGAL_ENTITY',
} as const;

export type LegalPersonType = typeof LegalPersonType[keyof typeof LegalPersonType];



export const LockoutState = {
    LockedOut: 'LOCKED_OUT',
    NotLockedOut: 'NOT_LOCKED_OUT',
} as const;

export type LockoutState = typeof LockoutState[keyof typeof LockoutState];


export interface LoginRequest {
    'email': string;
    'password': string;
    'twoFactorCode'?: string | null;
    'twoFactorRecoveryCode'?: string | null;
}
export interface MCBillingDto {
    'id'?: number;
    'energyCommunityId'?: number;
    'customerId'?: string | null;
    'ownerName'?: string | null;
    'invoiceTextType'?: InvoiceType;
    'ownerTaxType'?: TaxType;
    'consumptionBillingInfo'?: AmountBreakdownDto;
    'consumptionKwh'?: number;
    'productionBillingInfo'?: AmountBreakdownDto;
    'productionKwh'?: number;
    'monthlyMCCostsInfo'?: AmountBreakdownDto;
    'oneTimeCostsInfo'?: AmountBreakdownDto;
    'monthlyCosts'?: Array<MonthlyCostDto> | null;
    'supplyVatLegalNoteKey'?: string | null;
    'containsL3Data'?: boolean;
    'containsEmptyData'?: boolean;
    'totalCorrectedkWhCostNetEUR'?: number;
    'totalCorrectedCostEUR'?: number;
    'consumptionCorrectionCostToBePaidNetSumEUR'?: number;
    'productionCorrectionCostToBePaidNetSumEUR'?: number;
    'monthlyCorrectionCostToBePaidNetSumEUR'?: number;
    'oneTimeCorrectionNetEUR'?: number;
    'mpcIds'?: Set<number> | null;
    'monthlyMCTariffInfo'?: TariffInfo;
    'oneTimeMCTariffInfo'?: TariffInfo;
    'totalBillingInfo'?: AmountBreakdownDto;
}


export interface MCCreateRequestDto {
    'customerId': string | null;
    'activationDate': string;
    'energyCommunityId': number;
    'memberType': MemberType;
    'alternativeBillingEmail': string | null;
    'invoiceTextType': InvoiceType;
    'paymentInfoId': number;
    'ownerId': number;
}


export interface MCDto {
    'id': number;
    'customerId': string | null;
    'memberType': MemberType;
    'activationDate': string;
    'deactivationDate': string | null;
    'energyCommunity': EnergyCommunityDto;
    'paymentInfo': PaymentInfoDto;
    'document': DocumentDto;
    'owner': LegalPersonMinimalDto;
    'alternativeBillingEmail': string | null;
    'invoiceTextType': InvoiceType;
}


export interface MCDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<MCDtoTableFilterDto> | null;
}
export interface MCDtoRowsResponseDto {
    'rows': Array<MCDto> | null;
    'rowCount': number;
}
export interface MCDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface MCUsageDto {
    'id': number;
    'energyCommunity': ECDto;
    'legalPerson': LegalPersonMinimalDto;
}
export interface MPCBillingDto {
    'meteringPointContractId'?: number;
    'meteringPointId'?: string | null;
    'meteringPointName'?: string | null;
    'isProduction'?: boolean;
    'energyDataCostsInfos'?: Array<EnergyDataCostInfo> | null;
    'costCenterId'?: number | null;
    'costCenterName'?: string | null;
    'totalkWh'?: number;
    'costToBePaidNetSumEUR'?: number;
    'correctedCostNetSumEUR'?: number;
    'correctionCostToBePaidNetSumEUR'?: number;
    'containsL3Data'?: boolean;
    'containsEmptyData'?: boolean;
    'onlyEmptyData'?: boolean;
    'totalmonthlyCostNet'?: number;
    'monthlyCostCorrectionNet'?: number;
    'totalOneTimeCostNet'?: number;
    'oneTimeCostCorrectionNet'?: number;
    'energyDataTariffInfo'?: TariffInfo;
    'monthlyMPCTariffInfo'?: TariffInfo;
    'oneTimeMPCTariffInfo'?: TariffInfo;
}
export interface MPCostCenterDto {
    'id': number;
    'name': string | null;
    'ownerId': number;
    'ownerEmail': string | null;
    'ownerName': string | null;
}
export interface MPDto {
    'id': number;
    'meteringPointIdentifier': string | null;
    'name': string | null;
    'meteringPointCostCenterId': number | null;
    'meteringPointCostCenterName': string | null;
    'energyDirection': EnergyDirection;
    'ownerId': number;
    'ownerName': string | null;
    'address': AddressDto;
    'gridOperatorName': string | null;
    'gridOperatorOpId': string | null;
    'gridSubstationSsId': string | null;
    'gridTransformerTfId': string | null;
    'gridConnectionLevel': GridConnectionLevel;
    'plantCategory': PlantCategory;
}



export const MemberType = {
    Regular: 'REGULAR',
    Associate: 'ASSOCIATE',
} as const;

export type MemberType = typeof MemberType[keyof typeof MemberType];


export interface MessageDto {
    'id': number;
    'isIncomingMessage': boolean;
    'receivedTimestamp': string;
    'processedTimestamp': string | null;
    'messageVersion': string | null;
    'backendReceiverId': string | null;
    'schemaSet': string | null;
    'uniqueId': number | null;
    'filename': string | null;
    'messageId': string | null;
    'messageType': string | null;
    'backendSenderId': string | null;
    'conversation': ConversationDto;
    'errMsg': string | null;
}
export interface MessageDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<MessageDtoTableFilterDto> | null;
}
export interface MessageDtoRowsResponseDto {
    'rows': Array<MessageDto> | null;
    'rowCount': number;
}
export interface MessageDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}

export const MessageIssueType = {
    Registration: 'REGISTRATION',
    EnergyData: 'ENERGY_DATA',
    Deregistration: 'DEREGISTRATION',
    MeteringPointList: 'METERING_POINT_LIST',
    ParticipationFactorChange: 'PARTICIPATION_FACTOR_CHANGE',
} as const;

export type MessageIssueType = typeof MessageIssueType[keyof typeof MessageIssueType];


export interface MessageNoteDto {
    'id': number;
    'messageId': number;
    'note': string | null;
}
export interface MessagePayloadDto {
    'id': number;
    'payload': string | null;
}
export interface MeteringPointContractCreateRequestDto {
    'memberContractId': number;
    'meteringPointId': number;
}
export interface MeteringPointContractDto {
    'id': number;
    'mpInfoId': number;
    'meteringPointIdentifier': string | null;
    'energyCommunityName': string | null;
    'memberContractId': number;
    'customerId': string | null;
    'memberType': MemberType;
    'ownerId': number;
    'ownerEmail': string | null;
    'ownerName': string | null;
    'alternativeBillingEmail': string | null;
    'activationDate': string | null;
    'deactivationDate': string | null;
    'participationFactor': number;
    'participationFactorActivationDate': string | null;
    'activeOverrule'?: boolean;
    'isRegistrationDisabled'?: boolean;
}


export interface MeteringPointContractDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<MeteringPointContractDtoTableFilterDto> | null;
}
export interface MeteringPointContractDtoRowsResponseDto {
    'rows': Array<MeteringPointContractDto> | null;
    'rowCount': number;
}
export interface MeteringPointContractDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface MeteringPointContractSearchResultDto {
    'id': number;
    'mpInfoId': number;
    'meteringPointIdentifier': string | null;
    'meteringPointName': string | null;
    'ownerEmail': string | null;
    'ownerName': string | null;
    'energyCommunityName': string | null;
    'energyDirection'?: EnergyDirection;
    'participationFactor': number;
    'activationDate': string | null;
    'deactivationDate': string | null;
    'isActive'?: boolean;
    'activeOverrule'?: boolean;
}


export interface MeteringPointCreateRequestDto {
    'meteringPointIdentifier': string | null;
    'energyDirection': EnergyDirection;
    'addressStreet': string | null;
    'addressZipCode': string | null;
    'addressCity': string | null;
    /**
     * One of `AUSTRIA`, `GERMANY`, `UNKNOWN` (case-insensitive), or null. Any other  value is rejected. An address is only created when at least one address field is set.
     */
    'addressCountry': string | null;
    'gridOperatorId': number | null;
    'gridSubstationId': number | null;
    'gridTransformerId': number | null;
    'plantCategory': PlantCategory;
    'gridConnectionLevel': GridConnectionLevel;
}


export interface MeteringPointDto {
    'id': number;
    'ownerId': number | null;
    'ownerEmail': string | null;
    'ownerName': string | null;
    'meteringPointIdentifier': string | null;
    'energyDirection': EnergyDirection;
    'name': string | null;
    'meteringPointCostCenterId': number | null;
    'meteringPointCostCenterName': string | null;
    'addressStreet': string | null;
    'addressZipCode': string | null;
    'addressCity': string | null;
    'addressCountry': Country;
    'gridOperatorId': number | null;
    'gridOperatorName': string | null;
    'gridOperatorOpId': string | null;
    'gridSubstationId': number | null;
    'gridSubstationSsId': string | null;
    'gridTransformerId': number | null;
    'gridTransformerTfId': string | null;
    'plantCategory': PlantCategory;
    'techCode': string | null;
    'fuelCode': string | null;
    'gridConnectionLevel': GridConnectionLevel;
    'decommissionedAt': string | null;
}


export interface MeteringPointDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<MeteringPointDtoTableFilterDto> | null;
}
export interface MeteringPointDtoRowsResponseDto {
    'rows': Array<MeteringPointDto> | null;
    'rowCount': number;
}
export interface MeteringPointDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface MeteringPointMinimalDto {
    'id': number;
    'meteringPointId': string | null;
}
export interface MeteringPointParticipationFactorDto {
    'id': number;
    'participationFactor': number;
    'activationDate': string;
    'deactivationDate'?: string | null;
}
export interface MeteringPointUserUpdateRequestDto {
    'name'?: string | null;
    'meteringPointCostCenterId'?: number | null;
    'address'?: AddressCreateRequestDto;
}
export interface MonthlyCostDto {
    'from': string;
    'to': string;
    'isCorrection': boolean;
    'meteringPointId'?: string | null;
    'amount': AmountBreakdownDto;
}
export interface NotificationDto {
    'id': number;
    'title': string | null;
    'message': string | null;
    'severity': NotificationSeverity;
    'type': NotificationType;
    'relatedEnergyCommunityId'?: number | null;
    'relatedLegalPersonId'?: number | null;
    'actionUrl'?: string | null;
    'openInNewTab': boolean;
    'createdAt': string;
    'scheduledFor'?: string | null;
    'isRead': boolean;
    'isDismissed': boolean;
    'readAt'?: string | null;
    'dismissedAt'?: string | null;
}


export interface NotificationMarkAsDismissedRequestDto {
    'notificationIds': Array<number> | null;
}
export interface NotificationMarkAsReadRequestDto {
    'notificationIds': Array<number> | null;
}

export const NotificationSeverity = {
    Info: 'INFO',
    Warning: 'WARNING',
    Critical: 'CRITICAL',
} as const;

export type NotificationSeverity = typeof NotificationSeverity[keyof typeof NotificationSeverity];



export const NotificationTargetType = {
    SpecificUsers: 'SPECIFIC_USERS',
    EnergyCommunityMembers: 'ENERGY_COMMUNITY_MEMBERS',
    AllUsers: 'ALL_USERS',
    SpecificLegalPersons: 'SPECIFIC_LEGAL_PERSONS',
} as const;

export type NotificationTargetType = typeof NotificationTargetType[keyof typeof NotificationTargetType];



export const NotificationType = {
    SystemAnnouncement: 'SYSTEM_ANNOUNCEMENT',
    EnergyCommunity: 'ENERGY_COMMUNITY',
    Billing: 'BILLING',
    DataRequest: 'DATA_REQUEST',
    ContractUpdate: 'CONTRACT_UPDATE',
    PaymentInfo: 'PAYMENT_INFO',
    MeteringPoint: 'METERING_POINT',
    Maintenance: 'MAINTENANCE',
    General: 'GENERAL',
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


export interface OnboardingControllingFilterDto {
    'timeoutHours': number;
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean;
}
export interface OnboardingNoteDto {
    'id': number;
    'noteText': string | null;
    'createdByUserName': string | null;
    'createdAt': string;
    'updatedAt': string;
}
export interface OverlappingInvoiceDto {
    'mcId': number;
    'invoiceNumber': string | null;
    'from': string;
    'to': string;
}

export const Participation = {
    Static: 'STATIC',
    Dynamic: 'DYNAMIC',
} as const;

export type Participation = typeof Participation[keyof typeof Participation];


export interface ParticipationFactorChangeRequestDto {
    'meteringPointContractId': number;
    /**
     * New participation factor in percent. Must be between 1 and 100.
     */
    'participationFactor': number;
    /**
     * First day on which the new participation factor applies. Must be a future day — the earliest  accepted value is tomorrow — and must not precede the activation date of the contract\'s  currently open participation interval.
     */
    'dateFrom': string;
}

export const PaymentDirection = {
    Both: 'BOTH',
    Incoming: 'INCOMING',
    Outgoing: 'OUTGOING',
} as const;

export type PaymentDirection = typeof PaymentDirection[keyof typeof PaymentDirection];


export interface PaymentInfoCreateRequestDto {
    'name': string | null;
    'acceptedPayments': PaymentDirection;
    'ownerId': number;
    'accountHolder': string | null;
    'sepaCreditorId'?: string | null;
    'IBAN': string | null;
    'BIC': string | null;
}


export interface PaymentInfoDto {
    'id': number;
    'name': string | null;
    'acceptedPayments': PaymentDirection;
    'paymentMethod': PaymentMethodDto;
    'owner': LegalPersonMinimalDto;
    'accountHolder': string | null;
    'sepaCreditorId': string | null;
    'IBAN': string | null;
    'BIC': string | null;
    'state': State;
}


export interface PaymentInfoDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<PaymentInfoDtoTableFilterDto> | null;
}
export interface PaymentInfoDtoRowsResponseDto {
    'rows': Array<PaymentInfoDto> | null;
    'rowCount': number;
}
export interface PaymentInfoDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface PaymentInfoUsageDto {
    'paymentInfoId': number;
    'totalUsageCount': number;
    'energyCommunities': Array<ECDto> | null;
    'memberContracts': Array<MCUsageDto> | null;
}
export interface PaymentMethodDto {
    'id': number;
    'type': PaymentType;
    'details': any;
}



export const PaymentType = {
    Lsv: 'LSV',
} as const;

export type PaymentType = typeof PaymentType[keyof typeof PaymentType];



export const PlantCategory = {
    Sonne: 'SONNE',
    Wind: 'WIND',
    Wasser: 'WASSER',
    Sonstige: 'SONSTIGE',
    Thermal: 'THERMAL',
    Storage: 'STORAGE',
} as const;

export type PlantCategory = typeof PlantCategory[keyof typeof PlantCategory];


export interface ProblemDetails {
    [key: string]: any;

    'type'?: string | null;
    'title'?: string | null;
    'status'?: number | null;
    'detail'?: string | null;
    'instance'?: string | null;
}

export const ProcessStatus = {
    Created: 'CREATED',
    LocalError: 'LOCAL_ERROR',
    MessengerError: 'MESSENGER_ERROR',
    RemoteError: 'REMOTE_ERROR',
    Dispatched: 'DISPATCHED',
    Declined: 'DECLINED',
    Pending: 'PENDING',
    Success: 'SUCCESS',
    Done: 'DONE',
    Cancelled: 'CANCELLED',
    CancelledByAdmin: 'CANCELLED_BY_ADMIN',
} as const;

export type ProcessStatus = typeof ProcessStatus[keyof typeof ProcessStatus];


export interface ProcessStepDto {
    'id': number;
    'processStatus': ProcessStatus;
    'processMessage': string | null;
    'createdTime': string;
    'messageId': number | null;
    'createdFromIncomingMessage': boolean;
}



export const ProcessType = {
    RegistrationOnline: 'REGISTRATION_ONLINE',
    RegistrationOffline: 'REGISTRATION_OFFLINE',
    ParticipationFactorMutation: 'PARTICIPATION_FACTOR_MUTATION',
    Deregister: 'DEREGISTER',
    DataRequest: 'DATA_REQUEST',
    EcmpInfoRequest: 'ECMP_INFO_REQUEST',
} as const;

export type ProcessType = typeof ProcessType[keyof typeof ProcessType];


export interface ProcessWithStepsDto {
    'id': number;
    'type': ProcessType;
    'latestProcessStatus': ProcessStatus;
    'latestProcessMessage': string | null;
    'startTime': string;
    'updateTime': string;
    'endTime': string | null;
    'libConversationId': number;
    'conversationId'?: string | null;
    'processSteps': Array<ProcessStepDto> | null;
}


export interface ProcessWithStepsDtoRowsResponseDto {
    'rows': Array<ProcessWithStepsDto> | null;
    'rowCount': number;
}
export interface ReceivedRegistrationWithoutProcessDto {
    'id': number;
    'messageId': string | null;
    'conversationId': number | null;
    'messageType': string | null;
    'receivedTimestamp': string;
    'receivedAt': string;
    'processedTimestamp': string | null;
    'backendSenderId': string | null;
    'backendReceiverId': string | null;
    'processingError': string | null;
    'hoursSinceReceived': number;
}
export interface ReceivedRegistrationWithoutProcessDtoRowsResponseDto {
    'rows': Array<ReceivedRegistrationWithoutProcessDto> | null;
    'rowCount': number;
}
export interface RegisterRequest {
    'email': string;
    'password': string;
}
export interface RegistrationOfflineDto {
    'meteringPointContractId': number;
    /**
     * Participation factor in percent. Must be between 1 and 100.
     */
    'participationFactor': number;
    /**
     * Desired execution day (Europe/Vienna) of the registration process, forwarded to the grid operator.  Must be at least tomorrow and at most 42 calendar days (6 weeks) ahead; that is the  platform\'s approximation of the EBUtilities rule \"at most 30 working days\".
     */
    'processExecutionDate': string;
    'consentId': string | null;
}
export interface RegistrationOnlineDto {
    'meteringPointContractId': number;
    /**
     * Participation factor in percent. Must be between 1 and 100.
     */
    'participationFactor': number;
    /**
     * Desired execution day (Europe/Vienna) of the registration process, forwarded to the grid operator.  Must be at least tomorrow and at most 42 calendar days (6 weeks) ahead; that is the  platform\'s approximation of the EBUtilities rule \"at most 30 working days\".
     */
    'processExecutionDate': string;
}
export interface RegistrationProcessEntryDto {
    'id': number;
    'meteringPointContractId': number;
    'type': ProcessType;
    'processStatus': ProcessStatus;
    'startTime': string;
    'updateTime': string;
    'endTime': string | null;
    'latestProcessMessage'?: string | null;
}


export interface ResetPasswordRequest {
    'email': string;
    'resetCode': string;
    'newPassword': string;
}
export interface SepaExportRequestDto {
    'batchIds': Set<number> | null;
    'isSepaDebit': boolean;
    'date': string;
}
export interface SepaMandateCreateRequestDto {
    'mcId': number;
    'signatureDate': string;
}
export interface SepaMandateDto {
    'id': number;
    'mcId': number;
    'paymentInfoId': number;
    'mandateReference': string | null;
    'signatureDate': string;
    'validTo': string | null;
    'isActive'?: boolean;
}
export interface SepaMandateDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<SepaMandateDtoTableFilterDto> | null;
}
export interface SepaMandateDtoRowsResponseDto {
    'rows': Array<SepaMandateDto> | null;
    'rowCount': number;
}
export interface SepaMandateDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}

export const State = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
} as const;

export type State = typeof State[keyof typeof State];


export interface StuckContractDto {
    'contractId': number;
    'meteringPointId': string | null;
    'processId': number;
    'processType': ProcessType;
    'currentStatus': ProcessStatus;
    'lastUpdateTime': string;
    'hoursStuck': number;
    'latestMessage': string | null;
    'libConversationId': number;
    'noteCount': number;
}


export interface StuckContractDtoRowsResponseDto {
    'rows': Array<StuckContractDto> | null;
    'rowCount': number;
}
export interface SystemBannerCreateRequestDto {
    'message': string | null;
    'severity': BannerSeverity;
    'isActive': boolean;
}


export interface SystemBannerDto {
    'id': number;
    'message': string | null;
    'severity': BannerSeverity;
    'isActive': boolean;
    'createdByUserId': number;
    'createdAt': string;
}


export interface SystemBannerUpdateRequestDto {
    'id': number;
    'message'?: string | null;
    'severity'?: BannerSeverity;
    'isActive'?: boolean | null;
}



export const TariffApplicability = {
    Membership: 'MEMBERSHIP',
    ConsumptionMp: 'CONSUMPTION_MP',
    ProductionMp: 'PRODUCTION_MP',
} as const;

export type TariffApplicability = typeof TariffApplicability[keyof typeof TariffApplicability];


/**
 * Assigns a tariff package to exactly one scope: set exactly one of `energyCommunityId`,  `memberContractId` or `meteringPointContractId` — zero or several is  rejected.
 */
export interface TariffAssignmentCreateRequestDto {
    'tariffPackageId': number;
    'energyCommunityId'?: number | null;
    'memberContractId'?: number | null;
    'meteringPointContractId'?: number | null;
    /**
     * Stops inheritance from the parent scope. Not allowed together with `energyCommunityId`,  which has no parent to inherit from.
     */
    'doesNotInherit': boolean;
    'validFrom': string;
    /**
     * Exclusive end of validity; must be after `validFrom`. When omitted, the assignment is  open-ended but is silently clamped to the start of the next assignment in the same scope.  Existing overlapping assignments are shortened, split, or moved to make room.
     */
    'validTo'?: string | null;
}
export interface TariffAssignmentDto {
    'id': number;
    'tariffPackage': TariffPackageDto;
    'energyCommunityId'?: number | null;
    'memberContractId'?: number | null;
    'meteringPointContractId'?: number | null;
    'meteringPointIdentifier'?: string | null;
    'doesNotInherit': boolean;
    'validFrom': string;
    'validTo'?: string | null;
}
export interface TariffAssignmentDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<TariffAssignmentDtoTableFilterDto> | null;
}
export interface TariffAssignmentDtoRowsResponseDto {
    'rows': Array<TariffAssignmentDto> | null;
    'rowCount': number;
}
export interface TariffAssignmentDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface TariffComponentCreateRequestDto {
    'name': string | null;
    'unitType': TariffUnitType;
    'applicability': TariffApplicability;
}


export interface TariffComponentDto {
    'id': number;
    'name': string | null;
    'unitType': TariffUnitType;
    'applicability': TariffApplicability;
    'tariffComponentValues': Array<TariffComponentValueDto> | null;
}


export interface TariffComponentDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<TariffComponentDtoTableFilterDto> | null;
}
export interface TariffComponentDtoRowsResponseDto {
    'rows': Array<TariffComponentDto> | null;
    'rowCount': number;
}
export interface TariffComponentDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface TariffComponentInfo {
    'id': number;
    'name': string | null;
    'values': Array<TariffComponentTimedValueInfo> | null;
}
export interface TariffComponentTimedValueDto {
    'id': number;
    'validFrom': string;
    'value': number;
}
export interface TariffComponentTimedValueInfo {
    'start': string;
    'value': number;
}
export interface TariffComponentUpdateRequestDto {
    'name'?: string | null;
    'unitType'?: TariffUnitType;
    'applicability'?: TariffApplicability;
}


export interface TariffComponentValueCreateRequestDto {
    'tariffComponentId': number;
    'timedValues': Array<TimedValueRequestDto> | null;
    'validFrom': string;
    'validTo'?: string | null;
}
export interface TariffComponentValueDto {
    'id': number;
    'tariffComponentId': number;
    'timedValues': Array<TimedValueDto> | null;
    'validFrom': string;
    'validTo': string | null;
}
export interface TariffComponentValueUpdateRequestDto {
    'validFrom': string;
    'validTo'?: string | null;
    'timedValues': Array<TimedValueRequestDto> | null;
}
export interface TariffGapDto {
    'from': string;
    'to': string;
}
export interface TariffInfo {
    'tariff_tripples': Array<TariffTrippleInfo> | null;
}
export interface TariffIntervalMPCDto {
    'from': string;
    'to': string;
    'tariffTriples': Array<TariffTripleDto> | null;
    'gaps'?: Array<TariffGapDto> | null;
    'hasGaps'?: boolean;
    'mpcId': number;
}

export const TariffPackageApplicability = {
    EnergyCommunity: 'ENERGY_COMMUNITY',
    MemberContract: 'MEMBER_CONTRACT',
    MeteringPointContract: 'METERING_POINT_CONTRACT',
} as const;

export type TariffPackageApplicability = typeof TariffPackageApplicability[keyof typeof TariffPackageApplicability];


export interface TariffPackageCreateRequestDto {
    'name': string | null;
    'applicability': TariffPackageApplicability;
}


export interface TariffPackageDto {
    'id': number;
    'name': string | null;
    'applicability': TariffPackageApplicability;
    'tariffPackageComponents': Array<TariffComponentDto> | null;
}


export interface TariffPackageDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<TariffPackageDtoTableFilterDto> | null;
}
export interface TariffPackageDtoRowsResponseDto {
    'rows': Array<TariffPackageDto> | null;
    'rowCount': number;
}
export interface TariffPackageDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface TariffPackageUpdateRequestDto {
    'name'?: string | null;
    'applicability'?: TariffPackageApplicability;
}


export interface TariffTripleDto {
    'from': string;
    'to': string;
    'ecComponents': Array<FlatTariffComponentDto> | null;
    'mcComponents': Array<FlatTariffComponentDto> | null;
    'mpcComponents': Array<FlatTariffComponentDto> | null;
    'intraDayPricing': Array<IntraDayPriceDto> | null;
    'isEmpty'?: boolean;
}
export interface TariffTrippleInfo {
    'from': string;
    'to': string;
    'ec_tc': Array<TariffComponentInfo> | null;
    'mc_tc': Array<TariffComponentInfo> | null;
    'mpc_tc': Array<TariffComponentInfo> | null;
}

export const TariffUnitType = {
    CtKwhZp: 'CT_KWH_ZP',
    EurMtZp: 'EUR_MT_ZP',
    EurZp: 'EUR_ZP',
    EurMtMembership: 'EUR_MT_MEMBERSHIP',
    EurMembership: 'EUR_MEMBERSHIP',
    All: 'ALL',
} as const;

export type TariffUnitType = typeof TariffUnitType[keyof typeof TariffUnitType];



export const TaxType = {
    PrivatpersonKleinunternehmen: 'PRIVATPERSON_KLEINUNTERNEHMEN',
    UmsatzsteuerlichesKmu: 'UMSATZSTEUERLICHES_KMU',
    HoheitlicheStelle: 'HOHEITLICHE_STELLE',
    UmsatzsteuerlichesGrossunternehmen: 'UMSATZSTEUERLICHES_GROSSUNTERNEHMEN',
    UmsatzsteuerlichPauschalierterLandwirt: 'UMSATZSTEUERLICH_PAUSCHALIERTER_LANDWIRT',
} as const;

export type TaxType = typeof TaxType[keyof typeof TaxType];


export interface TimedValueDto {
    'id': number;
    'startTimeOfDay': string;
    'value': number;
}
export interface TimedValueRequestDto {
    'startTimeOfDay': string;
    'value': number;
}

export const Title = {
    None: 'NONE',
    Mr: 'MR',
    Mrs: 'MRS',
    Other: 'OTHER',
} as const;

export type Title = typeof Title[keyof typeof Title];


export interface UpdateOnboardingNoteDto {
    'noteText': string | null;
}
export interface UserCreateRequestDto {
    'title': Title;
    'firstName': string | null;
    'lastName': string | null;
    'address': AddressCreateRequestDto;
    'taxType': TaxType;
    'state': LockoutState;
    'email': string | null;
    'phoneNumber': string | null;
    'roles'?: Array<string> | null;
}


export interface UserDto {
    'id': number;
    'title': Title;
    'firstName': string | null;
    'lastName': string | null;
    'state': LockoutState;
    'address': AddressDto;
    'taxType': TaxType;
    'email': string | null;
    'emailConfirmed': boolean;
    'phoneNumber': string | null;
    'phoneNumberConfirmed': boolean;
}


export interface UserDtoRowsRequestDto {
    'numOfRows'?: number;
    'skipRows'?: number;
    'orderByPropertyName'?: string | null;
    'orderByDescending'?: boolean | null;
    /**
     * Filters combined with AND. The format of each filter value is described on `TableFilterValue`.
     */
    'filters'?: Array<UserDtoTableFilterDto> | null;
}
export interface UserDtoRowsResponseDto {
    'rows': Array<UserDto> | null;
    'rowCount': number;
}
export interface UserDtoTableFilterDto {
    'id': string | null;
    /**
     * Filter value, its shape depends on the property: a string (case-insensitive substring), a number or  array of numbers, a boolean, an array of enum values, a number range `[min, max]` (inclusive) or  a date/time range `[from, to]` of ISO-8601 timestamps applied as the half-open range  `[from, to)`. Range bounds may be `null` (open-ended).
     */
    'value': object;
}
export interface UserInfoDto {
    'title': Title;
    'firstName': string | null;
    'lastName': string | null;
    'email': string | null;
    'roles': Array<string> | null;
}


export interface UserInvoiceDto {
    'id': number;
    'invoiceNumber': string | null;
    'invoiceName': string | null;
    'billingPeriodFrom': string;
    'billingPeriodTo': string;
    'totalAmountEur': number;
    'isPaid': boolean;
    'documentId'?: number | null;
    'createdAt': string;
}
export interface UserMCDocumentDto {
    'documentId': number;
    'fileId': string;
    'name': string | null;
    'uploadedAt': string;
    'isActive': boolean;
    'memberContractId': number;
    'customerId': string | null;
    'energyCommunityContactName': string | null;
    'energyCommunityCode': string | null;
}
export interface UserMinimalDto {
    'id': number;
    'email': string | null;
}
export interface UserNotificationCreateRequestDto {
    'title': string | null;
    'message': string | null;
    'severity': NotificationSeverity;
    'type': NotificationType;
    'targetType': NotificationTargetType;
    'targetUserIds'?: Array<number> | null;
    'targetEnergyCommunityIds'?: Array<number> | null;
    'targetLegalPersonIds'?: Array<number> | null;
    'maxJoinDate'?: string | null;
    'relatedEnergyCommunityId'?: number | null;
    'relatedLegalPersonId'?: number | null;
    'actionUrl'?: string | null;
    'openInNewTab'?: boolean;
    'scheduledFor'?: string | null;
}


export interface UserNotificationSummaryDto {
    'totalCount': number;
    'unreadCount': number;
    'undismissedCount': number;
}
export interface UserProfileDto {
    'title': Title;
    'firstName': string | null;
    'lastName': string | null;
    'email': string | null;
    'phoneNumber': string | null;
    'taxType': TaxType;
    'address': AddressDto;
}


export interface ValidationProblemDetails {
    [key: string]: any;

    'type'?: string | null;
    'title'?: string | null;
    'status'?: number | null;
    'detail'?: string | null;
    'instance'?: string | null;
    'errors'?: { [key: string]: Array<string>; } | null;
}

/**
 * BillingApi - axios parameter creator
 */
export const BillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingEcEnergyCommunityIdGet: async (energyCommunityId: number, from?: string, to?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'energyCommunityId' is not null or undefined
            assertParamExists('apiBillingEcEnergyCommunityIdGet', 'energyCommunityId', energyCommunityId)
            const localVarPath = `/api/billing/ec/{energyCommunityId}`
                .replace('{energyCommunityId}', encodeURIComponent(String(energyCommunityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingEcEnergyCommunityIdMcGet: async (energyCommunityId: number, from?: string, to?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'energyCommunityId' is not null or undefined
            assertParamExists('apiBillingEcEnergyCommunityIdMcGet', 'energyCommunityId', energyCommunityId)
            const localVarPath = `/api/billing/ec/{energyCommunityId}/mc`
                .replace('{energyCommunityId}', encodeURIComponent(String(energyCommunityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingMcMemberContractIdGet: async (memberContractId: number, from?: string, to?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberContractId' is not null or undefined
            assertParamExists('apiBillingMcMemberContractIdGet', 'memberContractId', memberContractId)
            const localVarPath = `/api/billing/mc/{memberContractId}`
                .replace('{memberContractId}', encodeURIComponent(String(memberContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingMpcMeteringPointContractIdGet: async (meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meteringPointContractId' is not null or undefined
            assertParamExists('apiBillingMpcMeteringPointContractIdGet', 'meteringPointContractId', meteringPointContractId)
            const localVarPath = `/api/billing/mpc/{meteringPointContractId}`
                .replace('{meteringPointContractId}', encodeURIComponent(String(meteringPointContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillingApi - functional programming interface
 */
export const BillingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBillingEcEnergyCommunityIdGet(energyCommunityId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ECBillingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBillingEcEnergyCommunityIdGet(energyCommunityId, from, to, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiBillingEcEnergyCommunityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBillingEcEnergyCommunityIdMcGet(energyCommunityId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MCBillingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBillingEcEnergyCommunityIdMcGet(energyCommunityId, from, to, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiBillingEcEnergyCommunityIdMcGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} memberContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBillingMcMemberContractIdGet(memberContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MCBillingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBillingMcMemberContractIdGet(memberContractId, from, to, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiBillingMcMemberContractIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBillingMpcMeteringPointContractIdGet(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MPCBillingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBillingMpcMeteringPointContractIdGet(meteringPointContractId, from, to, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiBillingMpcMeteringPointContractIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BillingApi - factory interface
 */
export const BillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillingApiFp(configuration)
    return {
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingEcEnergyCommunityIdGet(energyCommunityId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<ECBillingDto> {
            return localVarFp.apiBillingEcEnergyCommunityIdGet(energyCommunityId, from, to, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingEcEnergyCommunityIdMcGet(energyCommunityId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MCBillingDto>> {
            return localVarFp.apiBillingEcEnergyCommunityIdMcGet(energyCommunityId, from, to, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} memberContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingMcMemberContractIdGet(memberContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<MCBillingDto> {
            return localVarFp.apiBillingMcMemberContractIdGet(memberContractId, from, to, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingMpcMeteringPointContractIdGet(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<MPCBillingDto> {
            return localVarFp.apiBillingMpcMeteringPointContractIdGet(meteringPointContractId, from, to, apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BillingApi - object-oriented interface
 */
export class BillingApi extends BaseAPI {
    /**
     * 
     * @param {number} energyCommunityId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBillingEcEnergyCommunityIdGet(energyCommunityId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiBillingEcEnergyCommunityIdGet(energyCommunityId, from, to, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} energyCommunityId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBillingEcEnergyCommunityIdMcGet(energyCommunityId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiBillingEcEnergyCommunityIdMcGet(energyCommunityId, from, to, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} memberContractId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBillingMcMemberContractIdGet(memberContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiBillingMcMemberContractIdGet(memberContractId, from, to, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} meteringPointContractId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBillingMpcMeteringPointContractIdGet(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiBillingMpcMeteringPointContractIdGet(meteringPointContractId, from, to, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BillingBatchApi - axios parameter creator
 */
export const BillingBatchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {BillingBatchDtoRowsRequestDto} [billingBatchDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingbatchAllPost: async (apiVersion?: string, billingBatchDtoRowsRequestDto?: BillingBatchDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/billingbatch/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(billingBatchDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingbatchIdGet: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiBillingbatchIdGet', 'id', id)
            const localVarPath = `/api/billingbatch/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SepaExportRequestDto} [sepaExportRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingbatchSepaExportXmlPost: async (apiVersion?: string, sepaExportRequestDto?: SepaExportRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/billingbatch/sepa-export-xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sepaExportRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SepaExportRequestDto} [sepaExportRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingbatchSepaUploadPost: async (apiVersion?: string, sepaExportRequestDto?: SepaExportRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/billingbatch/sepa-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sepaExportRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillingBatchApi - functional programming interface
 */
export const BillingBatchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillingBatchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {BillingBatchDtoRowsRequestDto} [billingBatchDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBillingbatchAllPost(apiVersion?: string, billingBatchDtoRowsRequestDto?: BillingBatchDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingBatchDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBillingbatchAllPost(apiVersion, billingBatchDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingBatchApi.apiBillingbatchAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBillingbatchIdGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingBatchDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBillingbatchIdGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingBatchApi.apiBillingbatchIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SepaExportRequestDto} [sepaExportRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBillingbatchSepaExportXmlPost(apiVersion?: string, sepaExportRequestDto?: SepaExportRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBillingbatchSepaExportXmlPost(apiVersion, sepaExportRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingBatchApi.apiBillingbatchSepaExportXmlPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SepaExportRequestDto} [sepaExportRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBillingbatchSepaUploadPost(apiVersion?: string, sepaExportRequestDto?: SepaExportRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBillingbatchSepaUploadPost(apiVersion, sepaExportRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingBatchApi.apiBillingbatchSepaUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BillingBatchApi - factory interface
 */
export const BillingBatchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillingBatchApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {BillingBatchDtoRowsRequestDto} [billingBatchDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingbatchAllPost(apiVersion?: string, billingBatchDtoRowsRequestDto?: BillingBatchDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<BillingBatchDtoRowsResponseDto> {
            return localVarFp.apiBillingbatchAllPost(apiVersion, billingBatchDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingbatchIdGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingBatchDto> {
            return localVarFp.apiBillingbatchIdGet(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SepaExportRequestDto} [sepaExportRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingbatchSepaExportXmlPost(apiVersion?: string, sepaExportRequestDto?: SepaExportRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiBillingbatchSepaExportXmlPost(apiVersion, sepaExportRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SepaExportRequestDto} [sepaExportRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBillingbatchSepaUploadPost(apiVersion?: string, sepaExportRequestDto?: SepaExportRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiBillingbatchSepaUploadPost(apiVersion, sepaExportRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BillingBatchApi - object-oriented interface
 */
export class BillingBatchApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {BillingBatchDtoRowsRequestDto} [billingBatchDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBillingbatchAllPost(apiVersion?: string, billingBatchDtoRowsRequestDto?: BillingBatchDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return BillingBatchApiFp(this.configuration).apiBillingbatchAllPost(apiVersion, billingBatchDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBillingbatchIdGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return BillingBatchApiFp(this.configuration).apiBillingbatchIdGet(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {SepaExportRequestDto} [sepaExportRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBillingbatchSepaExportXmlPost(apiVersion?: string, sepaExportRequestDto?: SepaExportRequestDto, options?: RawAxiosRequestConfig) {
        return BillingBatchApiFp(this.configuration).apiBillingbatchSepaExportXmlPost(apiVersion, sepaExportRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {SepaExportRequestDto} [sepaExportRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBillingbatchSepaUploadPost(apiVersion?: string, sepaExportRequestDto?: SepaExportRequestDto, options?: RawAxiosRequestConfig) {
        return BillingBatchApiFp(this.configuration).apiBillingbatchSepaUploadPost(apiVersion, sepaExportRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentApi - axios parameter creator
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {DocumentDtoRowsRequestDto} [documentDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentAllPost: async (apiVersion?: string, documentDtoRowsRequestDto?: DocumentDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {DeleteDocumentsDto} [deleteDocumentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentBatchDelete: async (apiVersion?: string, deleteDocumentsDto?: DeleteDocumentsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteDocumentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentDownloadMultiplePost: async (apiVersion?: string, requestBody?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document/download-multiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentIdDelete: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentIdDelete', 'id', id)
            const localVarPath = `/api/document/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentIdDownloadGet: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentIdDownloadGet', 'id', id)
            const localVarPath = `/api/document/{id}/download`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {DocumentDtoRowsRequestDto} [documentDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentUserAllPost: async (apiVersion?: string, documentDtoRowsRequestDto?: DocumentDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document/user/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {DocumentDtoRowsRequestDto} [documentDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentAllPost(apiVersion?: string, documentDtoRowsRequestDto?: DocumentDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentAllPost(apiVersion, documentDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {DeleteDocumentsDto} [deleteDocumentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentBatchDelete(apiVersion?: string, deleteDocumentsDto?: DeleteDocumentsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentBatchDelete(apiVersion, deleteDocumentsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentBatchDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentDownloadMultiplePost(apiVersion?: string, requestBody?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentDownloadMultiplePost(apiVersion, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentDownloadMultiplePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentIdDelete(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentIdDownloadGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentIdDownloadGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {DocumentDtoRowsRequestDto} [documentDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentUserAllPost(apiVersion?: string, documentDtoRowsRequestDto?: DocumentDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentUserAllPost(apiVersion, documentDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.apiDocumentUserAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentApi - factory interface
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {DocumentDtoRowsRequestDto} [documentDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentAllPost(apiVersion?: string, documentDtoRowsRequestDto?: DocumentDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoRowsResponseDto> {
            return localVarFp.apiDocumentAllPost(apiVersion, documentDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {DeleteDocumentsDto} [deleteDocumentsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentBatchDelete(apiVersion?: string, deleteDocumentsDto?: DeleteDocumentsDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiDocumentBatchDelete(apiVersion, deleteDocumentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentDownloadMultiplePost(apiVersion?: string, requestBody?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiDocumentDownloadMultiplePost(apiVersion, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiDocumentIdDelete(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentIdDownloadGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiDocumentIdDownloadGet(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {DocumentDtoRowsRequestDto} [documentDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentUserAllPost(apiVersion?: string, documentDtoRowsRequestDto?: DocumentDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DocumentDtoRowsResponseDto> {
            return localVarFp.apiDocumentUserAllPost(apiVersion, documentDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 */
export class DocumentApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {DocumentDtoRowsRequestDto} [documentDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentAllPost(apiVersion?: string, documentDtoRowsRequestDto?: DocumentDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentAllPost(apiVersion, documentDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {DeleteDocumentsDto} [deleteDocumentsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentBatchDelete(apiVersion?: string, deleteDocumentsDto?: DeleteDocumentsDto, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentBatchDelete(apiVersion, deleteDocumentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentDownloadMultiplePost(apiVersion?: string, requestBody?: Array<number>, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentDownloadMultiplePost(apiVersion, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentIdDelete(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentIdDownloadGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentIdDownloadGet(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {DocumentDtoRowsRequestDto} [documentDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDocumentUserAllPost(apiVersion?: string, documentDtoRowsRequestDto?: DocumentDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).apiDocumentUserAllPost(apiVersion, documentDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EBUtilitiesApi - axios parameter creator
 */
export const EBUtilitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {ConversationDtoRowsRequestDto} [conversationDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesConversationsAllPost: async (apiVersion?: string, conversationDtoRowsRequestDto?: ConversationDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ebutilities/conversations/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} conversationId 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesConversationsConversationIdMessagesGet: async (conversationId: number, limit?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('apiEbutilitiesConversationsConversationIdMessagesGet', 'conversationId', conversationId)
            const localVarPath = `/api/ebutilities/conversations/{conversationId}/messages`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MessageDtoRowsRequestDto} [messageDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesAllPost: async (apiVersion?: string, messageDtoRowsRequestDto?: MessageDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ebutilities/messages/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesIdMarkResolvedPut: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEbutilitiesMessagesIdMarkResolvedPut', 'id', id)
            const localVarPath = `/api/ebutilities/messages/{id}/mark-resolved`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesIdNoteDelete: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEbutilitiesMessagesIdNoteDelete', 'id', id)
            const localVarPath = `/api/ebutilities/messages/{id}/note`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {string} [note] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesIdNotePost: async (id: number, apiVersion?: string, note?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEbutilitiesMessagesIdNotePost', 'id', id)
            const localVarPath = `/api/ebutilities/messages/{id}/note`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (note !== undefined) { 
                localVarFormParams.append('note', note as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {string} [updatedNote] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesIdNotePut: async (id: number, apiVersion?: string, updatedNote?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEbutilitiesMessagesIdNotePut', 'id', id)
            const localVarPath = `/api/ebutilities/messages/{id}/note`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (updatedNote !== undefined) { 
                localVarFormParams.append('updatedNote', updatedNote as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesIdNotesGet: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEbutilitiesMessagesIdNotesGet', 'id', id)
            const localVarPath = `/api/ebutilities/messages/{id}/notes`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesIdPayloadGet: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiEbutilitiesMessagesIdPayloadGet', 'id', id)
            const localVarPath = `/api/ebutilities/messages/{id}/payload`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MessageIssueType} [msgIssueType] 
         * @param {string} [apiVersion] 
         * @param {MessageDtoRowsRequestDto} [messageDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesPost: async (msgIssueType?: MessageIssueType, apiVersion?: string, messageDtoRowsRequestDto?: MessageDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ebutilities/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (msgIssueType !== undefined) {
                localVarQueryParameter['msgIssueType'] = msgIssueType;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EBUtilitiesApi - functional programming interface
 */
export const EBUtilitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EBUtilitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {ConversationDtoRowsRequestDto} [conversationDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEbutilitiesConversationsAllPost(apiVersion?: string, conversationDtoRowsRequestDto?: ConversationDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEbutilitiesConversationsAllPost(apiVersion, conversationDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EBUtilitiesApi.apiEbutilitiesConversationsAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} conversationId 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEbutilitiesConversationsConversationIdMessagesGet(conversationId: number, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationMessagesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEbutilitiesConversationsConversationIdMessagesGet(conversationId, limit, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EBUtilitiesApi.apiEbutilitiesConversationsConversationIdMessagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MessageDtoRowsRequestDto} [messageDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEbutilitiesMessagesAllPost(apiVersion?: string, messageDtoRowsRequestDto?: MessageDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEbutilitiesMessagesAllPost(apiVersion, messageDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EBUtilitiesApi.apiEbutilitiesMessagesAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEbutilitiesMessagesIdMarkResolvedPut(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagePayloadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEbutilitiesMessagesIdMarkResolvedPut(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EBUtilitiesApi.apiEbutilitiesMessagesIdMarkResolvedPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEbutilitiesMessagesIdNoteDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEbutilitiesMessagesIdNoteDelete(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EBUtilitiesApi.apiEbutilitiesMessagesIdNoteDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {string} [note] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEbutilitiesMessagesIdNotePost(id: number, apiVersion?: string, note?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEbutilitiesMessagesIdNotePost(id, apiVersion, note, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EBUtilitiesApi.apiEbutilitiesMessagesIdNotePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {string} [updatedNote] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEbutilitiesMessagesIdNotePut(id: number, apiVersion?: string, updatedNote?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEbutilitiesMessagesIdNotePut(id, apiVersion, updatedNote, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EBUtilitiesApi.apiEbutilitiesMessagesIdNotePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEbutilitiesMessagesIdNotesGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MessageNoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEbutilitiesMessagesIdNotesGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EBUtilitiesApi.apiEbutilitiesMessagesIdNotesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEbutilitiesMessagesIdPayloadGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagePayloadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEbutilitiesMessagesIdPayloadGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EBUtilitiesApi.apiEbutilitiesMessagesIdPayloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MessageIssueType} [msgIssueType] 
         * @param {string} [apiVersion] 
         * @param {MessageDtoRowsRequestDto} [messageDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEbutilitiesMessagesPost(msgIssueType?: MessageIssueType, apiVersion?: string, messageDtoRowsRequestDto?: MessageDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEbutilitiesMessagesPost(msgIssueType, apiVersion, messageDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EBUtilitiesApi.apiEbutilitiesMessagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EBUtilitiesApi - factory interface
 */
export const EBUtilitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EBUtilitiesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {ConversationDtoRowsRequestDto} [conversationDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesConversationsAllPost(apiVersion?: string, conversationDtoRowsRequestDto?: ConversationDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ConversationDtoRowsResponseDto> {
            return localVarFp.apiEbutilitiesConversationsAllPost(apiVersion, conversationDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} conversationId 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesConversationsConversationIdMessagesGet(conversationId: number, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationMessagesResponseDto> {
            return localVarFp.apiEbutilitiesConversationsConversationIdMessagesGet(conversationId, limit, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MessageDtoRowsRequestDto} [messageDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesAllPost(apiVersion?: string, messageDtoRowsRequestDto?: MessageDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageDtoRowsResponseDto> {
            return localVarFp.apiEbutilitiesMessagesAllPost(apiVersion, messageDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesIdMarkResolvedPut(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<MessagePayloadDto> {
            return localVarFp.apiEbutilitiesMessagesIdMarkResolvedPut(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesIdNoteDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEbutilitiesMessagesIdNoteDelete(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {string} [note] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesIdNotePost(id: number, apiVersion?: string, note?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEbutilitiesMessagesIdNotePost(id, apiVersion, note, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {string} [updatedNote] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesIdNotePut(id: number, apiVersion?: string, updatedNote?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEbutilitiesMessagesIdNotePut(id, apiVersion, updatedNote, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesIdNotesGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MessageNoteDto>> {
            return localVarFp.apiEbutilitiesMessagesIdNotesGet(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesIdPayloadGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<MessagePayloadDto> {
            return localVarFp.apiEbutilitiesMessagesIdPayloadGet(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MessageIssueType} [msgIssueType] 
         * @param {string} [apiVersion] 
         * @param {MessageDtoRowsRequestDto} [messageDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEbutilitiesMessagesPost(msgIssueType?: MessageIssueType, apiVersion?: string, messageDtoRowsRequestDto?: MessageDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MessageDtoRowsResponseDto> {
            return localVarFp.apiEbutilitiesMessagesPost(msgIssueType, apiVersion, messageDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EBUtilitiesApi - object-oriented interface
 */
export class EBUtilitiesApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {ConversationDtoRowsRequestDto} [conversationDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEbutilitiesConversationsAllPost(apiVersion?: string, conversationDtoRowsRequestDto?: ConversationDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return EBUtilitiesApiFp(this.configuration).apiEbutilitiesConversationsAllPost(apiVersion, conversationDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} conversationId 
     * @param {number} [limit] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEbutilitiesConversationsConversationIdMessagesGet(conversationId: number, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return EBUtilitiesApiFp(this.configuration).apiEbutilitiesConversationsConversationIdMessagesGet(conversationId, limit, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {MessageDtoRowsRequestDto} [messageDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEbutilitiesMessagesAllPost(apiVersion?: string, messageDtoRowsRequestDto?: MessageDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return EBUtilitiesApiFp(this.configuration).apiEbutilitiesMessagesAllPost(apiVersion, messageDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEbutilitiesMessagesIdMarkResolvedPut(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return EBUtilitiesApiFp(this.configuration).apiEbutilitiesMessagesIdMarkResolvedPut(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEbutilitiesMessagesIdNoteDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return EBUtilitiesApiFp(this.configuration).apiEbutilitiesMessagesIdNoteDelete(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {string} [note] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEbutilitiesMessagesIdNotePost(id: number, apiVersion?: string, note?: string, options?: RawAxiosRequestConfig) {
        return EBUtilitiesApiFp(this.configuration).apiEbutilitiesMessagesIdNotePost(id, apiVersion, note, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {string} [updatedNote] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEbutilitiesMessagesIdNotePut(id: number, apiVersion?: string, updatedNote?: string, options?: RawAxiosRequestConfig) {
        return EBUtilitiesApiFp(this.configuration).apiEbutilitiesMessagesIdNotePut(id, apiVersion, updatedNote, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEbutilitiesMessagesIdNotesGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return EBUtilitiesApiFp(this.configuration).apiEbutilitiesMessagesIdNotesGet(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEbutilitiesMessagesIdPayloadGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return EBUtilitiesApiFp(this.configuration).apiEbutilitiesMessagesIdPayloadGet(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MessageIssueType} [msgIssueType] 
     * @param {string} [apiVersion] 
     * @param {MessageDtoRowsRequestDto} [messageDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEbutilitiesMessagesPost(msgIssueType?: MessageIssueType, apiVersion?: string, messageDtoRowsRequestDto?: MessageDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return EBUtilitiesApiFp(this.configuration).apiEbutilitiesMessagesPost(msgIssueType, apiVersion, messageDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EcsfPlatformApi - axios parameter creator
 */
export const EcsfPlatformApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsPathGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/assets/{path}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workboxFilenameGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/workbox-{filename}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EcsfPlatformApi - functional programming interface
 */
export const EcsfPlatformApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EcsfPlatformApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetsPathGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetsPathGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EcsfPlatformApi.assetsPathGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workboxFilenameGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workboxFilenameGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EcsfPlatformApi.workboxFilenameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EcsfPlatformApi - factory interface
 */
export const EcsfPlatformApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EcsfPlatformApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsPathGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assetsPathGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workboxFilenameGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.workboxFilenameGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EcsfPlatformApi - object-oriented interface
 */
export class EcsfPlatformApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assetsPathGet(options?: RawAxiosRequestConfig) {
        return EcsfPlatformApiFp(this.configuration).assetsPathGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public workboxFilenameGet(options?: RawAxiosRequestConfig) {
        return EcsfPlatformApiFp(this.configuration).workboxFilenameGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EnergyCommunityApi - axios parameter creator
 */
export const EnergyCommunityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityAllGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energycommunity/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {EnergyCommunityDtoRowsRequestDto} [energyCommunityDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityAllPost: async (apiVersion?: string, energyCommunityDtoRowsRequestDto?: EnergyCommunityDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energycommunity/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(energyCommunityDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {ECCreateRequestDto} [eCCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityCreatePost: async (apiVersion?: string, eCCreateRequestDto?: ECCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energycommunity/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eCCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [energyCommunityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityDeactivatePost: async (apiVersion?: string, energyCommunityIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energycommunity/deactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (energyCommunityIds) {
                energyCommunityIds.forEach((element) => {
                    localVarFormParams.append('energyCommunityIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [energyCommunityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityDeletePost: async (apiVersion?: string, energyCommunityIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energycommunity/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (energyCommunityIds) {
                energyCommunityIds.forEach((element) => {
                    localVarFormParams.append('energyCommunityIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityUpdatePost: async (apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energycommunity/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(int32TableChangesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityUserGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energycommunity/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnergyCommunityApi - functional programming interface
 */
export const EnergyCommunityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnergyCommunityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergycommunityAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ECDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergycommunityAllGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyCommunityApi.apiEnergycommunityAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {EnergyCommunityDtoRowsRequestDto} [energyCommunityDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergycommunityAllPost(apiVersion?: string, energyCommunityDtoRowsRequestDto?: EnergyCommunityDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnergyCommunityDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergycommunityAllPost(apiVersion, energyCommunityDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyCommunityApi.apiEnergycommunityAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {ECCreateRequestDto} [eCCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergycommunityCreatePost(apiVersion?: string, eCCreateRequestDto?: ECCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergycommunityCreatePost(apiVersion, eCCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyCommunityApi.apiEnergycommunityCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [energyCommunityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergycommunityDeactivatePost(apiVersion?: string, energyCommunityIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergycommunityDeactivatePost(apiVersion, energyCommunityIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyCommunityApi.apiEnergycommunityDeactivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [energyCommunityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergycommunityDeletePost(apiVersion?: string, energyCommunityIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergycommunityDeletePost(apiVersion, energyCommunityIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyCommunityApi.apiEnergycommunityDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergycommunityUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergycommunityUpdatePost(apiVersion, int32TableChangesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyCommunityApi.apiEnergycommunityUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergycommunityUserGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ECDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergycommunityUserGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyCommunityApi.apiEnergycommunityUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnergyCommunityApi - factory interface
 */
export const EnergyCommunityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnergyCommunityApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ECDto>> {
            return localVarFp.apiEnergycommunityAllGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {EnergyCommunityDtoRowsRequestDto} [energyCommunityDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityAllPost(apiVersion?: string, energyCommunityDtoRowsRequestDto?: EnergyCommunityDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EnergyCommunityDtoRowsResponseDto> {
            return localVarFp.apiEnergycommunityAllPost(apiVersion, energyCommunityDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {ECCreateRequestDto} [eCCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityCreatePost(apiVersion?: string, eCCreateRequestDto?: ECCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiEnergycommunityCreatePost(apiVersion, eCCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [energyCommunityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityDeactivatePost(apiVersion?: string, energyCommunityIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiEnergycommunityDeactivatePost(apiVersion, energyCommunityIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [energyCommunityIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityDeletePost(apiVersion?: string, energyCommunityIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiEnergycommunityDeletePost(apiVersion, energyCommunityIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiEnergycommunityUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergycommunityUserGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ECDto>> {
            return localVarFp.apiEnergycommunityUserGet(apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnergyCommunityApi - object-oriented interface
 */
export class EnergyCommunityApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergycommunityAllGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return EnergyCommunityApiFp(this.configuration).apiEnergycommunityAllGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {EnergyCommunityDtoRowsRequestDto} [energyCommunityDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergycommunityAllPost(apiVersion?: string, energyCommunityDtoRowsRequestDto?: EnergyCommunityDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return EnergyCommunityApiFp(this.configuration).apiEnergycommunityAllPost(apiVersion, energyCommunityDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {ECCreateRequestDto} [eCCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergycommunityCreatePost(apiVersion?: string, eCCreateRequestDto?: ECCreateRequestDto, options?: RawAxiosRequestConfig) {
        return EnergyCommunityApiFp(this.configuration).apiEnergycommunityCreatePost(apiVersion, eCCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [energyCommunityIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergycommunityDeactivatePost(apiVersion?: string, energyCommunityIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return EnergyCommunityApiFp(this.configuration).apiEnergycommunityDeactivatePost(apiVersion, energyCommunityIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [energyCommunityIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergycommunityDeletePost(apiVersion?: string, energyCommunityIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return EnergyCommunityApiFp(this.configuration).apiEnergycommunityDeletePost(apiVersion, energyCommunityIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergycommunityUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig) {
        return EnergyCommunityApiFp(this.configuration).apiEnergycommunityUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergycommunityUserGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return EnergyCommunityApiFp(this.configuration).apiEnergycommunityUserGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EnergyDataApi - axios parameter creator
 */
export const EnergyDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {AggregationResolution} [resolution] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataEnergyCommunitiesAggregatedAdminPost: async (apiVersion?: string, from?: string, to?: string, resolution?: AggregationResolution, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energydata/energy-communities/aggregated/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (from !== undefined) { 
                localVarFormParams.append('from', from as any);
            }

            if (to !== undefined) { 
                localVarFormParams.append('to', to as any);
            }

            if (resolution !== undefined) { 
                localVarFormParams.append('resolution', resolution as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {AggregationResolution} [resolution] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataEnergyCommunitiesAggregatedPost: async (apiVersion?: string, ids?: Set<number>, from?: string, to?: string, resolution?: AggregationResolution, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energydata/energy-communities/aggregated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (ids) {
                ids.forEach((element) => {
                    localVarFormParams.append('ids', element as any);
                })
            }


            if (from !== undefined) { 
                localVarFormParams.append('from', from as any);
            }

            if (to !== undefined) { 
                localVarFormParams.append('to', to as any);
            }

            if (resolution !== undefined) { 
                localVarFormParams.append('resolution', resolution as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataEnergyCommunitiesDetailedExportPost: async (from?: string, to?: string, apiVersion?: string, ids?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energydata/energy-communities/detailed/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (ids) {
                ids.forEach((element) => {
                    localVarFormParams.append('ids', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataEnergyCommunitiesExportPost: async (from?: string, to?: string, apiVersion?: string, ids?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energydata/energy-communities/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (ids) {
                ids.forEach((element) => {
                    localVarFormParams.append('ids', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataEnergyCommunitiesPost: async (apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energydata/energy-communities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (ids) {
                ids.forEach((element) => {
                    localVarFormParams.append('ids', element as any);
                })
            }


            if (from !== undefined) { 
                localVarFormParams.append('from', from as any);
            }

            if (to !== undefined) { 
                localVarFormParams.append('to', to as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataExportsActiveGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energydata/exports/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointContractMeteringPointContractIdEnergyDataRequestsGet: async (meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meteringPointContractId' is not null or undefined
            assertParamExists('apiEnergydataMeteringPointContractMeteringPointContractIdEnergyDataRequestsGet', 'meteringPointContractId', meteringPointContractId)
            const localVarPath = `/api/energydata/metering-point-contract/{meteringPointContractId}/energy-data-requests`
                .replace('{meteringPointContractId}', encodeURIComponent(String(meteringPointContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointContractMeteringPointContractIdExportPost: async (meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meteringPointContractId' is not null or undefined
            assertParamExists('apiEnergydataMeteringPointContractMeteringPointContractIdExportPost', 'meteringPointContractId', meteringPointContractId)
            const localVarPath = `/api/energydata/metering-point-contract/{meteringPointContractId}/export`
                .replace('{meteringPointContractId}', encodeURIComponent(String(meteringPointContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointContractMeteringPointContractIdInfoPost: async (meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meteringPointContractId' is not null or undefined
            assertParamExists('apiEnergydataMeteringPointContractMeteringPointContractIdInfoPost', 'meteringPointContractId', meteringPointContractId)
            const localVarPath = `/api/energydata/metering-point-contract/{meteringPointContractId}/info`
                .replace('{meteringPointContractId}', encodeURIComponent(String(meteringPointContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointContractMeteringPointContractIdUserExportPost: async (meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meteringPointContractId' is not null or undefined
            assertParamExists('apiEnergydataMeteringPointContractMeteringPointContractIdUserExportPost', 'meteringPointContractId', meteringPointContractId)
            const localVarPath = `/api/energydata/metering-point-contract/{meteringPointContractId}/user-export`
                .replace('{meteringPointContractId}', encodeURIComponent(String(meteringPointContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointContractsAdminPost: async (apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energydata/metering-point-contracts/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (ids) {
                ids.forEach((element) => {
                    localVarFormParams.append('ids', element as any);
                })
            }


            if (from !== undefined) { 
                localVarFormParams.append('from', from as any);
            }

            if (to !== undefined) { 
                localVarFormParams.append('to', to as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointContractsPost: async (apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energydata/metering-point-contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (ids) {
                ids.forEach((element) => {
                    localVarFormParams.append('ids', element as any);
                })
            }


            if (from !== undefined) { 
                localVarFormParams.append('from', from as any);
            }

            if (to !== undefined) { 
                localVarFormParams.append('to', to as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointsPost: async (apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energydata/metering-points`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (ids) {
                ids.forEach((element) => {
                    localVarFormParams.append('ids', element as any);
                })
            }


            if (from !== undefined) { 
                localVarFormParams.append('from', from as any);
            }

            if (to !== undefined) { 
                localVarFormParams.append('to', to as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {EnergyDataRequestTargetEnergyCommunitiesDto} [energyDataRequestTargetEnergyCommunitiesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataRequestTargetEnergyCommunitiesPost: async (apiVersion?: string, energyDataRequestTargetEnergyCommunitiesDto?: EnergyDataRequestTargetEnergyCommunitiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energydata/request-target/energy-communities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(energyDataRequestTargetEnergyCommunitiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {EnergyDataRequestTargetMeteringPointContractsDto} [energyDataRequestTargetMeteringPointContractsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataRequestTargetMeteringPointContractsPost: async (apiVersion?: string, energyDataRequestTargetMeteringPointContractsDto?: EnergyDataRequestTargetMeteringPointContractsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/energydata/request-target/metering-point-contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(energyDataRequestTargetMeteringPointContractsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnergyDataApi - functional programming interface
 */
export const EnergyDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnergyDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {AggregationResolution} [resolution] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataEnergyCommunitiesAggregatedAdminPost(apiVersion?: string, from?: string, to?: string, resolution?: AggregationResolution, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnergyCommunityAggregatedDataAdminDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataEnergyCommunitiesAggregatedAdminPost(apiVersion, from, to, resolution, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataEnergyCommunitiesAggregatedAdminPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {AggregationResolution} [resolution] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataEnergyCommunitiesAggregatedPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, resolution?: AggregationResolution, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnergyCommunityAggregatedDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataEnergyCommunitiesAggregatedPost(apiVersion, ids, from, to, resolution, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataEnergyCommunitiesAggregatedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataEnergyCommunitiesDetailedExportPost(from?: string, to?: string, apiVersion?: string, ids?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataEnergyCommunitiesDetailedExportPost(from, to, apiVersion, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataEnergyCommunitiesDetailedExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataEnergyCommunitiesExportPost(from?: string, to?: string, apiVersion?: string, ids?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataEnergyCommunitiesExportPost(from, to, apiVersion, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataEnergyCommunitiesExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataEnergyCommunitiesPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnergyDataAggregateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataEnergyCommunitiesPost(apiVersion, ids, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataEnergyCommunitiesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataExportsActiveGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnergyDataExportStatusDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataExportsActiveGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataExportsActiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataMeteringPointContractMeteringPointContractIdEnergyDataRequestsGet(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnergyDataSingleRequestDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataMeteringPointContractMeteringPointContractIdEnergyDataRequestsGet(meteringPointContractId, from, to, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataMeteringPointContractMeteringPointContractIdEnergyDataRequestsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataMeteringPointContractMeteringPointContractIdExportPost(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataMeteringPointContractMeteringPointContractIdExportPost(meteringPointContractId, from, to, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataMeteringPointContractMeteringPointContractIdExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataMeteringPointContractMeteringPointContractIdInfoPost(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnergyDataStateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataMeteringPointContractMeteringPointContractIdInfoPost(meteringPointContractId, from, to, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataMeteringPointContractMeteringPointContractIdInfoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataMeteringPointContractMeteringPointContractIdUserExportPost(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataMeteringPointContractMeteringPointContractIdUserExportPost(meteringPointContractId, from, to, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataMeteringPointContractMeteringPointContractIdUserExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataMeteringPointContractsAdminPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnergyDataAggregateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataMeteringPointContractsAdminPost(apiVersion, ids, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataMeteringPointContractsAdminPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataMeteringPointContractsPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnergyDataAggregateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataMeteringPointContractsPost(apiVersion, ids, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataMeteringPointContractsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataMeteringPointsPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnergyDataAggregateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataMeteringPointsPost(apiVersion, ids, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataMeteringPointsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {EnergyDataRequestTargetEnergyCommunitiesDto} [energyDataRequestTargetEnergyCommunitiesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataRequestTargetEnergyCommunitiesPost(apiVersion?: string, energyDataRequestTargetEnergyCommunitiesDto?: EnergyDataRequestTargetEnergyCommunitiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataRequestTargetEnergyCommunitiesPost(apiVersion, energyDataRequestTargetEnergyCommunitiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataRequestTargetEnergyCommunitiesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {EnergyDataRequestTargetMeteringPointContractsDto} [energyDataRequestTargetMeteringPointContractsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnergydataRequestTargetMeteringPointContractsPost(apiVersion?: string, energyDataRequestTargetMeteringPointContractsDto?: EnergyDataRequestTargetMeteringPointContractsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnergydataRequestTargetMeteringPointContractsPost(apiVersion, energyDataRequestTargetMeteringPointContractsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnergyDataApi.apiEnergydataRequestTargetMeteringPointContractsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnergyDataApi - factory interface
 */
export const EnergyDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnergyDataApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {AggregationResolution} [resolution] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataEnergyCommunitiesAggregatedAdminPost(apiVersion?: string, from?: string, to?: string, resolution?: AggregationResolution, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnergyCommunityAggregatedDataAdminDto>> {
            return localVarFp.apiEnergydataEnergyCommunitiesAggregatedAdminPost(apiVersion, from, to, resolution, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {AggregationResolution} [resolution] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataEnergyCommunitiesAggregatedPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, resolution?: AggregationResolution, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnergyCommunityAggregatedDataDto>> {
            return localVarFp.apiEnergydataEnergyCommunitiesAggregatedPost(apiVersion, ids, from, to, resolution, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataEnergyCommunitiesDetailedExportPost(from?: string, to?: string, apiVersion?: string, ids?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiEnergydataEnergyCommunitiesDetailedExportPost(from, to, apiVersion, ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataEnergyCommunitiesExportPost(from?: string, to?: string, apiVersion?: string, ids?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiEnergydataEnergyCommunitiesExportPost(from, to, apiVersion, ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataEnergyCommunitiesPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnergyDataAggregateDto>> {
            return localVarFp.apiEnergydataEnergyCommunitiesPost(apiVersion, ids, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataExportsActiveGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnergyDataExportStatusDto>> {
            return localVarFp.apiEnergydataExportsActiveGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointContractMeteringPointContractIdEnergyDataRequestsGet(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnergyDataSingleRequestDto>> {
            return localVarFp.apiEnergydataMeteringPointContractMeteringPointContractIdEnergyDataRequestsGet(meteringPointContractId, from, to, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointContractMeteringPointContractIdExportPost(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiEnergydataMeteringPointContractMeteringPointContractIdExportPost(meteringPointContractId, from, to, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointContractMeteringPointContractIdInfoPost(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnergyDataStateDto>> {
            return localVarFp.apiEnergydataMeteringPointContractMeteringPointContractIdInfoPost(meteringPointContractId, from, to, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointContractMeteringPointContractIdUserExportPost(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiEnergydataMeteringPointContractMeteringPointContractIdUserExportPost(meteringPointContractId, from, to, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointContractsAdminPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnergyDataAggregateDto>> {
            return localVarFp.apiEnergydataMeteringPointContractsAdminPost(apiVersion, ids, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointContractsPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnergyDataAggregateDto>> {
            return localVarFp.apiEnergydataMeteringPointContractsPost(apiVersion, ids, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [ids] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataMeteringPointsPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EnergyDataAggregateDto>> {
            return localVarFp.apiEnergydataMeteringPointsPost(apiVersion, ids, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {EnergyDataRequestTargetEnergyCommunitiesDto} [energyDataRequestTargetEnergyCommunitiesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataRequestTargetEnergyCommunitiesPost(apiVersion?: string, energyDataRequestTargetEnergyCommunitiesDto?: EnergyDataRequestTargetEnergyCommunitiesDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiEnergydataRequestTargetEnergyCommunitiesPost(apiVersion, energyDataRequestTargetEnergyCommunitiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {EnergyDataRequestTargetMeteringPointContractsDto} [energyDataRequestTargetMeteringPointContractsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnergydataRequestTargetMeteringPointContractsPost(apiVersion?: string, energyDataRequestTargetMeteringPointContractsDto?: EnergyDataRequestTargetMeteringPointContractsDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiEnergydataRequestTargetMeteringPointContractsPost(apiVersion, energyDataRequestTargetMeteringPointContractsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnergyDataApi - object-oriented interface
 */
export class EnergyDataApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {AggregationResolution} [resolution] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataEnergyCommunitiesAggregatedAdminPost(apiVersion?: string, from?: string, to?: string, resolution?: AggregationResolution, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataEnergyCommunitiesAggregatedAdminPost(apiVersion, from, to, resolution, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [ids] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {AggregationResolution} [resolution] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataEnergyCommunitiesAggregatedPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, resolution?: AggregationResolution, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataEnergyCommunitiesAggregatedPost(apiVersion, ids, from, to, resolution, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataEnergyCommunitiesDetailedExportPost(from?: string, to?: string, apiVersion?: string, ids?: Set<number>, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataEnergyCommunitiesDetailedExportPost(from, to, apiVersion, ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataEnergyCommunitiesExportPost(from?: string, to?: string, apiVersion?: string, ids?: Set<number>, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataEnergyCommunitiesExportPost(from, to, apiVersion, ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [ids] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataEnergyCommunitiesPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataEnergyCommunitiesPost(apiVersion, ids, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataExportsActiveGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataExportsActiveGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} meteringPointContractId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataMeteringPointContractMeteringPointContractIdEnergyDataRequestsGet(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataMeteringPointContractMeteringPointContractIdEnergyDataRequestsGet(meteringPointContractId, from, to, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} meteringPointContractId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataMeteringPointContractMeteringPointContractIdExportPost(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataMeteringPointContractMeteringPointContractIdExportPost(meteringPointContractId, from, to, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} meteringPointContractId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataMeteringPointContractMeteringPointContractIdInfoPost(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataMeteringPointContractMeteringPointContractIdInfoPost(meteringPointContractId, from, to, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} meteringPointContractId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataMeteringPointContractMeteringPointContractIdUserExportPost(meteringPointContractId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataMeteringPointContractMeteringPointContractIdUserExportPost(meteringPointContractId, from, to, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [ids] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataMeteringPointContractsAdminPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataMeteringPointContractsAdminPost(apiVersion, ids, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [ids] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataMeteringPointContractsPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataMeteringPointContractsPost(apiVersion, ids, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [ids] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataMeteringPointsPost(apiVersion?: string, ids?: Set<number>, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataMeteringPointsPost(apiVersion, ids, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {EnergyDataRequestTargetEnergyCommunitiesDto} [energyDataRequestTargetEnergyCommunitiesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataRequestTargetEnergyCommunitiesPost(apiVersion?: string, energyDataRequestTargetEnergyCommunitiesDto?: EnergyDataRequestTargetEnergyCommunitiesDto, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataRequestTargetEnergyCommunitiesPost(apiVersion, energyDataRequestTargetEnergyCommunitiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {EnergyDataRequestTargetMeteringPointContractsDto} [energyDataRequestTargetMeteringPointContractsDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEnergydataRequestTargetMeteringPointContractsPost(apiVersion?: string, energyDataRequestTargetMeteringPointContractsDto?: EnergyDataRequestTargetMeteringPointContractsDto, options?: RawAxiosRequestConfig) {
        return EnergyDataApiFp(this.configuration).apiEnergydataRequestTargetMeteringPointContractsPost(apiVersion, energyDataRequestTargetMeteringPointContractsDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GridApi - axios parameter creator
 */
export const GridApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridOperatorsGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/grid/operators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridOperatorsSearchGet: async (query?: string, limit?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/grid/operators/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridSubstationsGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/grid/substations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [ssId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridSubstationsPost: async (apiVersion?: string, ssId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/grid/substations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (ssId !== undefined) { 
                localVarFormParams.append('ssId', ssId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridSubstationsSearchGet: async (query?: string, limit?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/grid/substations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridTransformersGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/grid/transformers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [tfId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridTransformersPost: async (apiVersion?: string, tfId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/grid/transformers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (tfId !== undefined) { 
                localVarFormParams.append('tfId', tfId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridTransformersSearchGet: async (query?: string, limit?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/grid/transformers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridApi - functional programming interface
 */
export const GridApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridOperatorsGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GridOperatorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridOperatorsGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.apiGridOperatorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridOperatorsSearchGet(query?: string, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GridOperatorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridOperatorsSearchGet(query, limit, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.apiGridOperatorsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridSubstationsGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GridSubstationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridSubstationsGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.apiGridSubstationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [ssId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridSubstationsPost(apiVersion?: string, ssId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GridSubstationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridSubstationsPost(apiVersion, ssId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.apiGridSubstationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridSubstationsSearchGet(query?: string, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GridSubstationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridSubstationsSearchGet(query, limit, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.apiGridSubstationsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridTransformersGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GridTransformerDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridTransformersGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.apiGridTransformersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [tfId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridTransformersPost(apiVersion?: string, tfId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GridSubstationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridTransformersPost(apiVersion, tfId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.apiGridTransformersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridTransformersSearchGet(query?: string, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GridTransformerDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridTransformersSearchGet(query, limit, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.apiGridTransformersSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GridApi - factory interface
 */
export const GridApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridOperatorsGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GridOperatorDto>> {
            return localVarFp.apiGridOperatorsGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridOperatorsSearchGet(query?: string, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GridOperatorDto>> {
            return localVarFp.apiGridOperatorsSearchGet(query, limit, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridSubstationsGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GridSubstationDto>> {
            return localVarFp.apiGridSubstationsGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [ssId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridSubstationsPost(apiVersion?: string, ssId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GridSubstationDto>> {
            return localVarFp.apiGridSubstationsPost(apiVersion, ssId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridSubstationsSearchGet(query?: string, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GridSubstationDto>> {
            return localVarFp.apiGridSubstationsSearchGet(query, limit, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridTransformersGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GridTransformerDto>> {
            return localVarFp.apiGridTransformersGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [tfId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridTransformersPost(apiVersion?: string, tfId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GridSubstationDto>> {
            return localVarFp.apiGridTransformersPost(apiVersion, tfId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridTransformersSearchGet(query?: string, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GridTransformerDto>> {
            return localVarFp.apiGridTransformersSearchGet(query, limit, apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridApi - object-oriented interface
 */
export class GridApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridOperatorsGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).apiGridOperatorsGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [query] 
     * @param {number} [limit] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridOperatorsSearchGet(query?: string, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).apiGridOperatorsSearchGet(query, limit, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridSubstationsGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).apiGridSubstationsGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {string} [ssId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridSubstationsPost(apiVersion?: string, ssId?: string, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).apiGridSubstationsPost(apiVersion, ssId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [query] 
     * @param {number} [limit] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridSubstationsSearchGet(query?: string, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).apiGridSubstationsSearchGet(query, limit, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridTransformersGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).apiGridTransformersGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {string} [tfId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridTransformersPost(apiVersion?: string, tfId?: string, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).apiGridTransformersPost(apiVersion, tfId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [query] 
     * @param {number} [limit] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridTransformersSearchGet(query?: string, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).apiGridTransformersSearchGet(query, limit, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GridOperatorApi - axios parameter creator
 */
export const GridOperatorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridoperatorAllGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gridoperator/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {GridOperatorDtoRowsRequestDto} [gridOperatorDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridoperatorAllPost: async (apiVersion?: string, gridOperatorDtoRowsRequestDto?: GridOperatorDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gridoperator/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gridOperatorDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {GridOperatorCreateRequestDto} [gridOperatorCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridoperatorCreatePost: async (apiVersion?: string, gridOperatorCreateRequestDto?: GridOperatorCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gridoperator/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gridOperatorCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [gridOperatorIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridoperatorDeletePost: async (apiVersion?: string, gridOperatorIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gridoperator/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (gridOperatorIds) {
                gridOperatorIds.forEach((element) => {
                    localVarFormParams.append('gridOperatorIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridoperatorUpdatePost: async (apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gridoperator/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(int32TableChangesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridOperatorApi - functional programming interface
 */
export const GridOperatorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridOperatorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridoperatorAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GridOperatorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridoperatorAllGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridOperatorApi.apiGridoperatorAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {GridOperatorDtoRowsRequestDto} [gridOperatorDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridoperatorAllPost(apiVersion?: string, gridOperatorDtoRowsRequestDto?: GridOperatorDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridOperatorDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridoperatorAllPost(apiVersion, gridOperatorDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridOperatorApi.apiGridoperatorAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {GridOperatorCreateRequestDto} [gridOperatorCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridoperatorCreatePost(apiVersion?: string, gridOperatorCreateRequestDto?: GridOperatorCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridoperatorCreatePost(apiVersion, gridOperatorCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridOperatorApi.apiGridoperatorCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [gridOperatorIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridoperatorDeletePost(apiVersion?: string, gridOperatorIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridoperatorDeletePost(apiVersion, gridOperatorIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridOperatorApi.apiGridoperatorDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGridoperatorUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGridoperatorUpdatePost(apiVersion, int32TableChangesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridOperatorApi.apiGridoperatorUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GridOperatorApi - factory interface
 */
export const GridOperatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridOperatorApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridoperatorAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GridOperatorDto>> {
            return localVarFp.apiGridoperatorAllGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {GridOperatorDtoRowsRequestDto} [gridOperatorDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridoperatorAllPost(apiVersion?: string, gridOperatorDtoRowsRequestDto?: GridOperatorDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GridOperatorDtoRowsResponseDto> {
            return localVarFp.apiGridoperatorAllPost(apiVersion, gridOperatorDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {GridOperatorCreateRequestDto} [gridOperatorCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridoperatorCreatePost(apiVersion?: string, gridOperatorCreateRequestDto?: GridOperatorCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiGridoperatorCreatePost(apiVersion, gridOperatorCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [gridOperatorIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridoperatorDeletePost(apiVersion?: string, gridOperatorIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiGridoperatorDeletePost(apiVersion, gridOperatorIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGridoperatorUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiGridoperatorUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridOperatorApi - object-oriented interface
 */
export class GridOperatorApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridoperatorAllGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return GridOperatorApiFp(this.configuration).apiGridoperatorAllGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {GridOperatorDtoRowsRequestDto} [gridOperatorDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridoperatorAllPost(apiVersion?: string, gridOperatorDtoRowsRequestDto?: GridOperatorDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return GridOperatorApiFp(this.configuration).apiGridoperatorAllPost(apiVersion, gridOperatorDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {GridOperatorCreateRequestDto} [gridOperatorCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridoperatorCreatePost(apiVersion?: string, gridOperatorCreateRequestDto?: GridOperatorCreateRequestDto, options?: RawAxiosRequestConfig) {
        return GridOperatorApiFp(this.configuration).apiGridoperatorCreatePost(apiVersion, gridOperatorCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [gridOperatorIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridoperatorDeletePost(apiVersion?: string, gridOperatorIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return GridOperatorApiFp(this.configuration).apiGridoperatorDeletePost(apiVersion, gridOperatorIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiGridoperatorUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig) {
        return GridOperatorApiFp(this.configuration).apiGridoperatorUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IdentityApi - axios parameter creator
 */
export const IdentityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {ForgotPasswordRequest} [forgotPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityForgotpasswordPost: async (apiVersion?: string, forgotPasswordRequest?: ForgotPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/forgotpassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [useCookies] 
         * @param {boolean} [useSessionCookies] 
         * @param {string} [apiVersion] 
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityLoginPost: async (useCookies?: boolean, useSessionCookies?: boolean, apiVersion?: string, loginRequest?: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (useCookies !== undefined) {
                localVarQueryParameter['useCookies'] = useCookies;
            }

            if (useSessionCookies !== undefined) {
                localVarQueryParameter['useSessionCookies'] = useSessionCookies;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {RegisterRequest} [registerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRegisterPost: async (apiVersion?: string, registerRequest?: RegisterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {ResetPasswordRequest} [resetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityResetpasswordPost: async (apiVersion?: string, resetPasswordRequest?: ResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/resetpassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IdentityApi - functional programming interface
 */
export const IdentityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IdentityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {ForgotPasswordRequest} [forgotPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityForgotpasswordPost(apiVersion?: string, forgotPasswordRequest?: ForgotPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityForgotpasswordPost(apiVersion, forgotPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentityApi.apiIdentityForgotpasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [useCookies] 
         * @param {boolean} [useSessionCookies] 
         * @param {string} [apiVersion] 
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityLoginPost(useCookies?: boolean, useSessionCookies?: boolean, apiVersion?: string, loginRequest?: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityLoginPost(useCookies, useSessionCookies, apiVersion, loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentityApi.apiIdentityLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {RegisterRequest} [registerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRegisterPost(apiVersion?: string, registerRequest?: RegisterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRegisterPost(apiVersion, registerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentityApi.apiIdentityRegisterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {ResetPasswordRequest} [resetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityResetpasswordPost(apiVersion?: string, resetPasswordRequest?: ResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityResetpasswordPost(apiVersion, resetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentityApi.apiIdentityResetpasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IdentityApi - factory interface
 */
export const IdentityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IdentityApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {ForgotPasswordRequest} [forgotPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityForgotpasswordPost(apiVersion?: string, forgotPasswordRequest?: ForgotPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiIdentityForgotpasswordPost(apiVersion, forgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [useCookies] 
         * @param {boolean} [useSessionCookies] 
         * @param {string} [apiVersion] 
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityLoginPost(useCookies?: boolean, useSessionCookies?: boolean, apiVersion?: string, loginRequest?: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiIdentityLoginPost(useCookies, useSessionCookies, apiVersion, loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {RegisterRequest} [registerRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRegisterPost(apiVersion?: string, registerRequest?: RegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiIdentityRegisterPost(apiVersion, registerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {ResetPasswordRequest} [resetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityResetpasswordPost(apiVersion?: string, resetPasswordRequest?: ResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiIdentityResetpasswordPost(apiVersion, resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IdentityApi - object-oriented interface
 */
export class IdentityApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {ForgotPasswordRequest} [forgotPasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiIdentityForgotpasswordPost(apiVersion?: string, forgotPasswordRequest?: ForgotPasswordRequest, options?: RawAxiosRequestConfig) {
        return IdentityApiFp(this.configuration).apiIdentityForgotpasswordPost(apiVersion, forgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [useCookies] 
     * @param {boolean} [useSessionCookies] 
     * @param {string} [apiVersion] 
     * @param {LoginRequest} [loginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiIdentityLoginPost(useCookies?: boolean, useSessionCookies?: boolean, apiVersion?: string, loginRequest?: LoginRequest, options?: RawAxiosRequestConfig) {
        return IdentityApiFp(this.configuration).apiIdentityLoginPost(useCookies, useSessionCookies, apiVersion, loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {RegisterRequest} [registerRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiIdentityRegisterPost(apiVersion?: string, registerRequest?: RegisterRequest, options?: RawAxiosRequestConfig) {
        return IdentityApiFp(this.configuration).apiIdentityRegisterPost(apiVersion, registerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {ResetPasswordRequest} [resetPasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiIdentityResetpasswordPost(apiVersion?: string, resetPasswordRequest?: ResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return IdentityApiFp(this.configuration).apiIdentityResetpasswordPost(apiVersion, resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoiceApi - axios parameter creator
 */
export const InvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {InvoiceDtoRowsRequestDto} [invoiceDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceAllPost: async (apiVersion?: string, invoiceDtoRowsRequestDto?: InvoiceDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invoice/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoiceDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {boolean} [paymentPending] 
         * @param {number} [numOfRows] 
         * @param {number} [skipRows] 
         * @param {number} [ecId] 
         * @param {string} [search] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceControllingMatrixPost: async (from?: string, to?: string, paymentPending?: boolean, numOfRows?: number, skipRows?: number, ecId?: number, search?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invoice/controlling-matrix`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (paymentPending !== undefined) {
                localVarQueryParameter['paymentPending'] = paymentPending;
            }

            if (numOfRows !== undefined) {
                localVarQueryParameter['numOfRows'] = numOfRows;
            }

            if (skipRows !== undefined) {
                localVarQueryParameter['skipRows'] = skipRows;
            }

            if (ecId !== undefined) {
                localVarQueryParameter['ecId'] = ecId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {CreateInvoicesRequestDto} [createInvoicesRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceCreatePost: async (apiVersion?: string, createInvoicesRequestDto?: CreateInvoicesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invoice/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoicesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceDownloadBulkPost: async (apiVersion?: string, requestBody?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invoice/download-bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceEcEnergyCommunityIdInvoiceNumberConfigGet: async (energyCommunityId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'energyCommunityId' is not null or undefined
            assertParamExists('apiInvoiceEcEnergyCommunityIdInvoiceNumberConfigGet', 'energyCommunityId', energyCommunityId)
            const localVarPath = `/api/invoice/ec/{energyCommunityId}/invoice-number-config`
                .replace('{energyCommunityId}', encodeURIComponent(String(energyCommunityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceEcEnergyCommunityIdOverlappingGet: async (energyCommunityId: number, from?: string, to?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'energyCommunityId' is not null or undefined
            assertParamExists('apiInvoiceEcEnergyCommunityIdOverlappingGet', 'energyCommunityId', energyCommunityId)
            const localVarPath = `/api/invoice/ec/{energyCommunityId}/overlapping`
                .replace('{energyCommunityId}', encodeURIComponent(String(energyCommunityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceIdDownloadGet: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInvoiceIdDownloadGet', 'id', id)
            const localVarPath = `/api/invoice/{id}/download`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceIdUserDownloadGet: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInvoiceIdUserDownloadGet', 'id', id)
            const localVarPath = `/api/invoice/{id}/user/download`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceUpdatePost: async (apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invoice/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(int32TableChangesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceUserDownloadBulkPost: async (apiVersion?: string, requestBody?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invoice/user/download-bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [memberContractId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceUserGet: async (memberContractId?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invoice/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (memberContractId !== undefined) {
                localVarQueryParameter['memberContractId'] = memberContractId;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceApi - functional programming interface
 */
export const InvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {InvoiceDtoRowsRequestDto} [invoiceDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceAllPost(apiVersion?: string, invoiceDtoRowsRequestDto?: InvoiceDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceAllPost(apiVersion, invoiceDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiInvoiceAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {boolean} [paymentPending] 
         * @param {number} [numOfRows] 
         * @param {number} [skipRows] 
         * @param {number} [ecId] 
         * @param {string} [search] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceControllingMatrixPost(from?: string, to?: string, paymentPending?: boolean, numOfRows?: number, skipRows?: number, ecId?: number, search?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceControllingRowDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceControllingMatrixPost(from, to, paymentPending, numOfRows, skipRows, ecId, search, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiInvoiceControllingMatrixPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {CreateInvoicesRequestDto} [createInvoicesRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceCreatePost(apiVersion?: string, createInvoicesRequestDto?: CreateInvoicesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceCreatePost(apiVersion, createInvoicesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiInvoiceCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceDownloadBulkPost(apiVersion?: string, requestBody?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceDownloadBulkPost(apiVersion, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiInvoiceDownloadBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceEcEnergyCommunityIdInvoiceNumberConfigGet(energyCommunityId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceNumberConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceEcEnergyCommunityIdInvoiceNumberConfigGet(energyCommunityId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiInvoiceEcEnergyCommunityIdInvoiceNumberConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceEcEnergyCommunityIdOverlappingGet(energyCommunityId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OverlappingInvoiceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceEcEnergyCommunityIdOverlappingGet(energyCommunityId, from, to, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiInvoiceEcEnergyCommunityIdOverlappingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceIdDownloadGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceIdDownloadGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiInvoiceIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceIdUserDownloadGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceIdUserDownloadGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiInvoiceIdUserDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceUpdatePost(apiVersion, int32TableChangesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiInvoiceUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceUserDownloadBulkPost(apiVersion?: string, requestBody?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceUserDownloadBulkPost(apiVersion, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiInvoiceUserDownloadBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [memberContractId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvoiceUserGet(memberContractId?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserInvoiceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvoiceUserGet(memberContractId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiInvoiceUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoiceApi - factory interface
 */
export const InvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {InvoiceDtoRowsRequestDto} [invoiceDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceAllPost(apiVersion?: string, invoiceDtoRowsRequestDto?: InvoiceDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceDtoRowsResponseDto> {
            return localVarFp.apiInvoiceAllPost(apiVersion, invoiceDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {boolean} [paymentPending] 
         * @param {number} [numOfRows] 
         * @param {number} [skipRows] 
         * @param {number} [ecId] 
         * @param {string} [search] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceControllingMatrixPost(from?: string, to?: string, paymentPending?: boolean, numOfRows?: number, skipRows?: number, ecId?: number, search?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<InvoiceControllingRowDto>> {
            return localVarFp.apiInvoiceControllingMatrixPost(from, to, paymentPending, numOfRows, skipRows, ecId, search, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {CreateInvoicesRequestDto} [createInvoicesRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceCreatePost(apiVersion?: string, createInvoicesRequestDto?: CreateInvoicesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiInvoiceCreatePost(apiVersion, createInvoicesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceDownloadBulkPost(apiVersion?: string, requestBody?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiInvoiceDownloadBulkPost(apiVersion, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceEcEnergyCommunityIdInvoiceNumberConfigGet(energyCommunityId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceNumberConfigDto> {
            return localVarFp.apiInvoiceEcEnergyCommunityIdInvoiceNumberConfigGet(energyCommunityId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceEcEnergyCommunityIdOverlappingGet(energyCommunityId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<OverlappingInvoiceDto>> {
            return localVarFp.apiInvoiceEcEnergyCommunityIdOverlappingGet(energyCommunityId, from, to, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceIdDownloadGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiInvoiceIdDownloadGet(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceIdUserDownloadGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiInvoiceIdUserDownloadGet(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiInvoiceUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceUserDownloadBulkPost(apiVersion?: string, requestBody?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiInvoiceUserDownloadBulkPost(apiVersion, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [memberContractId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvoiceUserGet(memberContractId?: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserInvoiceDto>> {
            return localVarFp.apiInvoiceUserGet(memberContractId, apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceApi - object-oriented interface
 */
export class InvoiceApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {InvoiceDtoRowsRequestDto} [invoiceDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiInvoiceAllPost(apiVersion?: string, invoiceDtoRowsRequestDto?: InvoiceDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceAllPost(apiVersion, invoiceDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {boolean} [paymentPending] 
     * @param {number} [numOfRows] 
     * @param {number} [skipRows] 
     * @param {number} [ecId] 
     * @param {string} [search] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiInvoiceControllingMatrixPost(from?: string, to?: string, paymentPending?: boolean, numOfRows?: number, skipRows?: number, ecId?: number, search?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceControllingMatrixPost(from, to, paymentPending, numOfRows, skipRows, ecId, search, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {CreateInvoicesRequestDto} [createInvoicesRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiInvoiceCreatePost(apiVersion?: string, createInvoicesRequestDto?: CreateInvoicesRequestDto, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceCreatePost(apiVersion, createInvoicesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiInvoiceDownloadBulkPost(apiVersion?: string, requestBody?: Set<number>, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceDownloadBulkPost(apiVersion, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} energyCommunityId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiInvoiceEcEnergyCommunityIdInvoiceNumberConfigGet(energyCommunityId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceEcEnergyCommunityIdInvoiceNumberConfigGet(energyCommunityId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} energyCommunityId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiInvoiceEcEnergyCommunityIdOverlappingGet(energyCommunityId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceEcEnergyCommunityIdOverlappingGet(energyCommunityId, from, to, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiInvoiceIdDownloadGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceIdDownloadGet(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiInvoiceIdUserDownloadGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceIdUserDownloadGet(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiInvoiceUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiInvoiceUserDownloadBulkPost(apiVersion?: string, requestBody?: Array<number>, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceUserDownloadBulkPost(apiVersion, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [memberContractId] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiInvoiceUserGet(memberContractId?: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiInvoiceUserGet(memberContractId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegalPersonApi - axios parameter creator
 */
export const LegalPersonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonAllGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/legalperson/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {LegalPersonDtoRowsRequestDto} [legalPersonDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonAllPost: async (apiVersion?: string, legalPersonDtoRowsRequestDto?: LegalPersonDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/legalperson/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(legalPersonDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {LegalPersonCreateRequestDto} [legalPersonCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonCreatePost: async (apiVersion?: string, legalPersonCreateRequestDto?: LegalPersonCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/legalperson/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(legalPersonCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [legalPersonIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonDeletePost: async (apiVersion?: string, legalPersonIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/legalperson/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (legalPersonIds) {
                legalPersonIds.forEach((element) => {
                    localVarFormParams.append('legalPersonIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} legalPersonId 
         * @param {string} [apiVersion] 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonLegalPersonIdUsersAddPost: async (legalPersonId: number, apiVersion?: string, userId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'legalPersonId' is not null or undefined
            assertParamExists('apiLegalpersonLegalPersonIdUsersAddPost', 'legalPersonId', legalPersonId)
            const localVarPath = `/api/legalperson/{legalPersonId}/users/add`
                .replace('{legalPersonId}', encodeURIComponent(String(legalPersonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (userId !== undefined) { 
                localVarFormParams.append('userId', userId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} legalPersonId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonLegalPersonIdUsersGet: async (legalPersonId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'legalPersonId' is not null or undefined
            assertParamExists('apiLegalpersonLegalPersonIdUsersGet', 'legalPersonId', legalPersonId)
            const localVarPath = `/api/legalperson/{legalPersonId}/users`
                .replace('{legalPersonId}', encodeURIComponent(String(legalPersonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} legalPersonId 
         * @param {string} [apiVersion] 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonLegalPersonIdUsersRemovePost: async (legalPersonId: number, apiVersion?: string, userId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'legalPersonId' is not null or undefined
            assertParamExists('apiLegalpersonLegalPersonIdUsersRemovePost', 'legalPersonId', legalPersonId)
            const localVarPath = `/api/legalperson/{legalPersonId}/users/remove`
                .replace('{legalPersonId}', encodeURIComponent(String(legalPersonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (userId !== undefined) { 
                localVarFormParams.append('userId', userId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonLinkedGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/legalperson/linked`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonUpdatePost: async (apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/legalperson/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(int32TableChangesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegalPersonApi - functional programming interface
 */
export const LegalPersonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegalPersonApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegalpersonAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LegalPersonMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegalpersonAllGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalPersonApi.apiLegalpersonAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {LegalPersonDtoRowsRequestDto} [legalPersonDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegalpersonAllPost(apiVersion?: string, legalPersonDtoRowsRequestDto?: LegalPersonDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegalPersonDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegalpersonAllPost(apiVersion, legalPersonDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalPersonApi.apiLegalpersonAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {LegalPersonCreateRequestDto} [legalPersonCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegalpersonCreatePost(apiVersion?: string, legalPersonCreateRequestDto?: LegalPersonCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegalpersonCreatePost(apiVersion, legalPersonCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalPersonApi.apiLegalpersonCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [legalPersonIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegalpersonDeletePost(apiVersion?: string, legalPersonIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegalpersonDeletePost(apiVersion, legalPersonIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalPersonApi.apiLegalpersonDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} legalPersonId 
         * @param {string} [apiVersion] 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegalpersonLegalPersonIdUsersAddPost(legalPersonId: number, apiVersion?: string, userId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegalpersonLegalPersonIdUsersAddPost(legalPersonId, apiVersion, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalPersonApi.apiLegalpersonLegalPersonIdUsersAddPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} legalPersonId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegalpersonLegalPersonIdUsersGet(legalPersonId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegalpersonLegalPersonIdUsersGet(legalPersonId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalPersonApi.apiLegalpersonLegalPersonIdUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} legalPersonId 
         * @param {string} [apiVersion] 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegalpersonLegalPersonIdUsersRemovePost(legalPersonId: number, apiVersion?: string, userId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegalpersonLegalPersonIdUsersRemovePost(legalPersonId, apiVersion, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalPersonApi.apiLegalpersonLegalPersonIdUsersRemovePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegalpersonLinkedGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LegalPersonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegalpersonLinkedGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalPersonApi.apiLegalpersonLinkedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegalpersonUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegalpersonUpdatePost(apiVersion, int32TableChangesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalPersonApi.apiLegalpersonUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegalPersonApi - factory interface
 */
export const LegalPersonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegalPersonApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<LegalPersonMinimalDto>> {
            return localVarFp.apiLegalpersonAllGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {LegalPersonDtoRowsRequestDto} [legalPersonDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonAllPost(apiVersion?: string, legalPersonDtoRowsRequestDto?: LegalPersonDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<LegalPersonDtoRowsResponseDto> {
            return localVarFp.apiLegalpersonAllPost(apiVersion, legalPersonDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {LegalPersonCreateRequestDto} [legalPersonCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonCreatePost(apiVersion?: string, legalPersonCreateRequestDto?: LegalPersonCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiLegalpersonCreatePost(apiVersion, legalPersonCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [legalPersonIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonDeletePost(apiVersion?: string, legalPersonIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiLegalpersonDeletePost(apiVersion, legalPersonIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} legalPersonId 
         * @param {string} [apiVersion] 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonLegalPersonIdUsersAddPost(legalPersonId: number, apiVersion?: string, userId?: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiLegalpersonLegalPersonIdUsersAddPost(legalPersonId, apiVersion, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} legalPersonId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonLegalPersonIdUsersGet(legalPersonId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserMinimalDto>> {
            return localVarFp.apiLegalpersonLegalPersonIdUsersGet(legalPersonId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} legalPersonId 
         * @param {string} [apiVersion] 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonLegalPersonIdUsersRemovePost(legalPersonId: number, apiVersion?: string, userId?: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiLegalpersonLegalPersonIdUsersRemovePost(legalPersonId, apiVersion, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonLinkedGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<LegalPersonDto>> {
            return localVarFp.apiLegalpersonLinkedGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalpersonUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiLegalpersonUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegalPersonApi - object-oriented interface
 */
export class LegalPersonApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLegalpersonAllGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return LegalPersonApiFp(this.configuration).apiLegalpersonAllGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {LegalPersonDtoRowsRequestDto} [legalPersonDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLegalpersonAllPost(apiVersion?: string, legalPersonDtoRowsRequestDto?: LegalPersonDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return LegalPersonApiFp(this.configuration).apiLegalpersonAllPost(apiVersion, legalPersonDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {LegalPersonCreateRequestDto} [legalPersonCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLegalpersonCreatePost(apiVersion?: string, legalPersonCreateRequestDto?: LegalPersonCreateRequestDto, options?: RawAxiosRequestConfig) {
        return LegalPersonApiFp(this.configuration).apiLegalpersonCreatePost(apiVersion, legalPersonCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [legalPersonIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLegalpersonDeletePost(apiVersion?: string, legalPersonIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return LegalPersonApiFp(this.configuration).apiLegalpersonDeletePost(apiVersion, legalPersonIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} legalPersonId 
     * @param {string} [apiVersion] 
     * @param {number} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLegalpersonLegalPersonIdUsersAddPost(legalPersonId: number, apiVersion?: string, userId?: number, options?: RawAxiosRequestConfig) {
        return LegalPersonApiFp(this.configuration).apiLegalpersonLegalPersonIdUsersAddPost(legalPersonId, apiVersion, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} legalPersonId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLegalpersonLegalPersonIdUsersGet(legalPersonId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return LegalPersonApiFp(this.configuration).apiLegalpersonLegalPersonIdUsersGet(legalPersonId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} legalPersonId 
     * @param {string} [apiVersion] 
     * @param {number} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLegalpersonLegalPersonIdUsersRemovePost(legalPersonId: number, apiVersion?: string, userId?: number, options?: RawAxiosRequestConfig) {
        return LegalPersonApiFp(this.configuration).apiLegalpersonLegalPersonIdUsersRemovePost(legalPersonId, apiVersion, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLegalpersonLinkedGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return LegalPersonApiFp(this.configuration).apiLegalpersonLinkedGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLegalpersonUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig) {
        return LegalPersonApiFp(this.configuration).apiLegalpersonUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MemberContractApi - axios parameter creator
 */
export const MemberContractApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MCDtoRowsRequestDto} [mCDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractAllPost: async (apiVersion?: string, mCDtoRowsRequestDto?: MCDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/membercontract/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mCDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} contractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractContractIdDocumentDownloadGet: async (contractId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiMembercontractContractIdDocumentDownloadGet', 'contractId', contractId)
            const localVarPath = `/api/membercontract/{contractId}/document/download`
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} contractId 
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractContractIdDocumentUploadPost: async (contractId: number, apiVersion?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiMembercontractContractIdDocumentUploadPost', 'contractId', contractId)
            const localVarPath = `/api/membercontract/{contractId}/document/upload`
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MCCreateRequestDto} [mCCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractCreatePost: async (apiVersion?: string, mCCreateRequestDto?: MCCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/membercontract/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mCCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [mcIds] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractDeactivatePost: async (apiVersion?: string, mcIds?: Set<number>, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/membercontract/deactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (mcIds) {
                mcIds.forEach((element) => {
                    localVarFormParams.append('mcIds', element as any);
                })
            }


            if (endDate !== undefined) { 
                localVarFormParams.append('endDate', endDate as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [memberContractIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractDeletePost: async (apiVersion?: string, memberContractIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/membercontract/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (memberContractIds) {
                memberContractIds.forEach((element) => {
                    localVarFormParams.append('memberContractIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractUpdatePost: async (apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/membercontract/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(int32TableChangesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} documentEntityId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractUserDocumentDocumentEntityIdDownloadGet: async (documentEntityId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentEntityId' is not null or undefined
            assertParamExists('apiMembercontractUserDocumentDocumentEntityIdDownloadGet', 'documentEntityId', documentEntityId)
            const localVarPath = `/api/membercontract/user/document/{documentEntityId}/download`
                .replace('{documentEntityId}', encodeURIComponent(String(documentEntityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractUserDocumentsGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/membercontract/user/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractUserGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/membercontract/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MemberContractApi - functional programming interface
 */
export const MemberContractApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MemberContractApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MCDtoRowsRequestDto} [mCDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMembercontractAllPost(apiVersion?: string, mCDtoRowsRequestDto?: MCDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MCDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMembercontractAllPost(apiVersion, mCDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberContractApi.apiMembercontractAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} contractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMembercontractContractIdDocumentDownloadGet(contractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMembercontractContractIdDocumentDownloadGet(contractId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberContractApi.apiMembercontractContractIdDocumentDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} contractId 
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMembercontractContractIdDocumentUploadPost(contractId: number, apiVersion?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMembercontractContractIdDocumentUploadPost(contractId, apiVersion, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberContractApi.apiMembercontractContractIdDocumentUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MCCreateRequestDto} [mCCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMembercontractCreatePost(apiVersion?: string, mCCreateRequestDto?: MCCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMembercontractCreatePost(apiVersion, mCCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberContractApi.apiMembercontractCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [mcIds] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMembercontractDeactivatePost(apiVersion?: string, mcIds?: Set<number>, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMembercontractDeactivatePost(apiVersion, mcIds, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberContractApi.apiMembercontractDeactivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [memberContractIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMembercontractDeletePost(apiVersion?: string, memberContractIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMembercontractDeletePost(apiVersion, memberContractIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberContractApi.apiMembercontractDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMembercontractUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMembercontractUpdatePost(apiVersion, int32TableChangesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberContractApi.apiMembercontractUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} documentEntityId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMembercontractUserDocumentDocumentEntityIdDownloadGet(documentEntityId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMembercontractUserDocumentDocumentEntityIdDownloadGet(documentEntityId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberContractApi.apiMembercontractUserDocumentDocumentEntityIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMembercontractUserDocumentsGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserMCDocumentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMembercontractUserDocumentsGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberContractApi.apiMembercontractUserDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMembercontractUserGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrentUserMCDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMembercontractUserGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemberContractApi.apiMembercontractUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MemberContractApi - factory interface
 */
export const MemberContractApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MemberContractApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MCDtoRowsRequestDto} [mCDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractAllPost(apiVersion?: string, mCDtoRowsRequestDto?: MCDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MCDtoRowsResponseDto> {
            return localVarFp.apiMembercontractAllPost(apiVersion, mCDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} contractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractContractIdDocumentDownloadGet(contractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiMembercontractContractIdDocumentDownloadGet(contractId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} contractId 
         * @param {string} [apiVersion] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractContractIdDocumentUploadPost(contractId: number, apiVersion?: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiMembercontractContractIdDocumentUploadPost(contractId, apiVersion, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MCCreateRequestDto} [mCCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractCreatePost(apiVersion?: string, mCCreateRequestDto?: MCCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMembercontractCreatePost(apiVersion, mCCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [mcIds] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractDeactivatePost(apiVersion?: string, mcIds?: Set<number>, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMembercontractDeactivatePost(apiVersion, mcIds, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [memberContractIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractDeletePost(apiVersion?: string, memberContractIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMembercontractDeletePost(apiVersion, memberContractIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMembercontractUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} documentEntityId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractUserDocumentDocumentEntityIdDownloadGet(documentEntityId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiMembercontractUserDocumentDocumentEntityIdDownloadGet(documentEntityId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractUserDocumentsGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserMCDocumentDto>> {
            return localVarFp.apiMembercontractUserDocumentsGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMembercontractUserGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CurrentUserMCDto>> {
            return localVarFp.apiMembercontractUserGet(apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MemberContractApi - object-oriented interface
 */
export class MemberContractApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {MCDtoRowsRequestDto} [mCDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMembercontractAllPost(apiVersion?: string, mCDtoRowsRequestDto?: MCDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return MemberContractApiFp(this.configuration).apiMembercontractAllPost(apiVersion, mCDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} contractId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMembercontractContractIdDocumentDownloadGet(contractId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MemberContractApiFp(this.configuration).apiMembercontractContractIdDocumentDownloadGet(contractId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} contractId 
     * @param {string} [apiVersion] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMembercontractContractIdDocumentUploadPost(contractId: number, apiVersion?: string, file?: File, options?: RawAxiosRequestConfig) {
        return MemberContractApiFp(this.configuration).apiMembercontractContractIdDocumentUploadPost(contractId, apiVersion, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {MCCreateRequestDto} [mCCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMembercontractCreatePost(apiVersion?: string, mCCreateRequestDto?: MCCreateRequestDto, options?: RawAxiosRequestConfig) {
        return MemberContractApiFp(this.configuration).apiMembercontractCreatePost(apiVersion, mCCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [mcIds] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMembercontractDeactivatePost(apiVersion?: string, mcIds?: Set<number>, endDate?: string, options?: RawAxiosRequestConfig) {
        return MemberContractApiFp(this.configuration).apiMembercontractDeactivatePost(apiVersion, mcIds, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [memberContractIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMembercontractDeletePost(apiVersion?: string, memberContractIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return MemberContractApiFp(this.configuration).apiMembercontractDeletePost(apiVersion, memberContractIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMembercontractUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig) {
        return MemberContractApiFp(this.configuration).apiMembercontractUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} documentEntityId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMembercontractUserDocumentDocumentEntityIdDownloadGet(documentEntityId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MemberContractApiFp(this.configuration).apiMembercontractUserDocumentDocumentEntityIdDownloadGet(documentEntityId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMembercontractUserDocumentsGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MemberContractApiFp(this.configuration).apiMembercontractUserDocumentsGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMembercontractUserGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MemberContractApiFp(this.configuration).apiMembercontractUserGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeteringPointApi - axios parameter creator
 */
export const MeteringPointApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointAllGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpoint/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MeteringPointDtoRowsRequestDto} [meteringPointDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointAllPost: async (apiVersion?: string, meteringPointDtoRowsRequestDto?: MeteringPointDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpoint/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meteringPointDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MeteringPointCreateRequestDto} [meteringPointCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointCreatePost: async (apiVersion?: string, meteringPointCreateRequestDto?: MeteringPointCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpoint/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meteringPointCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [meteringPointIds] 
         * @param {string} [deactivationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointDeactivatePost: async (apiVersion?: string, meteringPointIds?: Set<number>, deactivationDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpoint/deactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (meteringPointIds) {
                meteringPointIds.forEach((element) => {
                    localVarFormParams.append('meteringPointIds', element as any);
                })
            }


            if (deactivationDate !== undefined) { 
                localVarFormParams.append('deactivationDate', deactivationDate as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [meteringPointIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointDeletePost: async (apiVersion?: string, meteringPointIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpoint/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (meteringPointIds) {
                meteringPointIds.forEach((element) => {
                    localVarFormParams.append('meteringPointIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointUpdatePost: async (apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpoint/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(int32TableChangesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointUserGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpoint/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {MeteringPointUserUpdateRequestDto} [meteringPointUserUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointUserUpdateIdPut: async (id: number, apiVersion?: string, meteringPointUserUpdateRequestDto?: MeteringPointUserUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMeteringpointUserUpdateIdPut', 'id', id)
            const localVarPath = `/api/meteringpoint/user-update/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meteringPointUserUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeteringPointApi - functional programming interface
 */
export const MeteringPointApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeteringPointApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeteringPointMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointAllGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointApi.apiMeteringpointAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MeteringPointDtoRowsRequestDto} [meteringPointDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointAllPost(apiVersion?: string, meteringPointDtoRowsRequestDto?: MeteringPointDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeteringPointDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointAllPost(apiVersion, meteringPointDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointApi.apiMeteringpointAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MeteringPointCreateRequestDto} [meteringPointCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointCreatePost(apiVersion?: string, meteringPointCreateRequestDto?: MeteringPointCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointCreatePost(apiVersion, meteringPointCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointApi.apiMeteringpointCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [meteringPointIds] 
         * @param {string} [deactivationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointDeactivatePost(apiVersion?: string, meteringPointIds?: Set<number>, deactivationDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointDeactivatePost(apiVersion, meteringPointIds, deactivationDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointApi.apiMeteringpointDeactivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [meteringPointIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointDeletePost(apiVersion?: string, meteringPointIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointDeletePost(apiVersion, meteringPointIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointApi.apiMeteringpointDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointUpdatePost(apiVersion, int32TableChangesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointApi.apiMeteringpointUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointUserGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MPDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointUserGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointApi.apiMeteringpointUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {MeteringPointUserUpdateRequestDto} [meteringPointUserUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointUserUpdateIdPut(id: number, apiVersion?: string, meteringPointUserUpdateRequestDto?: MeteringPointUserUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointUserUpdateIdPut(id, apiVersion, meteringPointUserUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointApi.apiMeteringpointUserUpdateIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeteringPointApi - factory interface
 */
export const MeteringPointApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeteringPointApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MeteringPointMinimalDto>> {
            return localVarFp.apiMeteringpointAllGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MeteringPointDtoRowsRequestDto} [meteringPointDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointAllPost(apiVersion?: string, meteringPointDtoRowsRequestDto?: MeteringPointDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MeteringPointDtoRowsResponseDto> {
            return localVarFp.apiMeteringpointAllPost(apiVersion, meteringPointDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MeteringPointCreateRequestDto} [meteringPointCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointCreatePost(apiVersion?: string, meteringPointCreateRequestDto?: MeteringPointCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointCreatePost(apiVersion, meteringPointCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [meteringPointIds] 
         * @param {string} [deactivationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointDeactivatePost(apiVersion?: string, meteringPointIds?: Set<number>, deactivationDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointDeactivatePost(apiVersion, meteringPointIds, deactivationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [meteringPointIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointDeletePost(apiVersion?: string, meteringPointIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointDeletePost(apiVersion, meteringPointIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointUserGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MPDto>> {
            return localVarFp.apiMeteringpointUserGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {MeteringPointUserUpdateRequestDto} [meteringPointUserUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointUserUpdateIdPut(id: number, apiVersion?: string, meteringPointUserUpdateRequestDto?: MeteringPointUserUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointUserUpdateIdPut(id, apiVersion, meteringPointUserUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeteringPointApi - object-oriented interface
 */
export class MeteringPointApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointAllGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointApiFp(this.configuration).apiMeteringpointAllGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {MeteringPointDtoRowsRequestDto} [meteringPointDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointAllPost(apiVersion?: string, meteringPointDtoRowsRequestDto?: MeteringPointDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return MeteringPointApiFp(this.configuration).apiMeteringpointAllPost(apiVersion, meteringPointDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {MeteringPointCreateRequestDto} [meteringPointCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointCreatePost(apiVersion?: string, meteringPointCreateRequestDto?: MeteringPointCreateRequestDto, options?: RawAxiosRequestConfig) {
        return MeteringPointApiFp(this.configuration).apiMeteringpointCreatePost(apiVersion, meteringPointCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [meteringPointIds] 
     * @param {string} [deactivationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointDeactivatePost(apiVersion?: string, meteringPointIds?: Set<number>, deactivationDate?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointApiFp(this.configuration).apiMeteringpointDeactivatePost(apiVersion, meteringPointIds, deactivationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [meteringPointIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointDeletePost(apiVersion?: string, meteringPointIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return MeteringPointApiFp(this.configuration).apiMeteringpointDeletePost(apiVersion, meteringPointIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig) {
        return MeteringPointApiFp(this.configuration).apiMeteringpointUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointUserGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointApiFp(this.configuration).apiMeteringpointUserGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {MeteringPointUserUpdateRequestDto} [meteringPointUserUpdateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointUserUpdateIdPut(id: number, apiVersion?: string, meteringPointUserUpdateRequestDto?: MeteringPointUserUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return MeteringPointApiFp(this.configuration).apiMeteringpointUserUpdateIdPut(id, apiVersion, meteringPointUserUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeteringPointContractApi - axios parameter creator
 */
export const MeteringPointContractApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MeteringPointContractDtoRowsRequestDto} [meteringPointContractDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractAllPost: async (apiVersion?: string, meteringPointContractDtoRowsRequestDto?: MeteringPointContractDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcontract/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meteringPointContractDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MeteringPointContractCreateRequestDto} [meteringPointContractCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractCreatePost: async (apiVersion?: string, meteringPointContractCreateRequestDto?: MeteringPointContractCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcontract/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meteringPointContractCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [meteringPointContractIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractDeletePost: async (apiVersion?: string, meteringPointContractIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcontract/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (meteringPointContractIds) {
                meteringPointContractIds.forEach((element) => {
                    localVarFormParams.append('meteringPointContractIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractMeteringPointContractIdGet: async (meteringPointContractId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meteringPointContractId' is not null or undefined
            assertParamExists('apiMeteringpointcontractMeteringPointContractIdGet', 'meteringPointContractId', meteringPointContractId)
            const localVarPath = `/api/meteringpointcontract/{meteringPointContractId}`
                .replace('{meteringPointContractId}', encodeURIComponent(String(meteringPointContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractMeteringPointContractIdParticipationFactorsGet: async (meteringPointContractId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meteringPointContractId' is not null or undefined
            assertParamExists('apiMeteringpointcontractMeteringPointContractIdParticipationFactorsGet', 'meteringPointContractId', meteringPointContractId)
            const localVarPath = `/api/meteringpointcontract/{meteringPointContractId}/participation-factors`
                .replace('{meteringPointContractId}', encodeURIComponent(String(meteringPointContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [processTypeFilter] 
         * @param {Array<string>} [stepStatusFilter] 
         * @param {string} [stepMessageFilter] 
         * @param {boolean} [showIncomingOnly] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractMeteringPointContractIdProcessesGet: async (meteringPointContractId: number, page?: number, pageSize?: number, processTypeFilter?: Array<string>, stepStatusFilter?: Array<string>, stepMessageFilter?: string, showIncomingOnly?: boolean, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meteringPointContractId' is not null or undefined
            assertParamExists('apiMeteringpointcontractMeteringPointContractIdProcessesGet', 'meteringPointContractId', meteringPointContractId)
            const localVarPath = `/api/meteringpointcontract/{meteringPointContractId}/processes`
                .replace('{meteringPointContractId}', encodeURIComponent(String(meteringPointContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (processTypeFilter) {
                localVarQueryParameter['processTypeFilter'] = processTypeFilter;
            }

            if (stepStatusFilter) {
                localVarQueryParameter['stepStatusFilter'] = stepStatusFilter;
            }

            if (stepMessageFilter !== undefined) {
                localVarQueryParameter['stepMessageFilter'] = stepMessageFilter;
            }

            if (showIncomingOnly !== undefined) {
                localVarQueryParameter['showIncomingOnly'] = showIncomingOnly;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractMeteringPointContractIdUserProcessesGet: async (meteringPointContractId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meteringPointContractId' is not null or undefined
            assertParamExists('apiMeteringpointcontractMeteringPointContractIdUserProcessesGet', 'meteringPointContractId', meteringPointContractId)
            const localVarPath = `/api/meteringpointcontract/{meteringPointContractId}/user/processes`
                .replace('{meteringPointContractId}', encodeURIComponent(String(meteringPointContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractSearchGet: async (query?: string, limit?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcontract/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractStatusLatestRegistrationProcessPost: async (apiVersion?: string, requestBody?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcontract/status/latest-registration-process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractUpdatePost: async (apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcontract/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(int32TableChangesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [includeDeactivatedContracts] 
         * @param {number} [memberContractId] 
         * @param {number} [meteringPointId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractUserGet: async (includeDeactivatedContracts?: boolean, memberContractId?: number, meteringPointId?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcontract/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeDeactivatedContracts !== undefined) {
                localVarQueryParameter['includeDeactivatedContracts'] = includeDeactivatedContracts;
            }

            if (memberContractId !== undefined) {
                localVarQueryParameter['memberContractId'] = memberContractId;
            }

            if (meteringPointId !== undefined) {
                localVarQueryParameter['meteringPointId'] = meteringPointId;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeteringPointContractApi - functional programming interface
 */
export const MeteringPointContractApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeteringPointContractApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MeteringPointContractDtoRowsRequestDto} [meteringPointContractDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcontractAllPost(apiVersion?: string, meteringPointContractDtoRowsRequestDto?: MeteringPointContractDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeteringPointContractDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcontractAllPost(apiVersion, meteringPointContractDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointContractApi.apiMeteringpointcontractAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MeteringPointContractCreateRequestDto} [meteringPointContractCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcontractCreatePost(apiVersion?: string, meteringPointContractCreateRequestDto?: MeteringPointContractCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcontractCreatePost(apiVersion, meteringPointContractCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointContractApi.apiMeteringpointcontractCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [meteringPointContractIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcontractDeletePost(apiVersion?: string, meteringPointContractIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcontractDeletePost(apiVersion, meteringPointContractIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointContractApi.apiMeteringpointcontractDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcontractMeteringPointContractIdGet(meteringPointContractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeteringPointContractDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcontractMeteringPointContractIdGet(meteringPointContractId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointContractApi.apiMeteringpointcontractMeteringPointContractIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcontractMeteringPointContractIdParticipationFactorsGet(meteringPointContractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeteringPointParticipationFactorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcontractMeteringPointContractIdParticipationFactorsGet(meteringPointContractId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointContractApi.apiMeteringpointcontractMeteringPointContractIdParticipationFactorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [processTypeFilter] 
         * @param {Array<string>} [stepStatusFilter] 
         * @param {string} [stepMessageFilter] 
         * @param {boolean} [showIncomingOnly] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcontractMeteringPointContractIdProcessesGet(meteringPointContractId: number, page?: number, pageSize?: number, processTypeFilter?: Array<string>, stepStatusFilter?: Array<string>, stepMessageFilter?: string, showIncomingOnly?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessWithStepsDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcontractMeteringPointContractIdProcessesGet(meteringPointContractId, page, pageSize, processTypeFilter, stepStatusFilter, stepMessageFilter, showIncomingOnly, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointContractApi.apiMeteringpointcontractMeteringPointContractIdProcessesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcontractMeteringPointContractIdUserProcessesGet(meteringPointContractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RegistrationProcessEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcontractMeteringPointContractIdUserProcessesGet(meteringPointContractId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointContractApi.apiMeteringpointcontractMeteringPointContractIdUserProcessesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcontractSearchGet(query?: string, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeteringPointContractSearchResultDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcontractSearchGet(query, limit, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointContractApi.apiMeteringpointcontractSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcontractStatusLatestRegistrationProcessPost(apiVersion?: string, requestBody?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RegistrationProcessEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcontractStatusLatestRegistrationProcessPost(apiVersion, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointContractApi.apiMeteringpointcontractStatusLatestRegistrationProcessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcontractUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcontractUpdatePost(apiVersion, int32TableChangesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointContractApi.apiMeteringpointcontractUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [includeDeactivatedContracts] 
         * @param {number} [memberContractId] 
         * @param {number} [meteringPointId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcontractUserGet(includeDeactivatedContracts?: boolean, memberContractId?: number, meteringPointId?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrentUserMeteringPointContractDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcontractUserGet(includeDeactivatedContracts, memberContractId, meteringPointId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointContractApi.apiMeteringpointcontractUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeteringPointContractApi - factory interface
 */
export const MeteringPointContractApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeteringPointContractApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MeteringPointContractDtoRowsRequestDto} [meteringPointContractDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractAllPost(apiVersion?: string, meteringPointContractDtoRowsRequestDto?: MeteringPointContractDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MeteringPointContractDtoRowsResponseDto> {
            return localVarFp.apiMeteringpointcontractAllPost(apiVersion, meteringPointContractDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {MeteringPointContractCreateRequestDto} [meteringPointContractCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractCreatePost(apiVersion?: string, meteringPointContractCreateRequestDto?: MeteringPointContractCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointcontractCreatePost(apiVersion, meteringPointContractCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [meteringPointContractIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractDeletePost(apiVersion?: string, meteringPointContractIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointcontractDeletePost(apiVersion, meteringPointContractIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractMeteringPointContractIdGet(meteringPointContractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<MeteringPointContractDto> {
            return localVarFp.apiMeteringpointcontractMeteringPointContractIdGet(meteringPointContractId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractMeteringPointContractIdParticipationFactorsGet(meteringPointContractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MeteringPointParticipationFactorDto>> {
            return localVarFp.apiMeteringpointcontractMeteringPointContractIdParticipationFactorsGet(meteringPointContractId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [processTypeFilter] 
         * @param {Array<string>} [stepStatusFilter] 
         * @param {string} [stepMessageFilter] 
         * @param {boolean} [showIncomingOnly] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractMeteringPointContractIdProcessesGet(meteringPointContractId: number, page?: number, pageSize?: number, processTypeFilter?: Array<string>, stepStatusFilter?: Array<string>, stepMessageFilter?: string, showIncomingOnly?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessWithStepsDtoRowsResponseDto> {
            return localVarFp.apiMeteringpointcontractMeteringPointContractIdProcessesGet(meteringPointContractId, page, pageSize, processTypeFilter, stepStatusFilter, stepMessageFilter, showIncomingOnly, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} meteringPointContractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractMeteringPointContractIdUserProcessesGet(meteringPointContractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RegistrationProcessEntryDto>> {
            return localVarFp.apiMeteringpointcontractMeteringPointContractIdUserProcessesGet(meteringPointContractId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractSearchGet(query?: string, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MeteringPointContractSearchResultDto>> {
            return localVarFp.apiMeteringpointcontractSearchGet(query, limit, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractStatusLatestRegistrationProcessPost(apiVersion?: string, requestBody?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<Array<RegistrationProcessEntryDto>> {
            return localVarFp.apiMeteringpointcontractStatusLatestRegistrationProcessPost(apiVersion, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointcontractUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [includeDeactivatedContracts] 
         * @param {number} [memberContractId] 
         * @param {number} [meteringPointId] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcontractUserGet(includeDeactivatedContracts?: boolean, memberContractId?: number, meteringPointId?: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CurrentUserMeteringPointContractDto>> {
            return localVarFp.apiMeteringpointcontractUserGet(includeDeactivatedContracts, memberContractId, meteringPointId, apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeteringPointContractApi - object-oriented interface
 */
export class MeteringPointContractApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {MeteringPointContractDtoRowsRequestDto} [meteringPointContractDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcontractAllPost(apiVersion?: string, meteringPointContractDtoRowsRequestDto?: MeteringPointContractDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return MeteringPointContractApiFp(this.configuration).apiMeteringpointcontractAllPost(apiVersion, meteringPointContractDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {MeteringPointContractCreateRequestDto} [meteringPointContractCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcontractCreatePost(apiVersion?: string, meteringPointContractCreateRequestDto?: MeteringPointContractCreateRequestDto, options?: RawAxiosRequestConfig) {
        return MeteringPointContractApiFp(this.configuration).apiMeteringpointcontractCreatePost(apiVersion, meteringPointContractCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [meteringPointContractIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcontractDeletePost(apiVersion?: string, meteringPointContractIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return MeteringPointContractApiFp(this.configuration).apiMeteringpointcontractDeletePost(apiVersion, meteringPointContractIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} meteringPointContractId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcontractMeteringPointContractIdGet(meteringPointContractId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointContractApiFp(this.configuration).apiMeteringpointcontractMeteringPointContractIdGet(meteringPointContractId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} meteringPointContractId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcontractMeteringPointContractIdParticipationFactorsGet(meteringPointContractId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointContractApiFp(this.configuration).apiMeteringpointcontractMeteringPointContractIdParticipationFactorsGet(meteringPointContractId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} meteringPointContractId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {Array<string>} [processTypeFilter] 
     * @param {Array<string>} [stepStatusFilter] 
     * @param {string} [stepMessageFilter] 
     * @param {boolean} [showIncomingOnly] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcontractMeteringPointContractIdProcessesGet(meteringPointContractId: number, page?: number, pageSize?: number, processTypeFilter?: Array<string>, stepStatusFilter?: Array<string>, stepMessageFilter?: string, showIncomingOnly?: boolean, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointContractApiFp(this.configuration).apiMeteringpointcontractMeteringPointContractIdProcessesGet(meteringPointContractId, page, pageSize, processTypeFilter, stepStatusFilter, stepMessageFilter, showIncomingOnly, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} meteringPointContractId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcontractMeteringPointContractIdUserProcessesGet(meteringPointContractId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointContractApiFp(this.configuration).apiMeteringpointcontractMeteringPointContractIdUserProcessesGet(meteringPointContractId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [query] 
     * @param {number} [limit] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcontractSearchGet(query?: string, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointContractApiFp(this.configuration).apiMeteringpointcontractSearchGet(query, limit, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcontractStatusLatestRegistrationProcessPost(apiVersion?: string, requestBody?: Array<number>, options?: RawAxiosRequestConfig) {
        return MeteringPointContractApiFp(this.configuration).apiMeteringpointcontractStatusLatestRegistrationProcessPost(apiVersion, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcontractUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig) {
        return MeteringPointContractApiFp(this.configuration).apiMeteringpointcontractUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [includeDeactivatedContracts] 
     * @param {number} [memberContractId] 
     * @param {number} [meteringPointId] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcontractUserGet(includeDeactivatedContracts?: boolean, memberContractId?: number, meteringPointId?: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointContractApiFp(this.configuration).apiMeteringpointcontractUserGet(includeDeactivatedContracts, memberContractId, meteringPointId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeteringPointCostCenterApi - axios parameter creator
 */
export const MeteringPointCostCenterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterAdminAllGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcostcenter/admin/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [name] 
         * @param {number} [ownerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterAdminCreatePost: async (apiVersion?: string, name?: string, ownerId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcostcenter/admin/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }

            if (ownerId !== undefined) { 
                localVarFormParams.append('ownerId', ownerId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [costCenterIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterAdminDeletePost: async (apiVersion?: string, costCenterIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcostcenter/admin/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (costCenterIds) {
                costCenterIds.forEach((element) => {
                    localVarFormParams.append('costCenterIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {string} [name] 
         * @param {number} [ownerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterAdminIdUpdatePost: async (id: number, apiVersion?: string, name?: string, ownerId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMeteringpointcostcenterAdminIdUpdatePost', 'id', id)
            const localVarPath = `/api/meteringpointcostcenter/admin/{id}/update`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }

            if (ownerId !== undefined) { 
                localVarFormParams.append('ownerId', ownerId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [ownerId] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterAdminSearchGet: async (query?: string, ownerId?: number, limit?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcostcenter/admin/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (ownerId !== undefined) {
                localVarQueryParameter['ownerId'] = ownerId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterAvailableCostCentersGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcostcenter/available-cost-centers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [name] 
         * @param {number} [ownerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterCreatePost: async (apiVersion?: string, name?: string, ownerId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcostcenter/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }

            if (ownerId !== undefined) { 
                localVarFormParams.append('ownerId', ownerId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [costCenterIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterDeletePost: async (apiVersion?: string, costCenterIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/meteringpointcostcenter/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (costCenterIds) {
                costCenterIds.forEach((element) => {
                    localVarFormParams.append('costCenterIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterIdUpdatePost: async (id: number, apiVersion?: string, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMeteringpointcostcenterIdUpdatePost', 'id', id)
            const localVarPath = `/api/meteringpointcostcenter/{id}/update`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeteringPointCostCenterApi - functional programming interface
 */
export const MeteringPointCostCenterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeteringPointCostCenterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcostcenterAdminAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MPCostCenterDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcostcenterAdminAllGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointCostCenterApi.apiMeteringpointcostcenterAdminAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [name] 
         * @param {number} [ownerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcostcenterAdminCreatePost(apiVersion?: string, name?: string, ownerId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcostcenterAdminCreatePost(apiVersion, name, ownerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointCostCenterApi.apiMeteringpointcostcenterAdminCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [costCenterIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcostcenterAdminDeletePost(apiVersion?: string, costCenterIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcostcenterAdminDeletePost(apiVersion, costCenterIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointCostCenterApi.apiMeteringpointcostcenterAdminDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {string} [name] 
         * @param {number} [ownerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcostcenterAdminIdUpdatePost(id: number, apiVersion?: string, name?: string, ownerId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcostcenterAdminIdUpdatePost(id, apiVersion, name, ownerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointCostCenterApi.apiMeteringpointcostcenterAdminIdUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [ownerId] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcostcenterAdminSearchGet(query?: string, ownerId?: number, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MPCostCenterDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcostcenterAdminSearchGet(query, ownerId, limit, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointCostCenterApi.apiMeteringpointcostcenterAdminSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcostcenterAvailableCostCentersGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MPCostCenterDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcostcenterAvailableCostCentersGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointCostCenterApi.apiMeteringpointcostcenterAvailableCostCentersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [name] 
         * @param {number} [ownerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcostcenterCreatePost(apiVersion?: string, name?: string, ownerId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcostcenterCreatePost(apiVersion, name, ownerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointCostCenterApi.apiMeteringpointcostcenterCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [costCenterIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcostcenterDeletePost(apiVersion?: string, costCenterIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcostcenterDeletePost(apiVersion, costCenterIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointCostCenterApi.apiMeteringpointcostcenterDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMeteringpointcostcenterIdUpdatePost(id: number, apiVersion?: string, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMeteringpointcostcenterIdUpdatePost(id, apiVersion, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeteringPointCostCenterApi.apiMeteringpointcostcenterIdUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeteringPointCostCenterApi - factory interface
 */
export const MeteringPointCostCenterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeteringPointCostCenterApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterAdminAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MPCostCenterDto>> {
            return localVarFp.apiMeteringpointcostcenterAdminAllGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [name] 
         * @param {number} [ownerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterAdminCreatePost(apiVersion?: string, name?: string, ownerId?: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointcostcenterAdminCreatePost(apiVersion, name, ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [costCenterIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterAdminDeletePost(apiVersion?: string, costCenterIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointcostcenterAdminDeletePost(apiVersion, costCenterIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {string} [name] 
         * @param {number} [ownerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterAdminIdUpdatePost(id: number, apiVersion?: string, name?: string, ownerId?: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointcostcenterAdminIdUpdatePost(id, apiVersion, name, ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [ownerId] 
         * @param {number} [limit] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterAdminSearchGet(query?: string, ownerId?: number, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MPCostCenterDto>> {
            return localVarFp.apiMeteringpointcostcenterAdminSearchGet(query, ownerId, limit, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterAvailableCostCentersGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MPCostCenterDto>> {
            return localVarFp.apiMeteringpointcostcenterAvailableCostCentersGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [name] 
         * @param {number} [ownerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterCreatePost(apiVersion?: string, name?: string, ownerId?: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointcostcenterCreatePost(apiVersion, name, ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [costCenterIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterDeletePost(apiVersion?: string, costCenterIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointcostcenterDeletePost(apiVersion, costCenterIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMeteringpointcostcenterIdUpdatePost(id: number, apiVersion?: string, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiMeteringpointcostcenterIdUpdatePost(id, apiVersion, name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeteringPointCostCenterApi - object-oriented interface
 */
export class MeteringPointCostCenterApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcostcenterAdminAllGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointCostCenterApiFp(this.configuration).apiMeteringpointcostcenterAdminAllGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {string} [name] 
     * @param {number} [ownerId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcostcenterAdminCreatePost(apiVersion?: string, name?: string, ownerId?: number, options?: RawAxiosRequestConfig) {
        return MeteringPointCostCenterApiFp(this.configuration).apiMeteringpointcostcenterAdminCreatePost(apiVersion, name, ownerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [costCenterIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcostcenterAdminDeletePost(apiVersion?: string, costCenterIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return MeteringPointCostCenterApiFp(this.configuration).apiMeteringpointcostcenterAdminDeletePost(apiVersion, costCenterIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {string} [name] 
     * @param {number} [ownerId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcostcenterAdminIdUpdatePost(id: number, apiVersion?: string, name?: string, ownerId?: number, options?: RawAxiosRequestConfig) {
        return MeteringPointCostCenterApiFp(this.configuration).apiMeteringpointcostcenterAdminIdUpdatePost(id, apiVersion, name, ownerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [query] 
     * @param {number} [ownerId] 
     * @param {number} [limit] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcostcenterAdminSearchGet(query?: string, ownerId?: number, limit?: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointCostCenterApiFp(this.configuration).apiMeteringpointcostcenterAdminSearchGet(query, ownerId, limit, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcostcenterAvailableCostCentersGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointCostCenterApiFp(this.configuration).apiMeteringpointcostcenterAvailableCostCentersGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {string} [name] 
     * @param {number} [ownerId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcostcenterCreatePost(apiVersion?: string, name?: string, ownerId?: number, options?: RawAxiosRequestConfig) {
        return MeteringPointCostCenterApiFp(this.configuration).apiMeteringpointcostcenterCreatePost(apiVersion, name, ownerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [costCenterIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcostcenterDeletePost(apiVersion?: string, costCenterIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return MeteringPointCostCenterApiFp(this.configuration).apiMeteringpointcostcenterDeletePost(apiVersion, costCenterIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMeteringpointcostcenterIdUpdatePost(id: number, apiVersion?: string, name?: string, options?: RawAxiosRequestConfig) {
        return MeteringPointCostCenterApiFp(this.configuration).apiMeteringpointcostcenterIdUpdatePost(id, apiVersion, name, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OnboardingControllingApi - axios parameter creator
 */
export const OnboardingControllingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} contractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnboardingcontrollingNotesContractIdGet: async (contractId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiOnboardingcontrollingNotesContractIdGet', 'contractId', contractId)
            const localVarPath = `/api/onboardingcontrolling/notes/{contractId}`
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} noteId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnboardingcontrollingNotesNoteIdDelete: async (noteId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('apiOnboardingcontrollingNotesNoteIdDelete', 'noteId', noteId)
            const localVarPath = `/api/onboardingcontrolling/notes/{noteId}`
                .replace('{noteId}', encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} noteId 
         * @param {string} [apiVersion] 
         * @param {UpdateOnboardingNoteDto} [updateOnboardingNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnboardingcontrollingNotesNoteIdPut: async (noteId: number, apiVersion?: string, updateOnboardingNoteDto?: UpdateOnboardingNoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('apiOnboardingcontrollingNotesNoteIdPut', 'noteId', noteId)
            const localVarPath = `/api/onboardingcontrolling/notes/{noteId}`
                .replace('{noteId}', encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOnboardingNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {CreateOnboardingNoteDto} [createOnboardingNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnboardingcontrollingNotesPost: async (apiVersion?: string, createOnboardingNoteDto?: CreateOnboardingNoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/onboardingcontrolling/notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOnboardingNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {OnboardingControllingFilterDto} [onboardingControllingFilterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnboardingcontrollingReceivedRegistrationsWithoutProcessPost: async (apiVersion?: string, onboardingControllingFilterDto?: OnboardingControllingFilterDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/onboardingcontrolling/received-registrations-without-process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingControllingFilterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {OnboardingControllingFilterDto} [onboardingControllingFilterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnboardingcontrollingStuckContractsPost: async (apiVersion?: string, onboardingControllingFilterDto?: OnboardingControllingFilterDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/onboardingcontrolling/stuck-contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingControllingFilterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingControllingApi - functional programming interface
 */
export const OnboardingControllingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingControllingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} contractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnboardingcontrollingNotesContractIdGet(contractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OnboardingNoteDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnboardingcontrollingNotesContractIdGet(contractId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllingApi.apiOnboardingcontrollingNotesContractIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} noteId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnboardingcontrollingNotesNoteIdDelete(noteId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnboardingcontrollingNotesNoteIdDelete(noteId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllingApi.apiOnboardingcontrollingNotesNoteIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} noteId 
         * @param {string} [apiVersion] 
         * @param {UpdateOnboardingNoteDto} [updateOnboardingNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnboardingcontrollingNotesNoteIdPut(noteId: number, apiVersion?: string, updateOnboardingNoteDto?: UpdateOnboardingNoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnboardingcontrollingNotesNoteIdPut(noteId, apiVersion, updateOnboardingNoteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllingApi.apiOnboardingcontrollingNotesNoteIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {CreateOnboardingNoteDto} [createOnboardingNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnboardingcontrollingNotesPost(apiVersion?: string, createOnboardingNoteDto?: CreateOnboardingNoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnboardingcontrollingNotesPost(apiVersion, createOnboardingNoteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllingApi.apiOnboardingcontrollingNotesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {OnboardingControllingFilterDto} [onboardingControllingFilterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnboardingcontrollingReceivedRegistrationsWithoutProcessPost(apiVersion?: string, onboardingControllingFilterDto?: OnboardingControllingFilterDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceivedRegistrationWithoutProcessDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnboardingcontrollingReceivedRegistrationsWithoutProcessPost(apiVersion, onboardingControllingFilterDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllingApi.apiOnboardingcontrollingReceivedRegistrationsWithoutProcessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {OnboardingControllingFilterDto} [onboardingControllingFilterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOnboardingcontrollingStuckContractsPost(apiVersion?: string, onboardingControllingFilterDto?: OnboardingControllingFilterDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StuckContractDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOnboardingcontrollingStuckContractsPost(apiVersion, onboardingControllingFilterDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingControllingApi.apiOnboardingcontrollingStuckContractsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnboardingControllingApi - factory interface
 */
export const OnboardingControllingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingControllingApiFp(configuration)
    return {
        /**
         * 
         * @param {number} contractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnboardingcontrollingNotesContractIdGet(contractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<OnboardingNoteDto>> {
            return localVarFp.apiOnboardingcontrollingNotesContractIdGet(contractId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} noteId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnboardingcontrollingNotesNoteIdDelete(noteId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiOnboardingcontrollingNotesNoteIdDelete(noteId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} noteId 
         * @param {string} [apiVersion] 
         * @param {UpdateOnboardingNoteDto} [updateOnboardingNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnboardingcontrollingNotesNoteIdPut(noteId: number, apiVersion?: string, updateOnboardingNoteDto?: UpdateOnboardingNoteDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiOnboardingcontrollingNotesNoteIdPut(noteId, apiVersion, updateOnboardingNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {CreateOnboardingNoteDto} [createOnboardingNoteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnboardingcontrollingNotesPost(apiVersion?: string, createOnboardingNoteDto?: CreateOnboardingNoteDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiOnboardingcontrollingNotesPost(apiVersion, createOnboardingNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {OnboardingControllingFilterDto} [onboardingControllingFilterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnboardingcontrollingReceivedRegistrationsWithoutProcessPost(apiVersion?: string, onboardingControllingFilterDto?: OnboardingControllingFilterDto, options?: RawAxiosRequestConfig): AxiosPromise<ReceivedRegistrationWithoutProcessDtoRowsResponseDto> {
            return localVarFp.apiOnboardingcontrollingReceivedRegistrationsWithoutProcessPost(apiVersion, onboardingControllingFilterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {OnboardingControllingFilterDto} [onboardingControllingFilterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOnboardingcontrollingStuckContractsPost(apiVersion?: string, onboardingControllingFilterDto?: OnboardingControllingFilterDto, options?: RawAxiosRequestConfig): AxiosPromise<StuckContractDtoRowsResponseDto> {
            return localVarFp.apiOnboardingcontrollingStuckContractsPost(apiVersion, onboardingControllingFilterDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnboardingControllingApi - object-oriented interface
 */
export class OnboardingControllingApi extends BaseAPI {
    /**
     * 
     * @param {number} contractId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOnboardingcontrollingNotesContractIdGet(contractId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return OnboardingControllingApiFp(this.configuration).apiOnboardingcontrollingNotesContractIdGet(contractId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} noteId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOnboardingcontrollingNotesNoteIdDelete(noteId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return OnboardingControllingApiFp(this.configuration).apiOnboardingcontrollingNotesNoteIdDelete(noteId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} noteId 
     * @param {string} [apiVersion] 
     * @param {UpdateOnboardingNoteDto} [updateOnboardingNoteDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOnboardingcontrollingNotesNoteIdPut(noteId: number, apiVersion?: string, updateOnboardingNoteDto?: UpdateOnboardingNoteDto, options?: RawAxiosRequestConfig) {
        return OnboardingControllingApiFp(this.configuration).apiOnboardingcontrollingNotesNoteIdPut(noteId, apiVersion, updateOnboardingNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {CreateOnboardingNoteDto} [createOnboardingNoteDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOnboardingcontrollingNotesPost(apiVersion?: string, createOnboardingNoteDto?: CreateOnboardingNoteDto, options?: RawAxiosRequestConfig) {
        return OnboardingControllingApiFp(this.configuration).apiOnboardingcontrollingNotesPost(apiVersion, createOnboardingNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {OnboardingControllingFilterDto} [onboardingControllingFilterDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOnboardingcontrollingReceivedRegistrationsWithoutProcessPost(apiVersion?: string, onboardingControllingFilterDto?: OnboardingControllingFilterDto, options?: RawAxiosRequestConfig) {
        return OnboardingControllingApiFp(this.configuration).apiOnboardingcontrollingReceivedRegistrationsWithoutProcessPost(apiVersion, onboardingControllingFilterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {OnboardingControllingFilterDto} [onboardingControllingFilterDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiOnboardingcontrollingStuckContractsPost(apiVersion?: string, onboardingControllingFilterDto?: OnboardingControllingFilterDto, options?: RawAxiosRequestConfig) {
        return OnboardingControllingApiFp(this.configuration).apiOnboardingcontrollingStuckContractsPost(apiVersion, onboardingControllingFilterDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentApi - axios parameter creator
 */
export const PaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {BankTxDetailDtoRowsRequestDto} [bankTxDetailDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentAllPost: async (apiVersion?: string, bankTxDetailDtoRowsRequestDto?: BankTxDetailDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/payment/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankTxDetailDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentApi - functional programming interface
 */
export const PaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {BankTxDetailDtoRowsRequestDto} [bankTxDetailDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentAllPost(apiVersion?: string, bankTxDetailDtoRowsRequestDto?: BankTxDetailDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankTxDetailDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentAllPost(apiVersion, bankTxDetailDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentApi.apiPaymentAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentApi - factory interface
 */
export const PaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {BankTxDetailDtoRowsRequestDto} [bankTxDetailDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentAllPost(apiVersion?: string, bankTxDetailDtoRowsRequestDto?: BankTxDetailDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<BankTxDetailDtoRowsResponseDto> {
            return localVarFp.apiPaymentAllPost(apiVersion, bankTxDetailDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentApi - object-oriented interface
 */
export class PaymentApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {BankTxDetailDtoRowsRequestDto} [bankTxDetailDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPaymentAllPost(apiVersion?: string, bankTxDetailDtoRowsRequestDto?: BankTxDetailDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return PaymentApiFp(this.configuration).apiPaymentAllPost(apiVersion, bankTxDetailDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentInfoApi - axios parameter creator
 */
export const PaymentInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {PaymentInfoDtoRowsRequestDto} [paymentInfoDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoAllPost: async (apiVersion?: string, paymentInfoDtoRowsRequestDto?: PaymentInfoDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/paymentinfo/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentInfoDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {PaymentInfoCreateRequestDto} [paymentInfoCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoCreatePost: async (apiVersion?: string, paymentInfoCreateRequestDto?: PaymentInfoCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/paymentinfo/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentInfoCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [paymentInfoIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoDeactivatePost: async (apiVersion?: string, paymentInfoIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/paymentinfo/deactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (paymentInfoIds) {
                paymentInfoIds.forEach((element) => {
                    localVarFormParams.append('paymentInfoIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [paymentInfoIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoDeletePost: async (apiVersion?: string, paymentInfoIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/paymentinfo/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (paymentInfoIds) {
                paymentInfoIds.forEach((element) => {
                    localVarFormParams.append('paymentInfoIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} paymentInfoId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoPaymentInfoIdReactivatePost: async (paymentInfoId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentInfoId' is not null or undefined
            assertParamExists('apiPaymentinfoPaymentInfoIdReactivatePost', 'paymentInfoId', paymentInfoId)
            const localVarPath = `/api/paymentinfo/{paymentInfoId}/reactivate`
                .replace('{paymentInfoId}', encodeURIComponent(String(paymentInfoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} paymentInfoId 
         * @param {string} [apiVersion] 
         * @param {string} [newName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoPaymentInfoIdUserRenamePost: async (paymentInfoId: number, apiVersion?: string, newName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentInfoId' is not null or undefined
            assertParamExists('apiPaymentinfoPaymentInfoIdUserRenamePost', 'paymentInfoId', paymentInfoId)
            const localVarPath = `/api/paymentinfo/{paymentInfoId}/user/rename`
                .replace('{paymentInfoId}', encodeURIComponent(String(paymentInfoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (newName !== undefined) { 
                localVarFormParams.append('newName', newName as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoUpdatePost: async (apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/paymentinfo/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(int32TableChangesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoUserGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/paymentinfo/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoUserUsageGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/paymentinfo/user/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentInfoApi - functional programming interface
 */
export const PaymentInfoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentInfoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {PaymentInfoDtoRowsRequestDto} [paymentInfoDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentinfoAllPost(apiVersion?: string, paymentInfoDtoRowsRequestDto?: PaymentInfoDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentInfoDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentinfoAllPost(apiVersion, paymentInfoDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentInfoApi.apiPaymentinfoAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {PaymentInfoCreateRequestDto} [paymentInfoCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentinfoCreatePost(apiVersion?: string, paymentInfoCreateRequestDto?: PaymentInfoCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentinfoCreatePost(apiVersion, paymentInfoCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentInfoApi.apiPaymentinfoCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [paymentInfoIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentinfoDeactivatePost(apiVersion?: string, paymentInfoIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentinfoDeactivatePost(apiVersion, paymentInfoIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentInfoApi.apiPaymentinfoDeactivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [paymentInfoIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentinfoDeletePost(apiVersion?: string, paymentInfoIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentinfoDeletePost(apiVersion, paymentInfoIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentInfoApi.apiPaymentinfoDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} paymentInfoId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentinfoPaymentInfoIdReactivatePost(paymentInfoId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentinfoPaymentInfoIdReactivatePost(paymentInfoId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentInfoApi.apiPaymentinfoPaymentInfoIdReactivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} paymentInfoId 
         * @param {string} [apiVersion] 
         * @param {string} [newName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentinfoPaymentInfoIdUserRenamePost(paymentInfoId: number, apiVersion?: string, newName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentinfoPaymentInfoIdUserRenamePost(paymentInfoId, apiVersion, newName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentInfoApi.apiPaymentinfoPaymentInfoIdUserRenamePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentinfoUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentinfoUpdatePost(apiVersion, int32TableChangesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentInfoApi.apiPaymentinfoUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentinfoUserGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentInfoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentinfoUserGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentInfoApi.apiPaymentinfoUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentinfoUserUsageGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentInfoUsageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentinfoUserUsageGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentInfoApi.apiPaymentinfoUserUsageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentInfoApi - factory interface
 */
export const PaymentInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentInfoApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {PaymentInfoDtoRowsRequestDto} [paymentInfoDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoAllPost(apiVersion?: string, paymentInfoDtoRowsRequestDto?: PaymentInfoDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PaymentInfoDtoRowsResponseDto> {
            return localVarFp.apiPaymentinfoAllPost(apiVersion, paymentInfoDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {PaymentInfoCreateRequestDto} [paymentInfoCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoCreatePost(apiVersion?: string, paymentInfoCreateRequestDto?: PaymentInfoCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiPaymentinfoCreatePost(apiVersion, paymentInfoCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [paymentInfoIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoDeactivatePost(apiVersion?: string, paymentInfoIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiPaymentinfoDeactivatePost(apiVersion, paymentInfoIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [paymentInfoIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoDeletePost(apiVersion?: string, paymentInfoIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiPaymentinfoDeletePost(apiVersion, paymentInfoIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} paymentInfoId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoPaymentInfoIdReactivatePost(paymentInfoId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiPaymentinfoPaymentInfoIdReactivatePost(paymentInfoId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} paymentInfoId 
         * @param {string} [apiVersion] 
         * @param {string} [newName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoPaymentInfoIdUserRenamePost(paymentInfoId: number, apiVersion?: string, newName?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiPaymentinfoPaymentInfoIdUserRenamePost(paymentInfoId, apiVersion, newName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiPaymentinfoUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoUserGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentInfoDto>> {
            return localVarFp.apiPaymentinfoUserGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentinfoUserUsageGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentInfoUsageDto>> {
            return localVarFp.apiPaymentinfoUserUsageGet(apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentInfoApi - object-oriented interface
 */
export class PaymentInfoApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {PaymentInfoDtoRowsRequestDto} [paymentInfoDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPaymentinfoAllPost(apiVersion?: string, paymentInfoDtoRowsRequestDto?: PaymentInfoDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return PaymentInfoApiFp(this.configuration).apiPaymentinfoAllPost(apiVersion, paymentInfoDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {PaymentInfoCreateRequestDto} [paymentInfoCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPaymentinfoCreatePost(apiVersion?: string, paymentInfoCreateRequestDto?: PaymentInfoCreateRequestDto, options?: RawAxiosRequestConfig) {
        return PaymentInfoApiFp(this.configuration).apiPaymentinfoCreatePost(apiVersion, paymentInfoCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [paymentInfoIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPaymentinfoDeactivatePost(apiVersion?: string, paymentInfoIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return PaymentInfoApiFp(this.configuration).apiPaymentinfoDeactivatePost(apiVersion, paymentInfoIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [paymentInfoIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPaymentinfoDeletePost(apiVersion?: string, paymentInfoIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return PaymentInfoApiFp(this.configuration).apiPaymentinfoDeletePost(apiVersion, paymentInfoIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} paymentInfoId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPaymentinfoPaymentInfoIdReactivatePost(paymentInfoId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return PaymentInfoApiFp(this.configuration).apiPaymentinfoPaymentInfoIdReactivatePost(paymentInfoId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} paymentInfoId 
     * @param {string} [apiVersion] 
     * @param {string} [newName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPaymentinfoPaymentInfoIdUserRenamePost(paymentInfoId: number, apiVersion?: string, newName?: string, options?: RawAxiosRequestConfig) {
        return PaymentInfoApiFp(this.configuration).apiPaymentinfoPaymentInfoIdUserRenamePost(paymentInfoId, apiVersion, newName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPaymentinfoUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig) {
        return PaymentInfoApiFp(this.configuration).apiPaymentinfoUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPaymentinfoUserGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return PaymentInfoApiFp(this.configuration).apiPaymentinfoUserGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiPaymentinfoUserUsageGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return PaymentInfoApiFp(this.configuration).apiPaymentinfoUserUsageGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProcessApi - axios parameter creator
 */
export const ProcessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} processId 
         * @param {string} [apiVersion] 
         * @param {string} [msg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProcessCancelRegistrationOnlineProcessIdPost: async (processId: number, apiVersion?: string, msg?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('apiProcessCancelRegistrationOnlineProcessIdPost', 'processId', processId)
            const localVarPath = `/api/process/cancel/registration-online/{processId}`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (msg !== undefined) { 
                localVarFormParams.append('msg', msg as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<DeregisterRequestDto>} [deregisterRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProcessStartDeregisterPost: async (apiVersion?: string, deregisterRequestDto?: Array<DeregisterRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/process/start/deregister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deregisterRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<ParticipationFactorChangeRequestDto>} [participationFactorChangeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProcessStartParticipationFactorMutationPost: async (apiVersion?: string, participationFactorChangeRequestDto?: Array<ParticipationFactorChangeRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/process/start/participation-factor-mutation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(participationFactorChangeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<RegistrationOfflineDto>} [registrationOfflineDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProcessStartRegistrationOfflinePost: async (apiVersion?: string, registrationOfflineDto?: Array<RegistrationOfflineDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/process/start/registration-offline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registrationOfflineDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<RegistrationOnlineDto>} [registrationOnlineDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProcessStartRegistrationOnlinePost: async (apiVersion?: string, registrationOnlineDto?: Array<RegistrationOnlineDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/process/start/registration-online`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registrationOnlineDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<ECMPInfoRequestDto>} [eCMPInfoRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProcessStartRequestPartnerActivationDatePost: async (apiVersion?: string, eCMPInfoRequestDto?: Array<ECMPInfoRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/process/start/request-partner-activation-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eCMPInfoRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessApi - functional programming interface
 */
export const ProcessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} processId 
         * @param {string} [apiVersion] 
         * @param {string} [msg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProcessCancelRegistrationOnlineProcessIdPost(processId: number, apiVersion?: string, msg?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProcessCancelRegistrationOnlineProcessIdPost(processId, apiVersion, msg, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessApi.apiProcessCancelRegistrationOnlineProcessIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<DeregisterRequestDto>} [deregisterRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProcessStartDeregisterPost(apiVersion?: string, deregisterRequestDto?: Array<DeregisterRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProcessStartDeregisterPost(apiVersion, deregisterRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessApi.apiProcessStartDeregisterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<ParticipationFactorChangeRequestDto>} [participationFactorChangeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProcessStartParticipationFactorMutationPost(apiVersion?: string, participationFactorChangeRequestDto?: Array<ParticipationFactorChangeRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProcessStartParticipationFactorMutationPost(apiVersion, participationFactorChangeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessApi.apiProcessStartParticipationFactorMutationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<RegistrationOfflineDto>} [registrationOfflineDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProcessStartRegistrationOfflinePost(apiVersion?: string, registrationOfflineDto?: Array<RegistrationOfflineDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProcessStartRegistrationOfflinePost(apiVersion, registrationOfflineDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessApi.apiProcessStartRegistrationOfflinePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<RegistrationOnlineDto>} [registrationOnlineDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProcessStartRegistrationOnlinePost(apiVersion?: string, registrationOnlineDto?: Array<RegistrationOnlineDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProcessStartRegistrationOnlinePost(apiVersion, registrationOnlineDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessApi.apiProcessStartRegistrationOnlinePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<ECMPInfoRequestDto>} [eCMPInfoRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProcessStartRequestPartnerActivationDatePost(apiVersion?: string, eCMPInfoRequestDto?: Array<ECMPInfoRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProcessStartRequestPartnerActivationDatePost(apiVersion, eCMPInfoRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessApi.apiProcessStartRequestPartnerActivationDatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessApi - factory interface
 */
export const ProcessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessApiFp(configuration)
    return {
        /**
         * 
         * @param {number} processId 
         * @param {string} [apiVersion] 
         * @param {string} [msg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProcessCancelRegistrationOnlineProcessIdPost(processId: number, apiVersion?: string, msg?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiProcessCancelRegistrationOnlineProcessIdPost(processId, apiVersion, msg, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<DeregisterRequestDto>} [deregisterRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProcessStartDeregisterPost(apiVersion?: string, deregisterRequestDto?: Array<DeregisterRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiProcessStartDeregisterPost(apiVersion, deregisterRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<ParticipationFactorChangeRequestDto>} [participationFactorChangeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProcessStartParticipationFactorMutationPost(apiVersion?: string, participationFactorChangeRequestDto?: Array<ParticipationFactorChangeRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiProcessStartParticipationFactorMutationPost(apiVersion, participationFactorChangeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<RegistrationOfflineDto>} [registrationOfflineDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProcessStartRegistrationOfflinePost(apiVersion?: string, registrationOfflineDto?: Array<RegistrationOfflineDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiProcessStartRegistrationOfflinePost(apiVersion, registrationOfflineDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<RegistrationOnlineDto>} [registrationOnlineDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProcessStartRegistrationOnlinePost(apiVersion?: string, registrationOnlineDto?: Array<RegistrationOnlineDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiProcessStartRegistrationOnlinePost(apiVersion, registrationOnlineDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<ECMPInfoRequestDto>} [eCMPInfoRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProcessStartRequestPartnerActivationDatePost(apiVersion?: string, eCMPInfoRequestDto?: Array<ECMPInfoRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiProcessStartRequestPartnerActivationDatePost(apiVersion, eCMPInfoRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessApi - object-oriented interface
 */
export class ProcessApi extends BaseAPI {
    /**
     * 
     * @param {number} processId 
     * @param {string} [apiVersion] 
     * @param {string} [msg] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProcessCancelRegistrationOnlineProcessIdPost(processId: number, apiVersion?: string, msg?: string, options?: RawAxiosRequestConfig) {
        return ProcessApiFp(this.configuration).apiProcessCancelRegistrationOnlineProcessIdPost(processId, apiVersion, msg, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<DeregisterRequestDto>} [deregisterRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProcessStartDeregisterPost(apiVersion?: string, deregisterRequestDto?: Array<DeregisterRequestDto>, options?: RawAxiosRequestConfig) {
        return ProcessApiFp(this.configuration).apiProcessStartDeregisterPost(apiVersion, deregisterRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<ParticipationFactorChangeRequestDto>} [participationFactorChangeRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProcessStartParticipationFactorMutationPost(apiVersion?: string, participationFactorChangeRequestDto?: Array<ParticipationFactorChangeRequestDto>, options?: RawAxiosRequestConfig) {
        return ProcessApiFp(this.configuration).apiProcessStartParticipationFactorMutationPost(apiVersion, participationFactorChangeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<RegistrationOfflineDto>} [registrationOfflineDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProcessStartRegistrationOfflinePost(apiVersion?: string, registrationOfflineDto?: Array<RegistrationOfflineDto>, options?: RawAxiosRequestConfig) {
        return ProcessApiFp(this.configuration).apiProcessStartRegistrationOfflinePost(apiVersion, registrationOfflineDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<RegistrationOnlineDto>} [registrationOnlineDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProcessStartRegistrationOnlinePost(apiVersion?: string, registrationOnlineDto?: Array<RegistrationOnlineDto>, options?: RawAxiosRequestConfig) {
        return ProcessApiFp(this.configuration).apiProcessStartRegistrationOnlinePost(apiVersion, registrationOnlineDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<ECMPInfoRequestDto>} [eCMPInfoRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProcessStartRequestPartnerActivationDatePost(apiVersion?: string, eCMPInfoRequestDto?: Array<ECMPInfoRequestDto>, options?: RawAxiosRequestConfig) {
        return ProcessApiFp(this.configuration).apiProcessStartRequestPartnerActivationDatePost(apiVersion, eCMPInfoRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SepaMandateApi - axios parameter creator
 */
export const SepaMandateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SepaMandateDtoRowsRequestDto} [sepaMandateDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateAllPost: async (apiVersion?: string, sepaMandateDtoRowsRequestDto?: SepaMandateDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sepamandate/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sepaMandateDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberContractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateContractMemberContractIdGet: async (memberContractId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberContractId' is not null or undefined
            assertParamExists('apiSepamandateContractMemberContractIdGet', 'memberContractId', memberContractId)
            const localVarPath = `/api/sepamandate/contract/{memberContractId}`
                .replace('{memberContractId}', encodeURIComponent(String(memberContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SepaMandateCreateRequestDto} [sepaMandateCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateCreatePost: async (apiVersion?: string, sepaMandateCreateRequestDto?: SepaMandateCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sepamandate/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sepaMandateCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [sepaMandateIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateDeletePost: async (apiVersion?: string, sepaMandateIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sepamandate/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (sepaMandateIds) {
                sepaMandateIds.forEach((element) => {
                    localVarFormParams.append('sepaMandateIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [mandateReference] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateDocumentUploadPost: async (apiVersion?: string, mandateReference?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sepamandate/document/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (mandateReference !== undefined) { 
                localVarFormParams.append('mandateReference', mandateReference as any);
            }

            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} mandateId 
         * @param {string} [apiVersion] 
         * @param {string} [validTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateMandateIdEndAtPost: async (mandateId: number, apiVersion?: string, validTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mandateId' is not null or undefined
            assertParamExists('apiSepamandateMandateIdEndAtPost', 'mandateId', mandateId)
            const localVarPath = `/api/sepamandate/{mandateId}/end-at`
                .replace('{mandateId}', encodeURIComponent(String(mandateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (validTo !== undefined) { 
                localVarFormParams.append('validTo', validTo as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} mandateId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateMandateIdEndPost: async (mandateId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mandateId' is not null or undefined
            assertParamExists('apiSepamandateMandateIdEndPost', 'mandateId', mandateId)
            const localVarPath = `/api/sepamandate/{mandateId}/end`
                .replace('{mandateId}', encodeURIComponent(String(mandateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} mandateId 
         * @param {string} [apiVersion] 
         * @param {string} [signatureDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateMandateIdSignatureDatePost: async (mandateId: number, apiVersion?: string, signatureDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mandateId' is not null or undefined
            assertParamExists('apiSepamandateMandateIdSignatureDatePost', 'mandateId', mandateId)
            const localVarPath = `/api/sepamandate/{mandateId}/signature-date`
                .replace('{mandateId}', encodeURIComponent(String(mandateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }


            if (signatureDate !== undefined) { 
                localVarFormParams.append('signatureDate', signatureDate as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SepaMandateApi - functional programming interface
 */
export const SepaMandateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SepaMandateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SepaMandateDtoRowsRequestDto} [sepaMandateDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSepamandateAllPost(apiVersion?: string, sepaMandateDtoRowsRequestDto?: SepaMandateDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaMandateDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSepamandateAllPost(apiVersion, sepaMandateDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateApi.apiSepamandateAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} memberContractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSepamandateContractMemberContractIdGet(memberContractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SepaMandateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSepamandateContractMemberContractIdGet(memberContractId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateApi.apiSepamandateContractMemberContractIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SepaMandateCreateRequestDto} [sepaMandateCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSepamandateCreatePost(apiVersion?: string, sepaMandateCreateRequestDto?: SepaMandateCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SepaMandateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSepamandateCreatePost(apiVersion, sepaMandateCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateApi.apiSepamandateCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [sepaMandateIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSepamandateDeletePost(apiVersion?: string, sepaMandateIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSepamandateDeletePost(apiVersion, sepaMandateIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateApi.apiSepamandateDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [mandateReference] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSepamandateDocumentUploadPost(apiVersion?: string, mandateReference?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSepamandateDocumentUploadPost(apiVersion, mandateReference, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateApi.apiSepamandateDocumentUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} mandateId 
         * @param {string} [apiVersion] 
         * @param {string} [validTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSepamandateMandateIdEndAtPost(mandateId: number, apiVersion?: string, validTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSepamandateMandateIdEndAtPost(mandateId, apiVersion, validTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateApi.apiSepamandateMandateIdEndAtPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} mandateId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSepamandateMandateIdEndPost(mandateId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSepamandateMandateIdEndPost(mandateId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateApi.apiSepamandateMandateIdEndPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} mandateId 
         * @param {string} [apiVersion] 
         * @param {string} [signatureDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSepamandateMandateIdSignatureDatePost(mandateId: number, apiVersion?: string, signatureDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSepamandateMandateIdSignatureDatePost(mandateId, apiVersion, signatureDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SepaMandateApi.apiSepamandateMandateIdSignatureDatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SepaMandateApi - factory interface
 */
export const SepaMandateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SepaMandateApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SepaMandateDtoRowsRequestDto} [sepaMandateDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateAllPost(apiVersion?: string, sepaMandateDtoRowsRequestDto?: SepaMandateDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SepaMandateDtoRowsResponseDto> {
            return localVarFp.apiSepamandateAllPost(apiVersion, sepaMandateDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} memberContractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateContractMemberContractIdGet(memberContractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SepaMandateDto>> {
            return localVarFp.apiSepamandateContractMemberContractIdGet(memberContractId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SepaMandateCreateRequestDto} [sepaMandateCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateCreatePost(apiVersion?: string, sepaMandateCreateRequestDto?: SepaMandateCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SepaMandateDto> {
            return localVarFp.apiSepamandateCreatePost(apiVersion, sepaMandateCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [sepaMandateIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateDeletePost(apiVersion?: string, sepaMandateIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiSepamandateDeletePost(apiVersion, sepaMandateIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {string} [mandateReference] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateDocumentUploadPost(apiVersion?: string, mandateReference?: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSepamandateDocumentUploadPost(apiVersion, mandateReference, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} mandateId 
         * @param {string} [apiVersion] 
         * @param {string} [validTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateMandateIdEndAtPost(mandateId: number, apiVersion?: string, validTo?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiSepamandateMandateIdEndAtPost(mandateId, apiVersion, validTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} mandateId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateMandateIdEndPost(mandateId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiSepamandateMandateIdEndPost(mandateId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} mandateId 
         * @param {string} [apiVersion] 
         * @param {string} [signatureDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSepamandateMandateIdSignatureDatePost(mandateId: number, apiVersion?: string, signatureDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiSepamandateMandateIdSignatureDatePost(mandateId, apiVersion, signatureDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SepaMandateApi - object-oriented interface
 */
export class SepaMandateApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {SepaMandateDtoRowsRequestDto} [sepaMandateDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSepamandateAllPost(apiVersion?: string, sepaMandateDtoRowsRequestDto?: SepaMandateDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return SepaMandateApiFp(this.configuration).apiSepamandateAllPost(apiVersion, sepaMandateDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} memberContractId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSepamandateContractMemberContractIdGet(memberContractId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return SepaMandateApiFp(this.configuration).apiSepamandateContractMemberContractIdGet(memberContractId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {SepaMandateCreateRequestDto} [sepaMandateCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSepamandateCreatePost(apiVersion?: string, sepaMandateCreateRequestDto?: SepaMandateCreateRequestDto, options?: RawAxiosRequestConfig) {
        return SepaMandateApiFp(this.configuration).apiSepamandateCreatePost(apiVersion, sepaMandateCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [sepaMandateIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSepamandateDeletePost(apiVersion?: string, sepaMandateIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return SepaMandateApiFp(this.configuration).apiSepamandateDeletePost(apiVersion, sepaMandateIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {string} [mandateReference] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSepamandateDocumentUploadPost(apiVersion?: string, mandateReference?: string, file?: File, options?: RawAxiosRequestConfig) {
        return SepaMandateApiFp(this.configuration).apiSepamandateDocumentUploadPost(apiVersion, mandateReference, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} mandateId 
     * @param {string} [apiVersion] 
     * @param {string} [validTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSepamandateMandateIdEndAtPost(mandateId: number, apiVersion?: string, validTo?: string, options?: RawAxiosRequestConfig) {
        return SepaMandateApiFp(this.configuration).apiSepamandateMandateIdEndAtPost(mandateId, apiVersion, validTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} mandateId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSepamandateMandateIdEndPost(mandateId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return SepaMandateApiFp(this.configuration).apiSepamandateMandateIdEndPost(mandateId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} mandateId 
     * @param {string} [apiVersion] 
     * @param {string} [signatureDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSepamandateMandateIdSignatureDatePost(mandateId: number, apiVersion?: string, signatureDate?: string, options?: RawAxiosRequestConfig) {
        return SepaMandateApiFp(this.configuration).apiSepamandateMandateIdSignatureDatePost(mandateId, apiVersion, signatureDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemBannerApi - axios parameter creator
 */
export const SystemBannerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystembannerActiveGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/systembanner/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystembannerAllGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/systembanner/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SystemBannerCreateRequestDto} [systemBannerCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystembannerCreatePost: async (apiVersion?: string, systemBannerCreateRequestDto?: SystemBannerCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/systembanner/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemBannerCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystembannerIdDelete: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSystembannerIdDelete', 'id', id)
            const localVarPath = `/api/systembanner/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SystemBannerUpdateRequestDto} [systemBannerUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystembannerUpdatePut: async (apiVersion?: string, systemBannerUpdateRequestDto?: SystemBannerUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/systembanner/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemBannerUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemBannerApi - functional programming interface
 */
export const SystemBannerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemBannerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystembannerActiveGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemBannerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystembannerActiveGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemBannerApi.apiSystembannerActiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystembannerAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SystemBannerDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystembannerAllGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemBannerApi.apiSystembannerAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SystemBannerCreateRequestDto} [systemBannerCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystembannerCreatePost(apiVersion?: string, systemBannerCreateRequestDto?: SystemBannerCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystembannerCreatePost(apiVersion, systemBannerCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemBannerApi.apiSystembannerCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystembannerIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystembannerIdDelete(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemBannerApi.apiSystembannerIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SystemBannerUpdateRequestDto} [systemBannerUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystembannerUpdatePut(apiVersion?: string, systemBannerUpdateRequestDto?: SystemBannerUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystembannerUpdatePut(apiVersion, systemBannerUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemBannerApi.apiSystembannerUpdatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SystemBannerApi - factory interface
 */
export const SystemBannerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemBannerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystembannerActiveGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<SystemBannerDto> {
            return localVarFp.apiSystembannerActiveGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystembannerAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SystemBannerDto>> {
            return localVarFp.apiSystembannerAllGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SystemBannerCreateRequestDto} [systemBannerCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystembannerCreatePost(apiVersion?: string, systemBannerCreateRequestDto?: SystemBannerCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiSystembannerCreatePost(apiVersion, systemBannerCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystembannerIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiSystembannerIdDelete(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {SystemBannerUpdateRequestDto} [systemBannerUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystembannerUpdatePut(apiVersion?: string, systemBannerUpdateRequestDto?: SystemBannerUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiSystembannerUpdatePut(apiVersion, systemBannerUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemBannerApi - object-oriented interface
 */
export class SystemBannerApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSystembannerActiveGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return SystemBannerApiFp(this.configuration).apiSystembannerActiveGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSystembannerAllGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return SystemBannerApiFp(this.configuration).apiSystembannerAllGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {SystemBannerCreateRequestDto} [systemBannerCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSystembannerCreatePost(apiVersion?: string, systemBannerCreateRequestDto?: SystemBannerCreateRequestDto, options?: RawAxiosRequestConfig) {
        return SystemBannerApiFp(this.configuration).apiSystembannerCreatePost(apiVersion, systemBannerCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSystembannerIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return SystemBannerApiFp(this.configuration).apiSystembannerIdDelete(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {SystemBannerUpdateRequestDto} [systemBannerUpdateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSystembannerUpdatePut(apiVersion?: string, systemBannerUpdateRequestDto?: SystemBannerUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return SystemBannerApiFp(this.configuration).apiSystembannerUpdatePut(apiVersion, systemBannerUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TariffAssignmentApi - axios parameter creator
 */
export const TariffAssignmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentAllGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tariffassignment/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffAssignmentDtoRowsRequestDto} [tariffAssignmentDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentAllPost: async (apiVersion?: string, tariffAssignmentDtoRowsRequestDto?: TariffAssignmentDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tariffassignment/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffAssignmentDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} contractId 
         * @param {string} [asOf] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentContractContractIdActiveGet: async (contractId: number, asOf?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiTariffassignmentContractContractIdActiveGet', 'contractId', contractId)
            const localVarPath = `/api/tariffassignment/contract/{contractId}/active`
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (asOf !== undefined) {
                localVarQueryParameter['asOf'] = (asOf as any instanceof Date) ?
                    (asOf as any).toISOString() :
                    asOf;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} contractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentContractContractIdGet: async (contractId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('apiTariffassignmentContractContractIdGet', 'contractId', contractId)
            const localVarPath = `/api/tariffassignment/contract/{contractId}`
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffAssignmentCreateRequestDto} [tariffAssignmentCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentCreatePost: async (apiVersion?: string, tariffAssignmentCreateRequestDto?: TariffAssignmentCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tariffassignment/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffAssignmentCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentEnergycommunityEnergyCommunityIdGet: async (energyCommunityId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'energyCommunityId' is not null or undefined
            assertParamExists('apiTariffassignmentEnergycommunityEnergyCommunityIdGet', 'energyCommunityId', energyCommunityId)
            const localVarPath = `/api/tariffassignment/energycommunity/{energyCommunityId}`
                .replace('{energyCommunityId}', encodeURIComponent(String(energyCommunityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentIdDelete: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTariffassignmentIdDelete', 'id', id)
            const localVarPath = `/api/tariffassignment/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {TariffAssignmentCreateRequestDto} [tariffAssignmentCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentIdPut: async (id: number, apiVersion?: string, tariffAssignmentCreateRequestDto?: TariffAssignmentCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTariffassignmentIdPut', 'id', id)
            const localVarPath = `/api/tariffassignment/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffAssignmentCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} membershipId 
         * @param {string} [asOf] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentMembershipMembershipIdActiveGet: async (membershipId: number, asOf?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'membershipId' is not null or undefined
            assertParamExists('apiTariffassignmentMembershipMembershipIdActiveGet', 'membershipId', membershipId)
            const localVarPath = `/api/tariffassignment/membership/{membershipId}/active`
                .replace('{membershipId}', encodeURIComponent(String(membershipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (asOf !== undefined) {
                localVarQueryParameter['asOf'] = (asOf as any instanceof Date) ?
                    (asOf as any).toISOString() :
                    asOf;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} membershipId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentMembershipMembershipIdGet: async (membershipId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'membershipId' is not null or undefined
            assertParamExists('apiTariffassignmentMembershipMembershipIdGet', 'membershipId', membershipId)
            const localVarPath = `/api/tariffassignment/membership/{membershipId}`
                .replace('{membershipId}', encodeURIComponent(String(membershipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TariffAssignmentApi - functional programming interface
 */
export const TariffAssignmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TariffAssignmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffassignmentAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffAssignmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffassignmentAllGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffAssignmentApi.apiTariffassignmentAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffAssignmentDtoRowsRequestDto} [tariffAssignmentDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffassignmentAllPost(apiVersion?: string, tariffAssignmentDtoRowsRequestDto?: TariffAssignmentDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TariffAssignmentDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffassignmentAllPost(apiVersion, tariffAssignmentDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffAssignmentApi.apiTariffassignmentAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} contractId 
         * @param {string} [asOf] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffassignmentContractContractIdActiveGet(contractId: number, asOf?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffAssignmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffassignmentContractContractIdActiveGet(contractId, asOf, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffAssignmentApi.apiTariffassignmentContractContractIdActiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} contractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffassignmentContractContractIdGet(contractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffAssignmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffassignmentContractContractIdGet(contractId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffAssignmentApi.apiTariffassignmentContractContractIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffAssignmentCreateRequestDto} [tariffAssignmentCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffassignmentCreatePost(apiVersion?: string, tariffAssignmentCreateRequestDto?: TariffAssignmentCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffassignmentCreatePost(apiVersion, tariffAssignmentCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffAssignmentApi.apiTariffassignmentCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffassignmentEnergycommunityEnergyCommunityIdGet(energyCommunityId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffAssignmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffassignmentEnergycommunityEnergyCommunityIdGet(energyCommunityId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffAssignmentApi.apiTariffassignmentEnergycommunityEnergyCommunityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffassignmentIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffassignmentIdDelete(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffAssignmentApi.apiTariffassignmentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {TariffAssignmentCreateRequestDto} [tariffAssignmentCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffassignmentIdPut(id: number, apiVersion?: string, tariffAssignmentCreateRequestDto?: TariffAssignmentCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffassignmentIdPut(id, apiVersion, tariffAssignmentCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffAssignmentApi.apiTariffassignmentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} membershipId 
         * @param {string} [asOf] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffassignmentMembershipMembershipIdActiveGet(membershipId: number, asOf?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffAssignmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffassignmentMembershipMembershipIdActiveGet(membershipId, asOf, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffAssignmentApi.apiTariffassignmentMembershipMembershipIdActiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} membershipId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffassignmentMembershipMembershipIdGet(membershipId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffAssignmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffassignmentMembershipMembershipIdGet(membershipId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffAssignmentApi.apiTariffassignmentMembershipMembershipIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TariffAssignmentApi - factory interface
 */
export const TariffAssignmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TariffAssignmentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffAssignmentDto>> {
            return localVarFp.apiTariffassignmentAllGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffAssignmentDtoRowsRequestDto} [tariffAssignmentDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentAllPost(apiVersion?: string, tariffAssignmentDtoRowsRequestDto?: TariffAssignmentDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TariffAssignmentDtoRowsResponseDto> {
            return localVarFp.apiTariffassignmentAllPost(apiVersion, tariffAssignmentDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} contractId 
         * @param {string} [asOf] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentContractContractIdActiveGet(contractId: number, asOf?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffAssignmentDto>> {
            return localVarFp.apiTariffassignmentContractContractIdActiveGet(contractId, asOf, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} contractId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentContractContractIdGet(contractId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffAssignmentDto>> {
            return localVarFp.apiTariffassignmentContractContractIdGet(contractId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffAssignmentCreateRequestDto} [tariffAssignmentCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentCreatePost(apiVersion?: string, tariffAssignmentCreateRequestDto?: TariffAssignmentCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTariffassignmentCreatePost(apiVersion, tariffAssignmentCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} energyCommunityId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentEnergycommunityEnergyCommunityIdGet(energyCommunityId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffAssignmentDto>> {
            return localVarFp.apiTariffassignmentEnergycommunityEnergyCommunityIdGet(energyCommunityId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTariffassignmentIdDelete(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {TariffAssignmentCreateRequestDto} [tariffAssignmentCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentIdPut(id: number, apiVersion?: string, tariffAssignmentCreateRequestDto?: TariffAssignmentCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTariffassignmentIdPut(id, apiVersion, tariffAssignmentCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} membershipId 
         * @param {string} [asOf] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentMembershipMembershipIdActiveGet(membershipId: number, asOf?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffAssignmentDto>> {
            return localVarFp.apiTariffassignmentMembershipMembershipIdActiveGet(membershipId, asOf, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} membershipId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffassignmentMembershipMembershipIdGet(membershipId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffAssignmentDto>> {
            return localVarFp.apiTariffassignmentMembershipMembershipIdGet(membershipId, apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TariffAssignmentApi - object-oriented interface
 */
export class TariffAssignmentApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffassignmentAllGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffAssignmentApiFp(this.configuration).apiTariffassignmentAllGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {TariffAssignmentDtoRowsRequestDto} [tariffAssignmentDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffassignmentAllPost(apiVersion?: string, tariffAssignmentDtoRowsRequestDto?: TariffAssignmentDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return TariffAssignmentApiFp(this.configuration).apiTariffassignmentAllPost(apiVersion, tariffAssignmentDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} contractId 
     * @param {string} [asOf] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffassignmentContractContractIdActiveGet(contractId: number, asOf?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffAssignmentApiFp(this.configuration).apiTariffassignmentContractContractIdActiveGet(contractId, asOf, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} contractId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffassignmentContractContractIdGet(contractId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffAssignmentApiFp(this.configuration).apiTariffassignmentContractContractIdGet(contractId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {TariffAssignmentCreateRequestDto} [tariffAssignmentCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffassignmentCreatePost(apiVersion?: string, tariffAssignmentCreateRequestDto?: TariffAssignmentCreateRequestDto, options?: RawAxiosRequestConfig) {
        return TariffAssignmentApiFp(this.configuration).apiTariffassignmentCreatePost(apiVersion, tariffAssignmentCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} energyCommunityId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffassignmentEnergycommunityEnergyCommunityIdGet(energyCommunityId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffAssignmentApiFp(this.configuration).apiTariffassignmentEnergycommunityEnergyCommunityIdGet(energyCommunityId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffassignmentIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffAssignmentApiFp(this.configuration).apiTariffassignmentIdDelete(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {TariffAssignmentCreateRequestDto} [tariffAssignmentCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffassignmentIdPut(id: number, apiVersion?: string, tariffAssignmentCreateRequestDto?: TariffAssignmentCreateRequestDto, options?: RawAxiosRequestConfig) {
        return TariffAssignmentApiFp(this.configuration).apiTariffassignmentIdPut(id, apiVersion, tariffAssignmentCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} membershipId 
     * @param {string} [asOf] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffassignmentMembershipMembershipIdActiveGet(membershipId: number, asOf?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffAssignmentApiFp(this.configuration).apiTariffassignmentMembershipMembershipIdActiveGet(membershipId, asOf, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} membershipId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffassignmentMembershipMembershipIdGet(membershipId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffAssignmentApiFp(this.configuration).apiTariffassignmentMembershipMembershipIdGet(membershipId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TariffCalculationApi - axios parameter creator
 */
export const TariffCalculationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} mpcId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcalculationTariffViewMpcMpcIdGet: async (mpcId: number, from?: string, to?: string, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mpcId' is not null or undefined
            assertParamExists('apiTariffcalculationTariffViewMpcMpcIdGet', 'mpcId', mpcId)
            const localVarPath = `/api/tariffcalculation/tariff-view/mpc/{mpcId}`
                .replace('{mpcId}', encodeURIComponent(String(mpcId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TariffCalculationApi - functional programming interface
 */
export const TariffCalculationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TariffCalculationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} mpcId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffcalculationTariffViewMpcMpcIdGet(mpcId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TariffIntervalMPCDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffcalculationTariffViewMpcMpcIdGet(mpcId, from, to, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffCalculationApi.apiTariffcalculationTariffViewMpcMpcIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TariffCalculationApi - factory interface
 */
export const TariffCalculationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TariffCalculationApiFp(configuration)
    return {
        /**
         * 
         * @param {number} mpcId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcalculationTariffViewMpcMpcIdGet(mpcId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<TariffIntervalMPCDto> {
            return localVarFp.apiTariffcalculationTariffViewMpcMpcIdGet(mpcId, from, to, apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TariffCalculationApi - object-oriented interface
 */
export class TariffCalculationApi extends BaseAPI {
    /**
     * 
     * @param {number} mpcId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffcalculationTariffViewMpcMpcIdGet(mpcId: number, from?: string, to?: string, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffCalculationApiFp(this.configuration).apiTariffcalculationTariffViewMpcMpcIdGet(mpcId, from, to, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TariffComponentApi - axios parameter creator
 */
export const TariffComponentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentAllGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tariffcomponent/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffComponentDtoRowsRequestDto} [tariffComponentDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentAllPost: async (apiVersion?: string, tariffComponentDtoRowsRequestDto?: TariffComponentDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tariffcomponent/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffComponentDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffComponentCreateRequestDto} [tariffComponentCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentCreatePost: async (apiVersion?: string, tariffComponentCreateRequestDto?: TariffComponentCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tariffcomponent/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffComponentCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentIdDelete: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTariffcomponentIdDelete', 'id', id)
            const localVarPath = `/api/tariffcomponent/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentIdGet: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTariffcomponentIdGet', 'id', id)
            const localVarPath = `/api/tariffcomponent/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {TariffComponentUpdateRequestDto} [tariffComponentUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentIdPut: async (id: number, apiVersion?: string, tariffComponentUpdateRequestDto?: TariffComponentUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTariffcomponentIdPut', 'id', id)
            const localVarPath = `/api/tariffcomponent/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffComponentUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TariffComponentApi - functional programming interface
 */
export const TariffComponentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TariffComponentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffcomponentAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffComponentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffcomponentAllGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffComponentApi.apiTariffcomponentAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffComponentDtoRowsRequestDto} [tariffComponentDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffcomponentAllPost(apiVersion?: string, tariffComponentDtoRowsRequestDto?: TariffComponentDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TariffComponentDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffcomponentAllPost(apiVersion, tariffComponentDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffComponentApi.apiTariffcomponentAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffComponentCreateRequestDto} [tariffComponentCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffcomponentCreatePost(apiVersion?: string, tariffComponentCreateRequestDto?: TariffComponentCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffcomponentCreatePost(apiVersion, tariffComponentCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffComponentApi.apiTariffcomponentCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffcomponentIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffcomponentIdDelete(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffComponentApi.apiTariffcomponentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffcomponentIdGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TariffComponentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffcomponentIdGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffComponentApi.apiTariffcomponentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {TariffComponentUpdateRequestDto} [tariffComponentUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffcomponentIdPut(id: number, apiVersion?: string, tariffComponentUpdateRequestDto?: TariffComponentUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffcomponentIdPut(id, apiVersion, tariffComponentUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffComponentApi.apiTariffcomponentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TariffComponentApi - factory interface
 */
export const TariffComponentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TariffComponentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffComponentDto>> {
            return localVarFp.apiTariffcomponentAllGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffComponentDtoRowsRequestDto} [tariffComponentDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentAllPost(apiVersion?: string, tariffComponentDtoRowsRequestDto?: TariffComponentDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TariffComponentDtoRowsResponseDto> {
            return localVarFp.apiTariffcomponentAllPost(apiVersion, tariffComponentDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffComponentCreateRequestDto} [tariffComponentCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentCreatePost(apiVersion?: string, tariffComponentCreateRequestDto?: TariffComponentCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTariffcomponentCreatePost(apiVersion, tariffComponentCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTariffcomponentIdDelete(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentIdGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<TariffComponentDto> {
            return localVarFp.apiTariffcomponentIdGet(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {TariffComponentUpdateRequestDto} [tariffComponentUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentIdPut(id: number, apiVersion?: string, tariffComponentUpdateRequestDto?: TariffComponentUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTariffcomponentIdPut(id, apiVersion, tariffComponentUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TariffComponentApi - object-oriented interface
 */
export class TariffComponentApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffcomponentAllGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffComponentApiFp(this.configuration).apiTariffcomponentAllGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {TariffComponentDtoRowsRequestDto} [tariffComponentDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffcomponentAllPost(apiVersion?: string, tariffComponentDtoRowsRequestDto?: TariffComponentDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return TariffComponentApiFp(this.configuration).apiTariffcomponentAllPost(apiVersion, tariffComponentDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {TariffComponentCreateRequestDto} [tariffComponentCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffcomponentCreatePost(apiVersion?: string, tariffComponentCreateRequestDto?: TariffComponentCreateRequestDto, options?: RawAxiosRequestConfig) {
        return TariffComponentApiFp(this.configuration).apiTariffcomponentCreatePost(apiVersion, tariffComponentCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffcomponentIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffComponentApiFp(this.configuration).apiTariffcomponentIdDelete(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffcomponentIdGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffComponentApiFp(this.configuration).apiTariffcomponentIdGet(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {TariffComponentUpdateRequestDto} [tariffComponentUpdateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffcomponentIdPut(id: number, apiVersion?: string, tariffComponentUpdateRequestDto?: TariffComponentUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return TariffComponentApiFp(this.configuration).apiTariffcomponentIdPut(id, apiVersion, tariffComponentUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TariffComponentValueApi - axios parameter creator
 */
export const TariffComponentValueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} componentId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentvalueComponentComponentIdGet: async (componentId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('apiTariffcomponentvalueComponentComponentIdGet', 'componentId', componentId)
            const localVarPath = `/api/tariffcomponentvalue/component/{componentId}`
                .replace('{componentId}', encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffComponentValueCreateRequestDto} [tariffComponentValueCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentvalueCreatePost: async (apiVersion?: string, tariffComponentValueCreateRequestDto?: TariffComponentValueCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tariffcomponentvalue/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffComponentValueCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentvalueIdDelete: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTariffcomponentvalueIdDelete', 'id', id)
            const localVarPath = `/api/tariffcomponentvalue/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {TariffComponentValueUpdateRequestDto} [tariffComponentValueUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentvalueIdPut: async (id: number, apiVersion?: string, tariffComponentValueUpdateRequestDto?: TariffComponentValueUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTariffcomponentvalueIdPut', 'id', id)
            const localVarPath = `/api/tariffcomponentvalue/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffComponentValueUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TariffComponentValueApi - functional programming interface
 */
export const TariffComponentValueApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TariffComponentValueApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} componentId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffcomponentvalueComponentComponentIdGet(componentId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffComponentValueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffcomponentvalueComponentComponentIdGet(componentId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffComponentValueApi.apiTariffcomponentvalueComponentComponentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffComponentValueCreateRequestDto} [tariffComponentValueCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffcomponentvalueCreatePost(apiVersion?: string, tariffComponentValueCreateRequestDto?: TariffComponentValueCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffcomponentvalueCreatePost(apiVersion, tariffComponentValueCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffComponentValueApi.apiTariffcomponentvalueCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffcomponentvalueIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffcomponentvalueIdDelete(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffComponentValueApi.apiTariffcomponentvalueIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {TariffComponentValueUpdateRequestDto} [tariffComponentValueUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffcomponentvalueIdPut(id: number, apiVersion?: string, tariffComponentValueUpdateRequestDto?: TariffComponentValueUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffcomponentvalueIdPut(id, apiVersion, tariffComponentValueUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffComponentValueApi.apiTariffcomponentvalueIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TariffComponentValueApi - factory interface
 */
export const TariffComponentValueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TariffComponentValueApiFp(configuration)
    return {
        /**
         * 
         * @param {number} componentId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentvalueComponentComponentIdGet(componentId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffComponentValueDto>> {
            return localVarFp.apiTariffcomponentvalueComponentComponentIdGet(componentId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffComponentValueCreateRequestDto} [tariffComponentValueCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentvalueCreatePost(apiVersion?: string, tariffComponentValueCreateRequestDto?: TariffComponentValueCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTariffcomponentvalueCreatePost(apiVersion, tariffComponentValueCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentvalueIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTariffcomponentvalueIdDelete(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {TariffComponentValueUpdateRequestDto} [tariffComponentValueUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffcomponentvalueIdPut(id: number, apiVersion?: string, tariffComponentValueUpdateRequestDto?: TariffComponentValueUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTariffcomponentvalueIdPut(id, apiVersion, tariffComponentValueUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TariffComponentValueApi - object-oriented interface
 */
export class TariffComponentValueApi extends BaseAPI {
    /**
     * 
     * @param {number} componentId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffcomponentvalueComponentComponentIdGet(componentId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffComponentValueApiFp(this.configuration).apiTariffcomponentvalueComponentComponentIdGet(componentId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {TariffComponentValueCreateRequestDto} [tariffComponentValueCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffcomponentvalueCreatePost(apiVersion?: string, tariffComponentValueCreateRequestDto?: TariffComponentValueCreateRequestDto, options?: RawAxiosRequestConfig) {
        return TariffComponentValueApiFp(this.configuration).apiTariffcomponentvalueCreatePost(apiVersion, tariffComponentValueCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffcomponentvalueIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffComponentValueApiFp(this.configuration).apiTariffcomponentvalueIdDelete(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {TariffComponentValueUpdateRequestDto} [tariffComponentValueUpdateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffcomponentvalueIdPut(id: number, apiVersion?: string, tariffComponentValueUpdateRequestDto?: TariffComponentValueUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return TariffComponentValueApiFp(this.configuration).apiTariffcomponentvalueIdPut(id, apiVersion, tariffComponentValueUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TariffPackageApi - axios parameter creator
 */
export const TariffPackageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageAllGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tariffpackage/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffPackageDtoRowsRequestDto} [tariffPackageDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageAllPost: async (apiVersion?: string, tariffPackageDtoRowsRequestDto?: TariffPackageDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tariffpackage/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffPackageDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffPackageCreateRequestDto} [tariffPackageCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageCreatePost: async (apiVersion?: string, tariffPackageCreateRequestDto?: TariffPackageCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tariffpackage/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffPackageCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} componentId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageIdComponentsComponentIdDelete: async (id: number, componentId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTariffpackageIdComponentsComponentIdDelete', 'id', id)
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('apiTariffpackageIdComponentsComponentIdDelete', 'componentId', componentId)
            const localVarPath = `/api/tariffpackage/{id}/components/{componentId}`
                .replace('{id}', encodeURIComponent(String(id)))
                .replace('{componentId}', encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} componentId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageIdComponentsComponentIdPost: async (id: number, componentId: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTariffpackageIdComponentsComponentIdPost', 'id', id)
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('apiTariffpackageIdComponentsComponentIdPost', 'componentId', componentId)
            const localVarPath = `/api/tariffpackage/{id}/components/{componentId}`
                .replace('{id}', encodeURIComponent(String(id)))
                .replace('{componentId}', encodeURIComponent(String(componentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageIdDelete: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTariffpackageIdDelete', 'id', id)
            const localVarPath = `/api/tariffpackage/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageIdGet: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTariffpackageIdGet', 'id', id)
            const localVarPath = `/api/tariffpackage/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {TariffPackageUpdateRequestDto} [tariffPackageUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageIdPut: async (id: number, apiVersion?: string, tariffPackageUpdateRequestDto?: TariffPackageUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTariffpackageIdPut', 'id', id)
            const localVarPath = `/api/tariffpackage/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tariffPackageUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TariffPackageApi - functional programming interface
 */
export const TariffPackageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TariffPackageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffpackageAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TariffPackageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffpackageAllGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffPackageApi.apiTariffpackageAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffPackageDtoRowsRequestDto} [tariffPackageDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffpackageAllPost(apiVersion?: string, tariffPackageDtoRowsRequestDto?: TariffPackageDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TariffPackageDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffpackageAllPost(apiVersion, tariffPackageDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffPackageApi.apiTariffpackageAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffPackageCreateRequestDto} [tariffPackageCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffpackageCreatePost(apiVersion?: string, tariffPackageCreateRequestDto?: TariffPackageCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffpackageCreatePost(apiVersion, tariffPackageCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffPackageApi.apiTariffpackageCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} componentId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffpackageIdComponentsComponentIdDelete(id: number, componentId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffpackageIdComponentsComponentIdDelete(id, componentId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffPackageApi.apiTariffpackageIdComponentsComponentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} componentId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffpackageIdComponentsComponentIdPost(id: number, componentId: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffpackageIdComponentsComponentIdPost(id, componentId, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffPackageApi.apiTariffpackageIdComponentsComponentIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffpackageIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffpackageIdDelete(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffPackageApi.apiTariffpackageIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffpackageIdGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TariffPackageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffpackageIdGet(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffPackageApi.apiTariffpackageIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {TariffPackageUpdateRequestDto} [tariffPackageUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTariffpackageIdPut(id: number, apiVersion?: string, tariffPackageUpdateRequestDto?: TariffPackageUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTariffpackageIdPut(id, apiVersion, tariffPackageUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TariffPackageApi.apiTariffpackageIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TariffPackageApi - factory interface
 */
export const TariffPackageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TariffPackageApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TariffPackageDto>> {
            return localVarFp.apiTariffpackageAllGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffPackageDtoRowsRequestDto} [tariffPackageDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageAllPost(apiVersion?: string, tariffPackageDtoRowsRequestDto?: TariffPackageDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TariffPackageDtoRowsResponseDto> {
            return localVarFp.apiTariffpackageAllPost(apiVersion, tariffPackageDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {TariffPackageCreateRequestDto} [tariffPackageCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageCreatePost(apiVersion?: string, tariffPackageCreateRequestDto?: TariffPackageCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTariffpackageCreatePost(apiVersion, tariffPackageCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} componentId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageIdComponentsComponentIdDelete(id: number, componentId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTariffpackageIdComponentsComponentIdDelete(id, componentId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} componentId 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageIdComponentsComponentIdPost(id: number, componentId: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTariffpackageIdComponentsComponentIdPost(id, componentId, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTariffpackageIdDelete(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageIdGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<TariffPackageDto> {
            return localVarFp.apiTariffpackageIdGet(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {TariffPackageUpdateRequestDto} [tariffPackageUpdateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffpackageIdPut(id: number, apiVersion?: string, tariffPackageUpdateRequestDto?: TariffPackageUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTariffpackageIdPut(id, apiVersion, tariffPackageUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TariffPackageApi - object-oriented interface
 */
export class TariffPackageApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffpackageAllGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffPackageApiFp(this.configuration).apiTariffpackageAllGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {TariffPackageDtoRowsRequestDto} [tariffPackageDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffpackageAllPost(apiVersion?: string, tariffPackageDtoRowsRequestDto?: TariffPackageDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return TariffPackageApiFp(this.configuration).apiTariffpackageAllPost(apiVersion, tariffPackageDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {TariffPackageCreateRequestDto} [tariffPackageCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffpackageCreatePost(apiVersion?: string, tariffPackageCreateRequestDto?: TariffPackageCreateRequestDto, options?: RawAxiosRequestConfig) {
        return TariffPackageApiFp(this.configuration).apiTariffpackageCreatePost(apiVersion, tariffPackageCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} componentId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffpackageIdComponentsComponentIdDelete(id: number, componentId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffPackageApiFp(this.configuration).apiTariffpackageIdComponentsComponentIdDelete(id, componentId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} componentId 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffpackageIdComponentsComponentIdPost(id: number, componentId: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffPackageApiFp(this.configuration).apiTariffpackageIdComponentsComponentIdPost(id, componentId, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffpackageIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffPackageApiFp(this.configuration).apiTariffpackageIdDelete(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffpackageIdGet(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return TariffPackageApiFp(this.configuration).apiTariffpackageIdGet(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {TariffPackageUpdateRequestDto} [tariffPackageUpdateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTariffpackageIdPut(id: number, apiVersion?: string, tariffPackageUpdateRequestDto?: TariffPackageUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return TariffPackageApiFp(this.configuration).apiTariffpackageIdPut(id, apiVersion, tariffPackageUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAllGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {UserDtoRowsRequestDto} [userDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAllPost: async (apiVersion?: string, userDtoRowsRequestDto?: UserDtoRowsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDtoRowsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {UserCreateRequestDto} [userCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserCreatePost: async (apiVersion?: string, userCreateRequestDto?: UserCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [userIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserDeletePost: async (apiVersion?: string, userIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (userIds) {
                userIds.forEach((element) => {
                    localVarFormParams.append('userIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserInfoGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [userIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserLockPost: async (apiVersion?: string, userIds?: Set<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/lock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            if (userIds) {
                userIds.forEach((element) => {
                    localVarFormParams.append('userIds', element as any);
                })
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserLogoutPost: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserProfileGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserUpdatePost: async (apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(int32TableChangesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserAllGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {UserDtoRowsRequestDto} [userDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserAllPost(apiVersion?: string, userDtoRowsRequestDto?: UserDtoRowsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoRowsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserAllPost(apiVersion, userDtoRowsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {UserCreateRequestDto} [userCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserCreatePost(apiVersion?: string, userCreateRequestDto?: UserCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserCreatePost(apiVersion, userCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [userIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserDeletePost(apiVersion?: string, userIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserDeletePost(apiVersion, userIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserInfoGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserInfoGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [userIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserLockPost(apiVersion?: string, userIds?: Set<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserLockPost(apiVersion, userIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserLockPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserLogoutPost(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserLogoutPost(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserLogoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserProfileGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserProfileGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserProfileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserUpdatePost(apiVersion, int32TableChangesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserUpdatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAllGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserMinimalDto>> {
            return localVarFp.apiUserAllGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {UserDtoRowsRequestDto} [userDtoRowsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAllPost(apiVersion?: string, userDtoRowsRequestDto?: UserDtoRowsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UserDtoRowsResponseDto> {
            return localVarFp.apiUserAllPost(apiVersion, userDtoRowsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {UserCreateRequestDto} [userCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserCreatePost(apiVersion?: string, userCreateRequestDto?: UserCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiUserCreatePost(apiVersion, userCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [userIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserDeletePost(apiVersion?: string, userIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiUserDeletePost(apiVersion, userIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserInfoGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserInfoDto> {
            return localVarFp.apiUserInfoGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Set<number>} [userIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserLockPost(apiVersion?: string, userIds?: Set<number>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiUserLockPost(apiVersion, userIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserLogoutPost(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiUserLogoutPost(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserProfileGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserProfileDto> {
            return localVarFp.apiUserProfileGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiUserUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserAllGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserAllGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {UserDtoRowsRequestDto} [userDtoRowsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserAllPost(apiVersion?: string, userDtoRowsRequestDto?: UserDtoRowsRequestDto, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserAllPost(apiVersion, userDtoRowsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {UserCreateRequestDto} [userCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserCreatePost(apiVersion?: string, userCreateRequestDto?: UserCreateRequestDto, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserCreatePost(apiVersion, userCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [userIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserDeletePost(apiVersion?: string, userIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserDeletePost(apiVersion, userIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserInfoGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserInfoGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Set<number>} [userIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserLockPost(apiVersion?: string, userIds?: Set<number>, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserLockPost(apiVersion, userIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserLogoutPost(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserLogoutPost(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserProfileGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserProfileGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {Array<Int32TableChangesDto>} [int32TableChangesDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserUpdatePost(apiVersion?: string, int32TableChangesDto?: Array<Int32TableChangesDto>, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserUpdatePost(apiVersion, int32TableChangesDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserNotificationApi - axios parameter creator
 */
export const UserNotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {UserNotificationCreateRequestDto} [userNotificationCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationCreatePost: async (apiVersion?: string, userNotificationCreateRequestDto?: UserNotificationCreateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userNotificationCreateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [isRead] 
         * @param {boolean} [isDismissed] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationGet: async (isRead?: boolean, isDismissed?: boolean, limit?: number, offset?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isRead !== undefined) {
                localVarQueryParameter['isRead'] = isRead;
            }

            if (isDismissed !== undefined) {
                localVarQueryParameter['isDismissed'] = isDismissed;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationIdDelete: async (id: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiNotificationIdDelete', 'id', id)
            const localVarPath = `/api/notification/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {NotificationMarkAsDismissedRequestDto} [notificationMarkAsDismissedRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationMarkDismissedPost: async (apiVersion?: string, notificationMarkAsDismissedRequestDto?: NotificationMarkAsDismissedRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification/mark-dismissed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationMarkAsDismissedRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {NotificationMarkAsReadRequestDto} [notificationMarkAsReadRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationMarkReadPost: async (apiVersion?: string, notificationMarkAsReadRequestDto?: NotificationMarkAsReadRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification/mark-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationMarkAsReadRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPendingGet: async (limit?: number, offset?: number, apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationSummaryGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserNotificationApi - functional programming interface
 */
export const UserNotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserNotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {UserNotificationCreateRequestDto} [userNotificationCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationCreatePost(apiVersion?: string, userNotificationCreateRequestDto?: UserNotificationCreateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationCreatePost(apiVersion, userNotificationCreateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationApi.apiNotificationCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [isRead] 
         * @param {boolean} [isDismissed] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationGet(isRead?: boolean, isDismissed?: boolean, limit?: number, offset?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationGet(isRead, isDismissed, limit, offset, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationApi.apiNotificationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationIdDelete(id, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationApi.apiNotificationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {NotificationMarkAsDismissedRequestDto} [notificationMarkAsDismissedRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationMarkDismissedPost(apiVersion?: string, notificationMarkAsDismissedRequestDto?: NotificationMarkAsDismissedRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationMarkDismissedPost(apiVersion, notificationMarkAsDismissedRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationApi.apiNotificationMarkDismissedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {NotificationMarkAsReadRequestDto} [notificationMarkAsReadRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationMarkReadPost(apiVersion?: string, notificationMarkAsReadRequestDto?: NotificationMarkAsReadRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationMarkReadPost(apiVersion, notificationMarkAsReadRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationApi.apiNotificationMarkReadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationPendingGet(limit?: number, offset?: number, apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationPendingGet(limit, offset, apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationApi.apiNotificationPendingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationSummaryGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationSummaryGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationApi.apiNotificationSummaryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserNotificationApi - factory interface
 */
export const UserNotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserNotificationApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {UserNotificationCreateRequestDto} [userNotificationCreateRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationCreatePost(apiVersion?: string, userNotificationCreateRequestDto?: UserNotificationCreateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiNotificationCreatePost(apiVersion, userNotificationCreateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [isRead] 
         * @param {boolean} [isDismissed] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationGet(isRead?: boolean, isDismissed?: boolean, limit?: number, offset?: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationDto>> {
            return localVarFp.apiNotificationGet(isRead, isDismissed, limit, offset, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiNotificationIdDelete(id, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {NotificationMarkAsDismissedRequestDto} [notificationMarkAsDismissedRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationMarkDismissedPost(apiVersion?: string, notificationMarkAsDismissedRequestDto?: NotificationMarkAsDismissedRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiNotificationMarkDismissedPost(apiVersion, notificationMarkAsDismissedRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {NotificationMarkAsReadRequestDto} [notificationMarkAsReadRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationMarkReadPost(apiVersion?: string, notificationMarkAsReadRequestDto?: NotificationMarkAsReadRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiNotificationMarkReadPost(apiVersion, notificationMarkAsReadRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationPendingGet(limit?: number, offset?: number, apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationDto>> {
            return localVarFp.apiNotificationPendingGet(limit, offset, apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationSummaryGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserNotificationSummaryDto> {
            return localVarFp.apiNotificationSummaryGet(apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserNotificationApi - object-oriented interface
 */
export class UserNotificationApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {UserNotificationCreateRequestDto} [userNotificationCreateRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationCreatePost(apiVersion?: string, userNotificationCreateRequestDto?: UserNotificationCreateRequestDto, options?: RawAxiosRequestConfig) {
        return UserNotificationApiFp(this.configuration).apiNotificationCreatePost(apiVersion, userNotificationCreateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [isRead] 
     * @param {boolean} [isDismissed] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationGet(isRead?: boolean, isDismissed?: boolean, limit?: number, offset?: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return UserNotificationApiFp(this.configuration).apiNotificationGet(isRead, isDismissed, limit, offset, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationIdDelete(id: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return UserNotificationApiFp(this.configuration).apiNotificationIdDelete(id, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {NotificationMarkAsDismissedRequestDto} [notificationMarkAsDismissedRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationMarkDismissedPost(apiVersion?: string, notificationMarkAsDismissedRequestDto?: NotificationMarkAsDismissedRequestDto, options?: RawAxiosRequestConfig) {
        return UserNotificationApiFp(this.configuration).apiNotificationMarkDismissedPost(apiVersion, notificationMarkAsDismissedRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {NotificationMarkAsReadRequestDto} [notificationMarkAsReadRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationMarkReadPost(apiVersion?: string, notificationMarkAsReadRequestDto?: NotificationMarkAsReadRequestDto, options?: RawAxiosRequestConfig) {
        return UserNotificationApiFp(this.configuration).apiNotificationMarkReadPost(apiVersion, notificationMarkAsReadRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationPendingGet(limit?: number, offset?: number, apiVersion?: string, options?: RawAxiosRequestConfig) {
        return UserNotificationApiFp(this.configuration).apiNotificationPendingGet(limit, offset, apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationSummaryGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return UserNotificationApiFp(this.configuration).apiNotificationSummaryGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VersionApi - axios parameter creator
 */
export const VersionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionTaggedGet: async (apiVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/version/tagged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apiVersion !== undefined) {
                localVarQueryParameter['api-version'] = apiVersion;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VersionApi - functional programming interface
 */
export const VersionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VersionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVersionGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VersionApi.apiVersionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVersionTaggedGet(apiVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVersionTaggedGet(apiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VersionApi.apiVersionTaggedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VersionApi - factory interface
 */
export const VersionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VersionApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiVersionGet(apiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [apiVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVersionTaggedGet(apiVersion?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiVersionTaggedGet(apiVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VersionApi - object-oriented interface
 */
export class VersionApi extends BaseAPI {
    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVersionGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return VersionApiFp(this.configuration).apiVersionGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [apiVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiVersionTaggedGet(apiVersion?: string, options?: RawAxiosRequestConfig) {
        return VersionApiFp(this.configuration).apiVersionTaggedGet(apiVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



